import cloneDeep from 'clone-deep';
import Url from 'url-parse';
import { Highlighter } from '@bukio/highlighter';
import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Optional, Inject, EventEmitter, Component, Output, Input, HostBinding, ChangeDetectionStrategy, ViewChild, ViewChildren, Pipe, NgModule } from '@angular/core';
import { Subject, BehaviorSubject, fromEvent, of, throwError, Observable, interval, asyncScheduler, from, merge, zip } from 'rxjs';
import { filter, map, pairwise, takeUntil, tap, startWith, skipWhile, take, timeout, catchError, timestamp, debounceTime, switchMap, scan, takeLast, throttleTime, observeOn, shareReplay, finalize } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import Hammer from 'hammerjs';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import FontFaceObserver from 'fontfaceobserver';
import Pica from 'pica';
import * as i1$1 from '@angular/platform-browser';

const WIKI_BIDS = [
    'en',
    'sv',
    'nl',
    'de',
    'fr',
    'war',
    'ru',
    'ceb',
    'it',
    'es',
    'vi',
    'pl',
    'ja',
    'pt',
    'zh',
    'uk',
    'ca',
    'fa',
    'no',
    'sh',
    'fi',
    'id',
    'ar',
    'cs',
    'sr',
    'ko',
    'ro',
    'hu',
    'ms',
    'tr',
    'min',
    'eo',
    'kk',
    'eu',
    'sk',
    'da',
    'bg',
    'lt',
    'he',
    'hy',
    'hr',
    'sl',
    'et',
    'uz',
    'gl',
    'nn',
    'vo',
    'la',
    'simple',
    'el',
    'hi',
    'az',
    'th',
    'ka',
    'oc',
    'be',
    'ce',
    'mk',
    'mg',
    'new',
    'ur',
    'tt',
    'ta',
    'pms',
    'cy',
    'tl',
    'lv',
    'te',
    'bs',
    'be-x-old',
    'br',
    'ht',
    'sq',
    'jv',
    'lb',
    'mr',
    'is',
    'ml',
    'zh-yue',
    'bn',
    'af',
    'ba',
    'ga',
    'pnb',
    'lmo',
    'fy',
    'tg',
    'yo',
    'cv',
    'my',
    'an',
    'sco',
    'sw',
    'ky',
    'io',
    'ne',
    'gu',
    'scn',
    'bpy',
    'nds',
    'ku',
    'ast',
    'qu',
    'als',
    'su',
    'kn',
    'pa',
    'ckb',
    'ia',
    'nap',
    'mn',
    'bug',
    'bat-smg',
    'arz',
    'wa',
    'zh-min-nan',
    'am',
    'map-bms',
    'gd',
    'yi',
    'mzn',
    'si',
    'fo',
    'bar',
    'vec',
    'nah',
    'sah',
    'os',
    'sa',
    'roa-tara',
    'li',
    'hsb',
    'or',
    'pam',
    'mhr',
    'se',
    'mi',
    'mrj',
    'ilo',
    'hif',
    'bcl',
    'gan',
    'rue',
    'glk',
    'bo',
    'nds-nl',
    'vls',
    'ps',
    'diq',
    'fiu-vro',
    'bh',
    'xmf',
    'tk',
    'gv',
    'co',
    'sc',
    'csb',
    'hak',
    'km',
    'kv',
    'zea',
    'vep',
    'crh',
    'zh-classical',
    'frr',
    'eml',
    'ay',
    'stq',
    'nrm',
    'kw',
    'wuu',
    'rm',
    'udm',
    'szl',
    'so',
    'koi',
    'as',
    'lad',
    'mt',
    'fur',
    'dv',
    'gn',
    'dsb',
    'pcd',
    'ie',
    'cbk-zam',
    'lij',
    'ksh',
    'ext',
    'mwl',
    'gag',
    'ang',
    'cdo',
    'ug',
    'ace',
    'pi',
    'pag',
    'nv',
    'frp',
    'sn',
    'kab',
    'lez',
    'ln',
    'pfl',
    'krc',
    'haw',
    'myv',
    'xal',
    'sd',
    'rw',
    'kaa',
    'pdc',
    'to',
    'kl',
    'arc',
    'nov',
    'kbd',
    'av',
    'lo',
    'bjn',
    'ha',
    'bxr',
    'tpi',
    'na',
    'pap',
    'lbe',
    'jbo',
    'ty',
    'mdf',
    'wo',
    'roa-rup',
    'ig',
    'tyv',
    'srn',
    'nso',
    'kg',
    'tet',
    'ab',
    'ltg',
    'zu',
    'om',
    'chy',
    'za',
    'cu',
    'rmy',
    'tw',
    'tn',
    'chr',
    'pih',
    'got',
    'mai',
    'bi',
    'xh',
    'sm',
    'ss',
    'mo',
    'ki',
    'rn',
    'pnt',
    'bm',
    'iu',
    'ee',
    'lg',
    'ts',
    'ak',
    'fj',
    'ik',
    'sg',
    'st',
    'ff',
    'dz',
    'ny',
    'ch',
    'ti',
    've',
    'ks',
    'tum',
    'cr',
    'ng',
    'cho',
    'kj',
    'mh',
    'ho',
    'ii',
    'aa',
    'mus',
    'hz',
    'kr',
];

var PagingMode;
(function (PagingMode) {
    PagingMode["Page"] = "page";
    PagingMode["Scroll"] = "scroll";
})(PagingMode || (PagingMode = {}));

var Theme;
(function (Theme) {
    Theme["Light"] = "light";
    Theme["Dark"] = "dark";
    Theme["Sepia"] = "sepia";
})(Theme || (Theme = {}));

const DEFAULT_SETTING_VALUES = {
    theme: Theme.Light,
    fontFace: 'default',
    fontSize: 100,
    lineHeight: 100,
    pagingMode: PagingMode.Page,
    multiColumn: false,
    pageAnimation: true,
    clickToPlayMediaOverlay: false,
};
const DEFAULT_ANCHOR_HIGHLIGHT_COLOR = 'rgb(78, 121, 188, 0.3)';

function cloneObj(obj) {
    return cloneDeep(obj);
}
function pixelStrToNumber(pixelStr) {
    return parseInt(pixelStr.substring(0, pixelStr.length - 2));
}
function findItemToDirection(array, direction, predicate, baseIndex) {
    if (baseIndex == null) {
        baseIndex = direction === 1 ? -1 : array.length;
    }
    let i = baseIndex + direction;
    while (i >= 0 && i < array.length) {
        if (predicate(array[i], i)) {
            return array[i];
        }
        i += direction;
    }
    return;
}
function isShallowEqual(object1 = {}, object2 = {}) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        if (object1[key] !== object2[key]) {
            return false;
        }
    }
    return true;
}

function createBukURL(bid, iid, anchor, query) {
    if (!bid) {
        throw new Error('cannot create url, bid required');
    }
    bid = bid.replace(/^@/, '');
    // bid
    let url = '/';
    if (!isIPAddressBid(bid)) {
        url += '@';
    }
    url += bid;
    // iid
    if (isDocumentBid(bid)) {
        if (anchor) {
            url += `/${anchor}`;
        }
    }
    else {
        if (iid != null) {
            url += `/${encodeURIComponent(iid)}`;
            if (anchor) {
                url += `/${anchor}`;
            }
        }
    }
    if (query && Object.keys(query).length > 0) {
        url += '?' + Url.qs.stringify(query);
    }
    return url;
}
function isIPAddressBid(bid) {
    return /(100\.\d{1,3}\.\d{1,3}.\d{1,3})/.test(bid);
}
function isDocumentBid(bid) {
    return /^([a-zA-Z]{3}\d{4})|(100\.\d{1,3}\.\d{1,3}.\d{1,3})$/.test(bid);
}
function isWikiBid(bid) {
    bid = bid.split('_')[0];
    return WIKI_BIDS.includes(bid);
}
function isWiktionaryBid(bid) {
    return bid.split('_')[1] === 'wiktionary' && isWikiBid(bid);
}
function isBukAnchor(anchor) {
    const match = /^(\d+)-(\d+)$/.exec(anchor);
    if (!match) {
        return false;
    }
    const start = parseInt(match[1]);
    const end = parseInt(match[2]);
    return start <= end;
}
function isSameAddress(addr1, addr2, ignoreQuery = true) {
    const result = addr1.bid === addr2.bid &&
        addr1.iid === addr2.iid &&
        addr1.anchor === addr2.anchor;
    return result && (ignoreQuery || isShallowEqual(addr1.query, addr2.query));
}
function getLanguages(addr) {
    const langs = decodeURIComponent(addr.query?.l ?? '');
    return langs.split(/\s*,\s*/);
}
function getAnchorHighlightColorFromQuery(query) {
    if (!query?.highlight) {
        return null;
    }
    if (query.highlight === 'true') {
        return DEFAULT_ANCHOR_HIGHLIGHT_COLOR;
    }
    if (/^[0-9a-f]{3,8}$/i.test(query.highlight)) {
        return `#${query.highlight}`;
    }
    return query.highlight;
}

class Address {
    constructor(bid, iid, anchor, query) {
        this.bid = bid;
        this.iid = iid;
        this.anchor = anchor;
        this.query = query;
        if (this.iid) {
            try {
                this.iid = decodeURIComponent(this.iid);
            }
            catch (error) {
                console.warn(error, this);
            }
        }
        if (this.query) {
            this.query = cloneDeep(this.query);
        }
    }
    get page() {
        return typeof this.anchor === 'number' ? this.anchor : undefined;
    }
    get range() {
        return typeof this.anchor === 'string' && isBukAnchor(this.anchor)
            ? this.anchor
            : undefined;
    }
    get fragment() {
        return typeof this.anchor === 'string' && !this.range
            ? this.anchor
            : undefined;
    }
    clone() {
        return new Address(this.bid, this.iid, this.anchor, this.query);
    }
    toString() {
        return createBukURL(this.bid, this.iid, this.anchor, this.query);
    }
}

var Direction;
(function (Direction) {
    Direction[Direction["Prev"] = -1] = "Prev";
    Direction[Direction["Next"] = 1] = "Next";
})(Direction || (Direction = {}));

function removeTrailingSlash(str) {
    return str.replace(/\/$/, '');
}
function parseBukURL(url) {
    const _url = new Url(url.replace(/^\//, ''), '/', true);
    const paths = _url.pathname.split('/');
    const bid = paths[0].replace(/^@/, '');
    let iid;
    let anchor;
    if (isDocumentBid(bid)) {
        anchor = paths[1];
    }
    else {
        iid = paths[1];
        anchor = paths[2];
    }
    if (/0\.\d+/.test(anchor)) {
        anchor = parseFloat(anchor);
    }
    return new Address(bid, iid, anchor, _url.query);
}
function isValidURL(url) {
    try {
        new URL(url);
        return true;
    }
    catch {
        return false;
    }
}

const IS_IE = !!navigator.userAgent.match(/Trident.*rv\:11\./);
const IS_IOS = !!navigator.userAgent.match(/iP(ad|hone|od)/i) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
const IS_WEBKIT = !!navigator.userAgent.match(/WebKit/i);
const IS_MOBILE_SAFARI = IS_IOS && IS_WEBKIT && !navigator.userAgent.match(/CriOS/i);
const IOS_VERSION = (() => {
    if (!IS_MOBILE_SAFARI) {
        return null;
    }
    const osVersionMatch = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    if (osVersionMatch) {
        return parseInt(osVersionMatch[1], 10);
    }
    const browserVersionMatch = navigator.appVersion.match(/Version\/(\d+)\.(\d+)(?:\.(\d+))?/);
    if (browserVersionMatch) {
        return parseInt(browserVersionMatch[1], 10);
    }
    return null;
})();
const IS_HIGH_DENSITY = (window.matchMedia &&
    (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches ||
        window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches)) ||
    (window.devicePixelRatio && window.devicePixelRatio > 1.3);
const IS_TOUCH_DEVICE = matchMedia('(pointer: coarse)').matches;
const SUPPORT_FONT_FACE_SET = !IS_IE;
const CAN_CREATE_RANGE_FROM_AREA = !IS_IE;
const SCROLL_FREEZE = IS_MOBILE_SAFARI;
const NOT_SCROLLABLE_IFRAME = IOS_VERSION && IOS_VERSION <= 12;
const HORIZONTAL_SCROLL_FREEZE_WITH_ZOOM = IS_TOUCH_DEVICE && !IS_IOS;
const SUPPORT_VISUAL_VIEWPORT = window.hasOwnProperty('visualViewport');
const MO_NOT_WORKING_ON_CAN_PLAY = IOS_VERSION && IOS_VERSION <= 13;
const IMAGE_FLICKERING_WITH_ZOOM = IS_MOBILE_SAFARI;
const LOW_DOWNSCALED_IMAGE_QUALITY = window.chrome && !IS_HIGH_DENSITY;

const BASE_BUK_URL_ATTR = 'data-bukv-base-buk-url';
const SMIL_TEXT_ITEM_ATTR = 'data-bukv-mo-text';
const CLICKABLE_FLAG_ATTR = 'data-bukv-click-handled';
const FONT_FACE_SETTING_ATTR = 'data-bukv-font-face';
const MULTI_COLUMN_SETTING_ATTR = 'data-bukv-multi-column';
const PAGE_LIST_ANCHOR_ATTR = 'data-bukv-pagelist-label';
const PAGE_FILLER_ID = 'bukv-page-filler';
const WIKI_URL_ATTR = 'data-bukv-wiki-link';
const LIB_CONFIG_STYLE_ID = 'bukv-lib-config-style';

function hasSize(element) {
    return (element.getBoundingClientRect().width *
        element.getBoundingClientRect().height >
        0);
}
function getStyle(target, property) {
    return target.ownerDocument?.defaultView
        ?.getComputedStyle(target)
        .getPropertyValue(property);
}
function findNodeFrom(startNode, predicate, maxParentLevel = 100000) {
    let result = null;
    let _currentNode = startNode;
    for (let i = 0; i <= maxParentLevel; i++) {
        if (!_currentNode) {
            break;
        }
        if (predicate(_currentNode)) {
            result = _currentNode;
            break;
        }
        _currentNode = _currentNode.parentElement;
    }
    return result;
}
function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (rect.left >= 0 &&
        rect.left < element.ownerDocument.defaultView.innerWidth &&
        rect.top >= 0 &&
        rect.top < element.ownerDocument.defaultView.innerHeight);
}
function isNode(arg) {
    return arg && 'nodeType' in arg;
}
function isElement(arg) {
    return arg && isNode(arg) && arg.nodeType === Node.ELEMENT_NODE;
}
const CLICKABLE_ELEMENTS = ['A', 'INPUT', 'AUDIO', 'VIDEO', 'SELECT', 'BUTTON'];
function isClickableElement(node) {
    if (!isElement(node)) {
        return false;
    }
    if (node.hasAttribute?.(CLICKABLE_FLAG_ATTR)) {
        return true;
    }
    if (node.getAttribute('onclick')) {
        return true;
    }
    if (CLICKABLE_ELEMENTS.indexOf(node.tagName) !== -1) {
        return true;
    }
    return false;
}
function getRectFromDOMRect(domRect) {
    const { left, top, width, height } = domRect;
    return { x: left, y: top, width, height };
}
function findElementFromRange(range, finder) {
    const doc = range.startContainer.ownerDocument ?? range.startContainer;
    const iterator = doc.createTreeWalker(range.commonAncestorContainer);
    iterator.currentNode = range.startContainer;
    let found = null;
    const iterate = (iterationCount = 0) => {
        if (iterationCount > 30) {
            console.warn('max iteration count exceeded');
            return;
        }
        if (iterator.currentNode.nodeType === Node.TEXT_NODE &&
            iterator.currentNode.parentElement &&
            iterator.currentNode.textContent?.trim().length) {
            found = finder(iterator.currentNode.parentElement);
            if (found) {
                return;
            }
        }
        if (iterator.currentNode !== range.endContainer && iterator.nextNode()) {
            iterate(iterationCount++);
        }
    };
    iterate();
    return found;
}
/**
 * 모바일에서 페이지 확대하는 경우 그 스케일을 가져옴
 * @returns 스케일
 */
function getWindowScale() {
    return document.documentElement.offsetWidth / window.innerWidth;
}
function isWindowZoomed() {
    return (SUPPORT_VISUAL_VIEWPORT &&
        window.innerWidth !== Math.round(visualViewport.width));
}
function getLocationInElement(target, clientLocation) {
    const targetBoundingRect = target.getBoundingClientRect();
    return {
        x: clientLocation.x - targetBoundingRect.left,
        y: clientLocation.y - targetBoundingRect.top,
    };
}
function preventBrowserPinchZoom(doc) {
    doc.addEventListener('touchmove', (event) => {
        if (event.touches.length > 1) {
            event.preventDefault();
        }
    }, { passive: false });
}
function isPointInRect(point, rect) {
    return (rect.top < point.y &&
        rect.bottom > point.y &&
        rect.left < point.x &&
        rect.right > point.x);
}

const highlighter$1 = new Highlighter({
    EXCLUDE_ELEMENT_FILTER: isEpubGarbageElement,
});
function isEpubGarbageElement(element) {
    return /\d[\w\d]{2}\w$/.test(element.tagName);
}
function isSelectionStringEmpty(selection) {
    return selection.toString().trim().length === 0;
}
function getSelectionDocument(selection) {
    if (!selection.anchorNode) {
        return null;
    }
    return selection.anchorNode.ownerDocument === selection.anchorNode
        ? selection.anchorNode
        : selection.anchorNode.ownerDocument;
}
function mergeAddress(addresses) {
    let mergedStart;
    let mergedEnd;
    addresses.forEach((address) => {
        const [start, end] = address.split('-').map((n) => parseInt(n));
        if (mergedStart == null || mergedStart > start) {
            mergedStart = start;
        }
        if (mergedEnd == null || mergedEnd < end) {
            mergedEnd = end;
        }
    });
    return `${mergedStart}-${mergedEnd}`;
}
function isParentSelection(child, parent) {
    return (parent.startOffset <= child.startOffset &&
        parent.endOffset >= child.endOffset);
}
function getParentSelections(currentSelection, relatedSelections) {
    return relatedSelections.filter((selection) => isParentSelection(currentSelection, selection));
}
function getLargestParentSelection(currentSelection, relatedSelections) {
    let parentInfo;
    /* 가장 범위가 큰 부모 하이라이트 찾음 */
    getParentSelections(currentSelection, relatedSelections).forEach((selection) => {
        const offsetDiff = currentSelection.startOffset -
            selection.startOffset +
            selection.endOffset -
            currentSelection.endOffset;
        if (!parentInfo || parentInfo.offsetDiff < offsetDiff) {
            // 더 큰 범위인지
            parentInfo = {
                selection,
                offsetDiff,
            };
        }
    });
    return parentInfo ? parentInfo.selection : null;
}
function isSelection(arg) {
    return arg && 'getRangeAt' in arg;
}
function createRangeFromArea(doc, start, end) {
    // Firefox
    if (typeof doc.caretPositionFromPoint != 'undefined') {
        const startPosition = doc.caretPositionFromPoint(start.x, start.y);
        const endPosition = doc.caretPositionFromPoint(end.x, end.y);
        if (!startPosition || !endPosition) {
            return null;
        }
        try {
            const range = doc.createRange();
            range.setStart(startPosition.offsetNode, startPosition.offset);
            range.setEnd(endPosition.offsetNode, endPosition.offset);
            return range;
        }
        catch (error) {
            console.log(error);
            return null;
        }
    }
    // Chrome, Safari, Edge
    if (typeof doc.caretRangeFromPoint != 'undefined') {
        const startRange = doc.caretRangeFromPoint(start.x, start.y);
        const endRange = doc.caretRangeFromPoint(end.x, end.y);
        if (!startRange || !endRange) {
            return null;
        }
        try {
            const range = doc.createRange();
            range.setStart(startRange.startContainer, startRange.startOffset);
            range.setEnd(endRange.startContainer, endRange.startOffset);
            return range;
        }
        catch (error) {
            console.log(error);
            return null;
        }
    }
    return null;
}
function createRangeFromNodeAndPoint(node, point) {
    if (node.nodeType === Node.TEXT_NODE) {
        const textNode = node;
        const range = textNode.ownerDocument.createRange();
        range.selectNodeContents(textNode);
        let currentPos = 0;
        const endPos = range.endOffset;
        while (currentPos + 1 < endPos) {
            range.setStart(textNode, currentPos);
            range.setEnd(textNode, currentPos + 1);
            if (range.getBoundingClientRect().left >= 0 &&
                range.toString().trim().length) {
                range.setEnd(textNode, textNode.length);
                return range;
            }
            currentPos += 1;
        }
    }
    else {
        for (let i = 0; i < node.childNodes.length; i++) {
            const range = node.childNodes[i].ownerDocument.createRange();
            range.selectNodeContents(node.childNodes[i]);
            if (range.getBoundingClientRect().left <= point.x &&
                range.getBoundingClientRect().right >= point.x &&
                range.getBoundingClientRect().top <= point.y &&
                range.getBoundingClientRect().bottom >= point.y) {
                range.detach();
                return createRangeFromNodeAndPoint(node.childNodes[i], point);
            }
            else {
                range.detach();
            }
        }
    }
    return null;
}
const VERTICAL_STEP = 20;
const HORIZONTAL_STEP = 20;
function getFirstVisibleSelection(doc) {
    let viewportWidth = doc.defaultView.innerWidth;
    const viewportHeight = doc.defaultView.innerWidth;
    if (doc.documentElement.getAttribute(MULTI_COLUMN_SETTING_ATTR) === 'true') {
        viewportWidth = Math.floor(viewportWidth / 2);
    }
    let startX = 2;
    let startY = 5;
    if (NOT_SCROLLABLE_IFRAME && doc.defaultView?.frameElement?.parentElement) {
        startY += doc.defaultView.frameElement.parentElement.scrollTop;
    }
    [doc.documentElement, doc.body].forEach((elem) => {
        const paddingLeft = pixelStrToNumber(getStyle(elem, 'padding-left'));
        if (!isNaN(paddingLeft)) {
            startX += paddingLeft;
        }
        const paddingTop = pixelStrToNumber(getStyle(elem, 'padding-top'));
        if (!isNaN(paddingTop)) {
            startY += paddingTop;
        }
    });
    const endX = viewportWidth - startX; // 좌우 패딩이 같다고 가정
    const endY = viewportHeight - startY; // 상하 패딩이 같다고 가정
    let h = startY;
    let sel;
    if (CAN_CREATE_RANGE_FROM_AREA) {
        while (h < endY) {
            h += VERTICAL_STEP;
            const range = createRangeFromArea(doc, { x: startX, y: startY }, { x: endX, y: h });
            if (!range || range.collapsed) {
                continue;
            }
            sel = highlighter$1.getSelectionFromRange(doc, range);
            if (sel.text.trim().length > 0) {
                break;
            }
            else {
                sel = null;
            }
            // h += VERTICAL_STEP;
        }
    }
    else {
        let target;
        let preserved;
        let w = 0;
        outer: while (h < endY) {
            w = startX;
            while (w < endX) {
                //console.log('search: (' + w + ', ' + h + ')');
                const elem = doc.elementFromPoint(w, h);
                if (elem && elem.tagName !== 'HTML' && elem.tagName !== 'BODY') {
                    if (!preserved) {
                        preserved = elem;
                    }
                    if (elem.textContent?.trim().length) {
                        target = elem;
                        break outer;
                    }
                }
                w += HORIZONTAL_STEP;
            }
            h += VERTICAL_STEP;
        }
        if (target) {
            // console.log('text target at (' + w + ', ' + h + ')');
            const hMax = h + 300;
            const wMax = w + 300;
            const wInitial = w;
            let range;
            outer: while (h < hMax) {
                w = wInitial;
                while (w < wMax) {
                    range = createRangeFromNodeAndPoint(target, { x: w, y: h });
                    if (range) {
                        break outer;
                    }
                    w += HORIZONTAL_STEP;
                }
                h += VERTICAL_STEP;
            }
            if (range) {
                sel = highlighter$1.getSelectionFromRange(doc, range);
            }
            else {
                // console.log('cannot create range');
            }
        } /*else if (preserved) {
          console.log(preserved);
          sel = highlighter.getSelectionFromElement(doc, preserved);
        }*/
        else {
            // console.log('bookmark error');
        }
    }
    return sel ?? null;
}
function createAnnotation(baseURL, type, selection, styleClass) {
    const address = parseBukURL(baseURL);
    address.anchor = selection.address;
    return {
        type,
        url: address.toString(),
        text: selection.text,
        styleClass: styleClass ?? null,
    };
}
function createHighlightId(range, styleClass) {
    return `${range}.${styleClass}`;
}

const highlighter = new Highlighter({
    EXCLUDE_ELEMENT_FILTER: isEpubGarbageElement,
});
function getISO639CodeFromBookLanguage(language) {
    if (!language) {
        return undefined;
    }
    return language.split('-')[0];
}
function getFontsForBook(book, fontConfig) {
    let bookLanguage;
    if (book.meta.type === 'wiki') {
        bookLanguage = book.meta.bid;
    }
    else {
        bookLanguage = getISO639CodeFromBookLanguage(book.meta.languages[0]);
    }
    if (bookLanguage) {
        return fontConfig[bookLanguage]?.fontFamilies ?? [];
    }
    return [];
}
const ITEM_POSITION_MULTIPLIER = 10000000;
function calculateBukURLPositionInBook(book, url) {
    const address = parseBukURL(url);
    if (!address.iid) {
        throw new Error('faild to calculate highlight position');
    }
    const itemIndex = book.getItemIndex(address.iid);
    const startOffset = (address.range && highlighter.parseAddress(address.range).startOffset) ?? 0;
    return itemIndex * ITEM_POSITION_MULTIPLIER + startOffset;
}
function calculateNextItem(book, currentIid, direction, isMultiColumn) {
    if (!isMultiColumn) {
        return direction === Direction.Prev
            ? book.getPrevItem(currentIid)
            : book.getNextItem(currentIid);
    }
    const currentSpreadItems = book.getSpreadItems(currentIid);
    const currentItems = [
        currentSpreadItems.left,
        currentSpreadItems.right,
    ].filter((item) => !!item);
    const nextItem = direction === Direction.Prev
        ? book.getPrevItem(currentItems[0].iid)
        : book.getNextItem(currentItems[currentItems.length - 1].iid);
    if (!nextItem) {
        return undefined;
    }
    const nextSpreadItems = book.getSpreadItems(nextItem.iid);
    const nextItems = [nextSpreadItems.left, nextSpreadItems.right].filter((item) => !!item);
    return nextItems[nextItems.length - 1];
}
function calculateAddressItems(book, address, isMultiColumn) {
    const addressItem = address.iid ? book.getItem(address.iid) : book.items[0];
    if (!addressItem) {
        return [];
    }
    if (isMultiColumn) {
        const spreadItems = book.getSpreadItems(addressItem.iid);
        return [spreadItems.right, spreadItems.left].filter((item) => !!item);
    }
    return [addressItem];
}
function isBookReflowableAndFixedLayout(book) {
    const reflowableItem = book.items.find((item) => item.layout !== 'fixed');
    const fixedLayoutItem = book.items.find((item) => item.layout === 'fixed');
    return !!reflowableItem && !!fixedLayoutItem;
}

var BookType;
(function (BookType) {
    BookType["Buk"] = "buk";
    BookType["PDF"] = "pdf";
    BookType["Document"] = "document";
    BookType["Wiki"] = "wiki";
    BookType["Edition"] = "edition";
})(BookType || (BookType = {}));
class Book {
    constructor(book) {
        this._rawBook = cloneObj(book);
        book.items.forEach((item) => Object.freeze(item));
        this.items = book.items;
        this.meta = book.meta;
        this.toc = book.toc;
        this.page_list = book.page_list;
        this._isHorizontalFixedLayout =
            this.meta.layout === 'fixed' &&
                this.items.some((i, index) => {
                    return index > 0 && i.fixedWidth > i.fixedHeight * 1.1;
                });
        this._isMediaOverlayContent = this.items.some((item) => item.smil);
        this._totalPrintPageCount =
            this.page_list.length > 0
                ? Math.max(...this.page_list.map((plItem) => plItem.page))
                : undefined;
    }
    getItem(iid) {
        return this.items.find((item) => item.iid === iid);
    }
    getItemIndex(iid) {
        return this.items.findIndex((item) => item.iid === iid);
    }
    getNextItem(baseIid) {
        return this.items[this.getItemIndex(baseIid) + 1];
    }
    getPrevItem(baseIid) {
        return this.items[this.getItemIndex(baseIid) - 1];
    }
    getSpreadItems(baseIid) {
        const baseItem = this.getItem(baseIid);
        if (!baseItem) {
            throw new Error();
        }
        if (!baseItem.pageSpread) {
            return { right: baseItem };
        }
        const result = {};
        result[baseItem.pageSpread] = baseItem;
        const willBePairItem = baseItem.pageSpread === 'left'
            ? this.getNextItem(baseIid)
            : this.getPrevItem(baseIid);
        const pairItemPageSpread = baseItem.pageSpread === 'left' ? 'right' : 'left';
        if (willBePairItem &&
            willBePairItem.url &&
            willBePairItem.pageSpread === pairItemPageSpread) {
            result[pairItemPageSpread] = willBePairItem;
        }
        return result;
    }
    getPositionOfURL(url) {
        return calculateBukURLPositionInBook(this, url);
    }
}

const SHARED_BOOKMARK_CLASS = 'bukh-shared-bookmark';
// 하이라이트 공유 -> permission 페이지 찾기에 사용
const SHARED_HIGHLIGHT_CLASS = 'bukh-shared';
// 공유 주소에 대한 위치 찾기에 사용
const ANCHOR_HIGHLIGHT_CLASS = 'bukh-anchor';
// 검색 키워드 하이라이팅에 사용
const KEYBOARD_HIGHLIGHT_CLASS = 'bukh-search';
// 사용자 북마크 위치 찾기에 사용
const BOOKMARK_HIGHLIGHT_CLASS = 'bukh-bookmark';
// 기타 용도
const TEMP_HIGHLIGHT_CLASS = 'bukh-temp';
const STARTING_HIGHLIGHT_CLASS = 'bukh-start';
const ENDING_HIGHLIGHT_CLASS = 'bukh-end';

var AnnotationType;
(function (AnnotationType) {
    AnnotationType["Bookmark"] = "bookmark";
    AnnotationType["Highlight"] = "highlight";
})(AnnotationType || (AnnotationType = {}));
class ParsedAnnotation {
    constructor(annotation) {
        this.type = annotation.type;
        this.url = annotation.url;
        this.text = annotation.text;
        this.styleClass = annotation.styleClass ?? BOOKMARK_HIGHLIGHT_CLASS;
        this.address = parseBukURL(annotation.url);
    }
    toAnnotation() {
        return {
            type: this.type,
            url: this.url,
            text: this.text,
            styleClass: this.type === AnnotationType.Bookmark ? null : this.styleClass,
        };
    }
}

var AddressChangeType;
(function (AddressChangeType) {
    AddressChangeType[AddressChangeType["Book"] = 0] = "Book";
    AddressChangeType[AddressChangeType["Item"] = 1] = "Item";
    AddressChangeType[AddressChangeType["Page"] = 2] = "Page";
    AddressChangeType[AddressChangeType["Query"] = 3] = "Query";
    AddressChangeType[AddressChangeType["None"] = 4] = "None";
})(AddressChangeType || (AddressChangeType = {}));
function getAddressChangeType(newAddr, oldAddr) {
    if (!oldAddr || newAddr.bid !== oldAddr.bid || newAddr.query?.force) {
        return AddressChangeType.Book;
    }
    if (newAddr.iid !== oldAddr.iid) {
        return isWikiBid(newAddr.bid)
            ? AddressChangeType.Book
            : AddressChangeType.Item;
    }
    if (newAddr.anchor !== oldAddr.anchor) {
        return AddressChangeType.Page;
    }
    if (!isShallowEqual(newAddr.query, oldAddr.query)) {
        return isWikiBid(newAddr.bid) &&
            newAddr.query?.version !== oldAddr.query?.version
            ? AddressChangeType.Book
            : AddressChangeType.Query;
    }
    return AddressChangeType.None; // not changed
}

const LIB_CONFIG_INTERNAL_ENABLE_EPUB_OBFUSCATION = new InjectionToken('LIB_CONFIG_INTERNAL_ENABLE_EPUB_OBFUSCATION');
function normalizeSettings(settings) {
    return {
        ...DEFAULT_SETTING_VALUES,
        ...settings,
    };
}
function normalizeConfigInput(configInput) {
    const _config = { ...cloneObj(configInput) };
    _config.contentsBaseURL = removeTrailingSlash(_config.contentsBaseURL);
    if ('bukJSONBaseURL' in _config) {
        _config.bukJSONBaseURL = removeTrailingSlash(_config.bukJSONBaseURL);
    }
    if ('initialSettings' in _config) {
        _config.initialSettings = normalizeSettings(_config.initialSettings);
    }
    return _config;
}
function defaultCanChangeAddress(newAddress) {
    return true;
}
class LibConfigService {
    constructor(_enableEpubObfuscation) {
        this._enableEpubObfuscation = _enableEpubObfuscation;
    }
    init(config) {
        this._config = normalizeConfigInput(config);
        return this._config;
    }
    get config() {
        if (!this._config) {
            throw new Error('viewer not initialized');
        }
        return this._config;
    }
    get bukJSONBaseURL() {
        return this.config.bukJSONBaseURL ?? this.config.contentsBaseURL;
    }
    get contentsBaseURL() {
        return this.config.contentsBaseURL;
    }
    get pdfTextBaseURL() {
        return this.config.pdfTextBaseURL;
    }
    get fonts() {
        return this.config.fonts ?? {};
    }
    get highlightStyles() {
        return this.config.highlightStyles ?? [];
    }
    get contentsStyleURLs() {
        return this.config.contentsStyleURLs ?? [];
    }
    get contentsStyles() {
        return this.config.contentsStyles ?? [];
    }
    set contentsStyles(value) {
        this.config.contentsStyles = value;
    }
    get initialSettings() {
        return this.config.initialSettings;
    }
    get updateHTTPRequest() {
        return this.config.updateHTTPRequest;
    }
    get canChangeAddress() {
        return this.config.canChangeAddress ?? defaultCanChangeAddress;
    }
    get enableEpubObfuscation() {
        return !!this._enableEpubObfuscation;
    }
    get enablePinchZoom() {
        return !!this.config.enablePinchZoom;
    }
    set pageGestureEnabled(enabled) {
        this.config.pageGestureEnabled = enabled;
    }
    get pageGestureEnabled() {
        return this.config.pageGestureEnabled ?? true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: LibConfigService, deps: [{ token: LIB_CONFIG_INTERNAL_ENABLE_EPUB_OBFUSCATION, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: LibConfigService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: LibConfigService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [LIB_CONFIG_INTERNAL_ENABLE_EPUB_OBFUSCATION]
                }] }] });

class EventBusService {
    constructor() {
        this.eventBus = new Subject();
    }
    emit(key, data) {
        this.eventBus.next({ key, data });
    }
    on(key) {
        return this.eventBus.asObservable().pipe(filter((event) => event.key === key), map((event) => event.data));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: EventBusService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: EventBusService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: EventBusService, decorators: [{
            type: Injectable
        }] });

function getRandomNumber(start, end) {
    return Math.floor(Math.random() * (end - start + 1)) + start;
}
function clamp(min, value, max) {
    return Math.min(Math.max(value, min), max);
}
function getEnclosingRect(rects) {
    const minLeft = Math.min(...rects.map((rect) => rect.x));
    const maxRight = Math.max(...rects.map((rect) => rect.x + rect.width));
    const minTop = Math.min(...rects.map((rect) => rect.y));
    const maxBottom = Math.min(...rects.map((rect) => rect.y + rect.height));
    return {
        x: Math.min(...rects.map((rect) => rect.x)),
        y: Math.min(...rects.map((rect) => rect.y)),
        width: maxRight - minLeft,
        height: maxBottom - minTop,
    };
}

const MAX_FONT_SIZE = 200;
const MIN_FONT_SIZE = 50;
const FONT_SIZE_STEP = 10;
const MAX_LINE_HEIGHT = 150;
const MIN_LINE_HEIGHT = 50;
const LINE_HEIGHT_STEP = 10;
function toSettings(values) {
    return Object.entries(values).reduce((settings, [key, value]) => {
        settings[key] = {
            value,
            isDisabled: false,
        };
        return settings;
    }, {});
}
function isMultiColumnAvailableAtSize(size) {
    return size.width >= size.height && size.width >= 1024;
}
class SettingsStoreService {
    constructor(_libConfig) {
        this._libConfig = _libConfig;
        this._isMultiColumnAvailable = true;
        this._userSettingValues = cloneObj(_libConfig.initialSettings || DEFAULT_SETTING_VALUES);
        this._settings$ = new BehaviorSubject(toSettings(this._userSettingValues));
        this.settings$ = this._settings$.asObservable();
    }
    get settings() {
        return this._settings$.getValue();
    }
    resetSettings(book, viewerSize) {
        this._isMultiColumnAvailable =
            isMultiColumnAvailableAtSize(viewerSize) &&
                book.meta.type !== BookType.Wiki &&
                !isBookReflowableAndFixedLayout(book);
        const pagingMode = this.getPagingModeForBook(book);
        const isPageAnimationDisabled = pagingMode.value === PagingMode.Scroll;
        let canUseMultiColumn;
        if (book.meta.layout === 'fixed') {
            canUseMultiColumn = !book._isHorizontalFixedLayout;
        }
        else {
            canUseMultiColumn =
                pagingMode.value === PagingMode.Page && this._isMultiColumnAvailable;
        }
        this._settings$.next({
            theme: this.getThemeForBook(book),
            fontFace: this.getFontFaceForBook(book),
            fontSize: this.getFontSizeForBook(book),
            lineHeight: this.getLineHightForBook(book),
            pagingMode,
            multiColumn: {
                isDisabled: !canUseMultiColumn,
                value: canUseMultiColumn ? this._userSettingValues.multiColumn : false,
            },
            pageAnimation: {
                isDisabled: isPageAnimationDisabled,
                value: isPageAnimationDisabled
                    ? true
                    : this._userSettingValues.pageAnimation,
            },
            clickToPlayMediaOverlay: this.getClickToPlayMediaOverlayForBook(book),
        });
    }
    change(settingKey, value) {
        this._userSettingValues[settingKey] = value;
        if (this.settings[settingKey].isDisabled) {
            return;
        }
        if (this.settings[settingKey].value === value) {
            return;
        }
        this._change(settingKey, value);
    }
    changeTheme(theme) {
        this.change('theme', theme);
    }
    changeFontSize(value, isAbsolute) {
        let fontSize = this.settings.fontSize.value;
        if (isAbsolute) {
            fontSize = value;
        }
        else {
            fontSize =
                value === 0 ? 100 : fontSize + (value > 0 ? 1 : -1) * FONT_SIZE_STEP;
        }
        this.change('fontSize', clamp(MIN_FONT_SIZE, fontSize, MAX_FONT_SIZE));
    }
    changeLineHeight(value, isAbsolute) {
        let lineHeight = this.settings.lineHeight.value;
        if (isAbsolute) {
            lineHeight = value;
        }
        else {
            lineHeight =
                value === 0
                    ? 100
                    : lineHeight + (value > 0 ? 1 : -1) * LINE_HEIGHT_STEP;
        }
        this.change('lineHeight', clamp(MIN_LINE_HEIGHT, lineHeight, MAX_LINE_HEIGHT));
    }
    changeFontFace(fontFace) {
        this.change('fontFace', fontFace);
    }
    changePagingMode(pagingMode) {
        this.change('pagingMode', pagingMode);
    }
    setPageAnimation(isActive) {
        this.change('pageAnimation', isActive);
    }
    setMultiColumn(isActive) {
        this.change('multiColumn', isActive);
    }
    setClickToPlayMediaOverlay(isActive) {
        this.change('clickToPlayMediaOverlay', isActive);
    }
    _change(settingKey, value) {
        const newSettings = {
            ...this.settings,
            [settingKey]: { ...this.settings[settingKey], value },
        };
        if (settingKey === 'pagingMode') {
            const isDisabled = newSettings.pagingMode.value === PagingMode.Scroll;
            newSettings.pageAnimation = {
                isDisabled,
                value: isDisabled ? true : this._userSettingValues.pageAnimation,
            };
            const isScrollMode = newSettings.pagingMode.value === PagingMode.Scroll;
            const isMultiColumnDisabled = isScrollMode || !this._isMultiColumnAvailable;
            newSettings.multiColumn = {
                isDisabled: isMultiColumnDisabled,
                value: isMultiColumnDisabled
                    ? false
                    : this._userSettingValues.multiColumn,
            };
        }
        this._settings$.next(newSettings);
    }
    getThemeForBook(book) {
        // const isDisabled = book.meta.layout === 'fixed';
        return {
            isDisabled: false,
            value: this._userSettingValues.theme,
        };
    }
    getFontSizeForBook(book) {
        const isDisabled = book.meta.layout === 'fixed';
        return {
            isDisabled,
            value: isDisabled ? 100 : this._userSettingValues.fontSize,
        };
    }
    getFontFaceForBook(book) {
        const isFixedLayout = book.meta.layout === 'fixed';
        const availableFonts = getFontsForBook(book, this._libConfig.fonts);
        const isDisabled = isFixedLayout || availableFonts.length === 0;
        const canUseUserValue = availableFonts.indexOf(this._userSettingValues.fontFace) !== -1;
        return {
            isDisabled,
            value: isDisabled || !canUseUserValue
                ? 'default'
                : this._userSettingValues.fontFace,
        };
    }
    getLineHightForBook(book) {
        const isDisabled = book.meta.layout === 'fixed';
        return {
            isDisabled,
            value: isDisabled ? 100 : this._userSettingValues.lineHeight,
        };
    }
    getPagingModeForBook(book) {
        if (book.meta.layout === 'fixed') {
            return {
                isDisabled: true,
                value: PagingMode.Page,
            };
        }
        if (book.meta.viewMode !== 'both') {
            return {
                isDisabled: true,
                value: book.meta.viewMode === 'page' ? PagingMode.Page : PagingMode.Scroll,
            };
        }
        return {
            isDisabled: false,
            value: this._userSettingValues.pagingMode,
        };
    }
    getClickToPlayMediaOverlayForBook(book) {
        const isDisabled = !book.meta.media;
        return {
            isDisabled,
            value: isDisabled
                ? false
                : this._userSettingValues.clickToPlayMediaOverlay,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: SettingsStoreService, deps: [{ token: LibConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: SettingsStoreService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: SettingsStoreService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: LibConfigService }] });

var ItemLoadErrorCode;
(function (ItemLoadErrorCode) {
    ItemLoadErrorCode[ItemLoadErrorCode["Unknown"] = 0] = "Unknown";
    ItemLoadErrorCode[ItemLoadErrorCode["ItemNotFound"] = 1] = "ItemNotFound";
    /**
     * @deprecated
     */
    ItemLoadErrorCode[ItemLoadErrorCode["PermissionDenied"] = 2] = "PermissionDenied";
    ItemLoadErrorCode[ItemLoadErrorCode["ContentsLoadFailed"] = 3] = "ContentsLoadFailed";
    ItemLoadErrorCode[ItemLoadErrorCode["ContentsProcessingFailed"] = 4] = "ContentsProcessingFailed";
})(ItemLoadErrorCode || (ItemLoadErrorCode = {}));
var PageChangeCancelCode;
(function (PageChangeCancelCode) {
    /**
     * @deprecated
     */
    PageChangeCancelCode[PageChangeCancelCode["OutOfPreviewBounds"] = 0] = "OutOfPreviewBounds";
    PageChangeCancelCode[PageChangeCancelCode["NoNextItem"] = 1] = "NoNextItem";
})(PageChangeCancelCode || (PageChangeCancelCode = {}));
const PAGE_ANIMATION_CLASS_TO_NEXT = 'bukv_anim-to-next';
const PAGE_ANIMATION_CLASS_TO_PREV = 'bukv_anim-to-prev';
class PagesBaseComponent {
    constructor(_renderer, _element, _libConfig, _eventBus, _settingsStore) {
        this._renderer = _renderer;
        this._element = _element;
        this._libConfig = _libConfig;
        this._eventBus = _eventBus;
        this.itemLoadStart = new EventEmitter();
        this.itemLoad = new EventEmitter();
        this.itemLoadError = new EventEmitter();
        this.pageInfoChange = new EventEmitter();
        this.mediaOverlayPlayStateChange = new EventEmitter();
        this.pageChangeCanceled = new EventEmitter();
        this.bookmarkStateChange = new EventEmitter();
        this.annotationCreated = new EventEmitter();
        this.annotationChanged = new EventEmitter();
        this.annotationRemoved = new EventEmitter();
        this.zoomScaleChange = new EventEmitter();
        this._unsubscriber = new Subject();
        this._address$ = new BehaviorSubject(undefined);
        this._settings$ = new BehaviorSubject(undefined);
        this.__pageBookmarks = [];
        this._addressChange$ = this._address$.pipe(pairwise(), map(([oldAddr, newAddr]) => {
            return {
                newAddress: newAddr,
                oldAddress: oldAddr,
                changeType: getAddressChangeType(newAddr, oldAddr),
            };
        }));
        this._settingsChange$ = this._settings$.pipe(pairwise(), map(([oldSettings, newSettings]) => ({
            oldSettings,
            newSettings: newSettings,
        })));
        this._changePage$ = this._eventBus.on('changePage').pipe(takeUntil(this._unsubscriber), filter(({ trigger }) => {
            return this._libConfig.pageGestureEnabled
                ? true
                : trigger !== 'gesture';
        }), map(({ direction }) => direction));
        this.theme = _settingsStore.settings.theme.value;
        this._settings$
            .pipe(takeUntil(this._unsubscriber), filter((settings) => !!settings))
            .subscribe((settings) => (this.theme = settings.theme.value));
        this._element.nativeElement.addEventListener('contextmenu', (event) => {
            event.preventDefault();
        });
        fromEvent(this._element.nativeElement, 'animationend')
            .pipe(takeUntil(this._unsubscriber), filter((event) => event.animationName.indexOf('bukvPageSlideIn') !== -1))
            .subscribe(() => {
            [PAGE_ANIMATION_CLASS_TO_NEXT, PAGE_ANIMATION_CLASS_TO_PREV].forEach((className) => this._renderer.removeClass(this._element.nativeElement, className));
            this._onItemPageSettled();
        });
    }
    get _address() {
        return this._address$.value;
    }
    set _pageBookmarks(annotations) {
        const wasActive = this.__pageBookmarks.length > 0;
        const isActive = annotations.length > 0;
        this.__pageBookmarks = annotations;
        if (wasActive !== isActive) {
            this.bookmarkStateChange.emit({ isActive });
        }
    }
    get _pageBookmarks() {
        return this.__pageBookmarks;
    }
    ngOnDestroy() {
        this._unsubscriber.next();
        this._unsubscriber.complete();
    }
    updateAddress(address) {
        this._address$.next(address);
    }
    updateSettings(settings) {
        this._settings$.next(settings);
    }
    toggleBookmark() {
        if (this._pageBookmarks.length > 0) {
            this._unhighlightAnnotations(this._pageBookmarks);
            this.annotationRemoved.emit({
                annotations: this._pageBookmarks.map((bookmark) => {
                    return bookmark.toAnnotation();
                }),
            });
            this._pageBookmarks = [];
        }
        else {
            const annotation = this._createBookmark();
            this.annotationCreated.emit({
                annotation,
                mergedAnnotations: [],
            });
            this._pageBookmarks = [new ParsedAnnotation(annotation)];
        }
    }
    createHighlight(range, styleClass, options = {}) {
        return null;
    }
    changeHighlight(range, currStyleClass, newStyleClass, options = {}) {
        return null;
    }
    removeHighlight(range, styleClass, options = {}) {
        return null;
    }
    getSelection() {
        return null;
    }
    clearSelection() { }
    getHighlightsFromRange(range) {
        return [];
    }
    _createBookmark() {
        throw new Error('not implemented');
    }
    _unhighlightAnnotations(annotations) { }
    search(keyword) {
        return of([]);
    }
    zoom(scale) { }
    playMediaOverlay(prevOrNext) { }
    playMediaOverlayFromRange(range) { }
    pauseMediaOverlay() { }
    isPlayingMediaOverlay() {
        return false;
    }
    createRangeFromElements(startId, endId, iid) {
        throw new Error('not implemented');
    }
    getVisibleRanges() {
        return [];
    }
    getAddressFromRange(range) {
        throw new Error('not implemented');
    }
    canPlayMediaOverlayFromRange(range) {
        return false;
    }
    _getViewerSize() {
        return {
            width: this._element.nativeElement.parentElement.offsetWidth,
            height: this._element.nativeElement.parentElement.offsetHeight,
        };
    }
    _changePageVisibility(activePageComp, inactivePageComp, skipAnimation) {
        this._renderer.addClass(activePageComp._element.nativeElement, 'bukv_is-active');
        this._renderer.removeClass(inactivePageComp._element.nativeElement, 'bukv_is-active');
        if (skipAnimation) {
            this._onItemPageSettled();
            return;
        }
        if (!inactivePageComp._rightItem || !activePageComp._rightItem) {
            this._onItemPageSettled();
            return;
        }
        const activePageItemIndex = this.book.getItemIndex(activePageComp._rightItem.iid);
        const inactivePageItemIndex = this.book.getItemIndex(inactivePageComp._rightItem.iid);
        if (activePageItemIndex === inactivePageItemIndex) {
            this._onItemPageSettled();
            return;
        }
        const animClasses = [
            {
                name: PAGE_ANIMATION_CLASS_TO_NEXT,
                isAdd: activePageItemIndex > inactivePageItemIndex,
            },
            {
                name: PAGE_ANIMATION_CLASS_TO_PREV,
                isAdd: activePageItemIndex < inactivePageItemIndex,
            },
        ];
        animClasses.forEach((animClass) => {
            if (animClass.isAdd) {
                this._renderer.addClass(this._element.nativeElement, animClass.name);
            }
            else {
                this._renderer.removeClass(this._element.nativeElement, animClass.name);
            }
        });
        // fromEvent<AnimationEvent>(
        //   this._element.nativeElement,
        //   'animationend'
        // )
        //   .pipe(
        //     filter((event) => event.animationName.indexOf('slide') === 0),
        //     take(1)
        //   )
        //   .subscribe((event) => {
        //     this._renderer.removeClass(
        //       this._element.nativeElement,
        //       animClasses.find((animClass) => animClass.isAdd)!.name
        //     );
        //     subscriber.next();
        //     subscriber.complete();
        //   });
        // merge(
        //   fromEvent<AnimationEvent>(
        //     this._element.nativeElement,
        //     'animationend'
        //   ).pipe(
        //     filter((event) => event.animationName.indexOf('slide') === 0),
        //     take(1)
        //   ),
        //   fromEvent<AnimationEvent>(
        //     this._element.nativeElement,
        //     'animationcancel'
        //   ).pipe(
        //     filter((event) => event.animationName.indexOf('slide') === 0),
        //     take(1)
        //   )
        // ).subscribe((event) => {
        //   event.type === 'animationend' &&
        //     this._renderer.removeClass(
        //       this._element.nativeElement,
        //       animClasses.find((animClass) => animClass.isAdd)!.name
        //     );
        //   if (!subscriber.closed) {
        //     subscriber.next();
        //     subscriber.complete();
        //   }
        // });
    }
    _onItemPageSettled() {
        this._eventBus.emit('pageTransitionEnd');
    }
    applyContentsStyles() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: PagesBaseComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: LibConfigService }, { token: EventBusService }, { token: SettingsStoreService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.3", type: PagesBaseComponent, selector: "bukv-pages-base", inputs: { book: "book" }, outputs: { itemLoadStart: "itemLoadStart", itemLoad: "itemLoad", itemLoadError: "itemLoadError", pageInfoChange: "pageInfoChange", mediaOverlayPlayStateChange: "mediaOverlayPlayStateChange", pageChangeCanceled: "pageChangeCanceled", bookmarkStateChange: "bookmarkStateChange", annotationCreated: "annotationCreated", annotationChanged: "annotationChanged", annotationRemoved: "annotationRemoved", zoomScaleChange: "zoomScaleChange" }, host: { properties: { "attr.data-bukv-theme": "this.theme" } }, ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: PagesBaseComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bukv-pages-base',
                    template: '',
                }]
        }], ctorParameters: () => [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: LibConfigService }, { type: EventBusService }, { type: SettingsStoreService }], propDecorators: { itemLoadStart: [{
                type: Output
            }], itemLoad: [{
                type: Output
            }], itemLoadError: [{
                type: Output
            }], pageInfoChange: [{
                type: Output
            }], mediaOverlayPlayStateChange: [{
                type: Output
            }], pageChangeCanceled: [{
                type: Output
            }], bookmarkStateChange: [{
                type: Output
            }], annotationCreated: [{
                type: Output
            }], annotationChanged: [{
                type: Output
            }], annotationRemoved: [{
                type: Output
            }], zoomScaleChange: [{
                type: Output
            }], book: [{
                type: Input
            }], theme: [{
                type: HostBinding,
                args: ['attr.data-bukv-theme']
            }] } });

var BookLoadErrorCode;
(function (BookLoadErrorCode) {
    BookLoadErrorCode[BookLoadErrorCode["Unknown"] = 0] = "Unknown";
    BookLoadErrorCode[BookLoadErrorCode["Network"] = 1] = "Network";
})(BookLoadErrorCode || (BookLoadErrorCode = {}));

function renderWikiContentsHTML(parseResult) {
    return (parseResult.parse.headhtml['*'] +
        parseResult.parse.text['*'] +
        '</body></html>');
}
function renderWikiTOC(iid, parseResult) {
    return parseResult.parse.sections.map((section) => ({
        address: `${iid}/${section.anchor}`,
        title: `${section.number} ${section.line}`,
        depth: section.toclevel - 1,
    }));
}
function renderWikiBukJSON(address, parseResult) {
    return {
        meta: {
            bid: address.bid,
            type: BookType.Wiki,
            cover: '',
            title: parseResult.parse.title,
            subtitle: '',
            author: 'Wikipedia',
            languages: [address.bid],
            version: parseResult.parse.revid.toString(),
            locales: [],
        },
        items: [
            {
                iid: address.iid,
                url: '',
            },
        ],
        toc: renderWikiTOC(address.iid, parseResult),
        page_list: [],
    };
}

function isWikiParseError(response) {
    return response.error !== undefined;
}
class WikiAPIService {
    constructor(_http) {
        this._http = _http;
    }
    getMeta(bid, iid, revid) {
        const params = {
            action: 'parse',
            format: 'json',
            prop: 'sections|revid',
            redirects: 'yes',
            origin: '*',
        };
        if (revid) {
            params.oldid = revid;
        }
        else {
            params.page = iid;
        }
        return this._http
            .get(this._getAPIURL(bid), {
            params,
        })
            .pipe(map((response) => {
            if (isWikiParseError(response)) {
                throw new Error(response.error.info);
            }
            return response;
        }));
    }
    getItem(bid, revid) {
        return this._http
            .get(this._getAPIURL(bid), {
            params: {
                action: 'parse',
                prop: 'text|headhtml',
                format: 'json',
                redirects: 'yes',
                origin: '*',
                oldid: revid,
            },
        })
            .pipe(map((response) => {
            if (isWikiParseError(response)) {
                throw new Error(response.error.info);
            }
            return response;
        }));
    }
    getThumbnail(bid, iid) {
        return this._http
            .get(this._getAPIURL(bid), {
            params: {
                action: 'query',
                format: 'json',
                titles: iid,
                prop: 'pageimages',
                pithumbsize: '400',
                piprop: 'thumbnail',
                redirects: 'yes',
                origin: '*',
            },
        })
            .pipe(map((response) => {
            const pageId = Object.keys(response.query.pages)[0];
            if (pageId === '-1') {
                throw new Error('title not found');
            }
            return response.query.pages[pageId].thumbnail?.source;
        }));
    }
    _getAPIURL(bid) {
        const lang = bid.split('_')[0];
        const wikiType = isWiktionaryBid(bid) ? 'wiktionary' : 'wikipedia';
        return `https://${lang}.${wikiType}.org/w/api.php`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: WikiAPIService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: WikiAPIService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: WikiAPIService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }] });

class ViewerAPIService {
}
class APIService {
    constructor(_http, _libConfig, _wikiAPIService, _customAPIService) {
        this._http = _http;
        this._libConfig = _libConfig;
        this._wikiAPIService = _wikiAPIService;
        this._customAPIService = _customAPIService;
    }
    getBukJSON(address) {
        if (this._customAPIService?.getBukJSON) {
            return this._customAPIService.getBukJSON(address);
        }
        if (isWikiBid(address.bid)) {
            return this._getWikiBukJSON(address);
        }
        else {
            return this._getBukJSON(address);
        }
    }
    getPDFText(bid) {
        if (this._customAPIService?.getPDFText) {
            return this._customAPIService.getPDFText(bid);
        }
        if (!this._libConfig.pdfTextBaseURL) {
            return throwError(new Error('no pdfTextBaseURL'));
        }
        let request = new HttpRequest('GET', `${this._libConfig.pdfTextBaseURL}/${bid}`, { responseType: 'json' });
        try {
            const update = this._libConfig.updateHTTPRequest?.(request.url);
            if (update) {
                request = request.clone(update);
            }
        }
        catch (error) {
            return throwError(error);
        }
        return this._http.request(request).pipe(filter((event) => event instanceof HttpResponse), map((event) => event.body));
    }
    _getBukJSON(address) {
        let request = new HttpRequest('GET', `${this._libConfig.bukJSONBaseURL}/@${address.bid}/buk.json`, { responseType: 'json' });
        try {
            const update = this._libConfig.updateHTTPRequest?.(request.url);
            if (update) {
                request = request.clone(update);
            }
        }
        catch (error) {
            return throwError(error);
        }
        return this._http.request(request).pipe(filter((event) => event instanceof HttpResponse), map((event) => event.body));
    }
    _getWikiBukJSON(address) {
        return this._wikiAPIService
            .getMeta(address.bid, address.iid, address.query?.version)
            .pipe(map((response) => renderWikiBukJSON(address, response)));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: APIService, deps: [{ token: i1.HttpClient }, { token: LibConfigService }, { token: WikiAPIService }, { token: ViewerAPIService, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: APIService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: APIService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: LibConfigService }, { type: WikiAPIService }, { type: ViewerAPIService, decorators: [{
                    type: Optional
                }] }] });

/**
 * 서버에서 내려준 buk.json을 뷰어에서 사용하기 편하도록 가공
 * @param book 원본 buk.json
 * @param address 책 요청 주소
 * @returns 가공한 buk.json
 */
function normalizeBukJSON(book, address, contentsBaseURL) {
    const resolveContentsURL = (url) => {
        return new Url(url.replace(/^https?:\/\/contents\.buk\.io/, '.'), contentsBaseURL + '/').href;
    };
    const _book = JSON.parse(JSON.stringify(book));
    // toc 필드가 존재하지 않는 경우
    if (!_book.toc) {
        _book.toc = [];
    }
    if (!_book.page_list) {
        _book.page_list = [];
    }
    if (_book.meta.cover) {
        _book.meta.cover = resolveContentsURL(_book.meta.cover);
    }
    if (!_book.meta.locales) {
        _book.meta.locales = [];
    }
    if (_book.meta.type === BookType.Document) {
        _book.items = [
            {
                iid: '',
                url: `${contentsBaseURL}/@${_book.meta.bid}/html/${_book.meta.bid}.html`,
            },
        ];
    }
    else if (_book.meta.type === BookType.PDF) {
        _book.items.forEach((item) => {
            if (item.url && /\.x?html$/.test(item.url)) {
                item.url = item.url
                    .replace(/\.x?html$/, '.jpg')
                    .replace('/html/', '/static/images/');
            }
        });
    }
    // TOC 처리
    _book.toc.forEach((toc) => {
        if (toc.depth == null) {
            toc.depth = toc.type === 'title' ? 0 : 1;
        }
    });
    // 아이템 처리
    _book.items.forEach((item) => {
        // url 정리: url을 contentesBaseURL로 resolve, https
        if (item.url) {
            item.url = resolveContentsURL(item.url);
        }
        if (item.thumbnail) {
            item.thumbnail = resolveContentsURL(item.thumbnail);
        }
        // layout 값 채워줌
        if (!item.layout && book.meta.layout) {
            item.layout = book.meta.layout;
        }
        // layout fixed인 경우 사이즈 채워줌
        if (item.layout === 'fixed') {
            item.fixedWidth = item.fixedWidth ?? book.meta.fixedWidth;
            item.fixedHeight = item.fixedHeight ?? book.meta.fixedHeight;
        }
        // smil clipEnd, clipBegin 값 ms number 값으로 변경, audio url을 contentsBaseURL로 resolve
        item.smil?.forEach((smilItem) => {
            if (smilItem.audio_url) {
                smilItem.audio_url = resolveContentsURL(smilItem.audio_url).replace('http://', 'https://');
            }
        });
    });
    // 모든 아이템이 fixed layout인 경우 책의 layout을 'fixed'로
    if (_book.items.every((item) => item.layout === 'fixed')) {
        _book.meta.layout = 'fixed';
    }
    // fixed layout 책인 경우 페이지 모드만 가능하도록
    if (_book.items.some((item) => item.layout === 'fixed')) {
        _book.meta.viewMode = 'page';
    }
    else {
        _book.meta.viewMode = 'both';
    }
    // fixed layout 책인 경우 두 페이지 보기 모드에서 표시할 위치 정해줌
    if (_book.meta.layout === 'fixed') {
        _book.items.forEach((item, index) => {
            if (!item.pageSpread) {
                item.pageSpread = index % 2 === 0 ? 'right' : 'left';
            }
        });
    }
    return _book;
}

class ViewerContentsService {
}
class ContentsService {
    constructor(_http, _libConfig, _apiService, _wikiAPIService, _customContentsService) {
        this._http = _http;
        this._libConfig = _libConfig;
        this._apiService = _apiService;
        this._wikiAPIService = _wikiAPIService;
        this._customContentsService = _customContentsService;
    }
    getBook(address) {
        return this._apiService.getBukJSON(address).pipe(map((bukJSON) => {
            return normalizeBukJSON(bukJSON, address, this._libConfig.contentsBaseURL);
        }));
    }
    getItem(itemURL) {
        if (!itemURL) {
            return throwError(new Error('empty url'));
        }
        if (this._customContentsService?.getItem) {
            return this._customContentsService.getItem(itemURL);
        }
        let request = new HttpRequest('GET', itemURL, { responseType: 'text' });
        try {
            const update = this._libConfig.updateHTTPRequest?.(request.url);
            if (update) {
                request = request.clone(update);
            }
        }
        catch (error) {
            return throwError(error);
        }
        return this._http.request(request).pipe(filter((event) => event instanceof HttpResponse), map((event) => event.body));
    }
    getPDFImage(imageURL) {
        if (this._customContentsService?.getPDFImage) {
            return this._customContentsService.getPDFImage(imageURL);
        }
        return this._http.get(imageURL, { responseType: 'blob' });
    }
    getWikiItem(bid, version) {
        return this._wikiAPIService
            .getItem(bid, version)
            .pipe(map(renderWikiContentsHTML));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: ContentsService, deps: [{ token: i1.HttpClient }, { token: LibConfigService }, { token: APIService }, { token: WikiAPIService }, { token: ViewerContentsService, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: ContentsService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: ContentsService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: LibConfigService }, { type: APIService }, { type: WikiAPIService }, { type: ViewerContentsService, decorators: [{
                    type: Optional
                }] }] });

class ViewerPDFOverlayViewProviderService {
}

const APP_KEY_PREFIX = 'bukv';
const KEY_SETTINGS = 'settings';
let viewerId = 1;
class StorageService {
    constructor() {
        this._viewerId = viewerId++;
    }
    saveSettings(settings) {
        const prevSettings = this.loadSettings();
        /**
         * 유저가 직접 변경한 설정만 저장
         */
        const newSettings = Object.entries(settings)
            .filter(([key, setting]) => !setting.isDisabled)
            .reduce((settingValues, [key, setting]) => {
            settingValues[key] = setting.value;
            return settingValues;
        }, {});
        try {
            this._save(KEY_SETTINGS, JSON.stringify({ ...prevSettings, ...newSettings }));
        }
        catch (error) {
            console.log('failed to save viewer setting data', error);
        }
    }
    loadSettings() {
        try {
            const settings = this._load(KEY_SETTINGS);
            if (!settings) {
                return null;
            }
            return JSON.parse(settings);
        }
        catch (error) {
            console.log('failed to load viewer setting data', error);
            return null;
        }
    }
    _getKey(key) {
        return `${APP_KEY_PREFIX}-${this._viewerId}.${key}`;
    }
    _load(key) {
        return localStorage.getItem(this._getKey(key));
    }
    _save(key, value) {
        localStorage.setItem(this._getKey(key), value);
    }
    _remove(key) {
        localStorage.removeItem(this._getKey(key));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: StorageService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: StorageService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: StorageService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [] });

class AddressStoreService {
    constructor(_libConfig) {
        this._libConfig = _libConfig;
        this._address$ = new BehaviorSubject(undefined);
        this.address$ = this._address$
            .asObservable()
            .pipe(filter((address) => !!address));
    }
    get address() {
        return this._address$.getValue();
    }
    update(address) {
        if (!this._libConfig.canChangeAddress(address)) {
            return false;
        }
        this._address$.next(address);
        return true;
    }
    updateWithURL(url) {
        return this.update(parseBukURL(url));
    }
    updateBid(bid) {
        return this.update(new Address(bid));
    }
    updateIid(iid) {
        const address = this.address;
        return this.update(new Address(address.bid, iid));
    }
    updateAnchor(anchor) {
        const address = this.address;
        return this.update(new Address(address.bid, address.iid, anchor === 0 ? undefined : anchor));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: AddressStoreService, deps: [{ token: LibConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: AddressStoreService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: AddressStoreService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: LibConfigService }] });

class ContentsClickInterceptorService {
    constructor(libConfig) {
        this._highlightStyleClasses = libConfig.highlightStyles.map((style) => style.styleClass);
    }
    getHighlightElement(target) {
        return this.getHighlightElementFromNode(target);
    }
    getAddress(target) {
        if (!isElement(target)) {
            return null;
        }
        const linkElement = findNodeFrom(target, (node) => isElement(node) && node.tagName === 'A');
        if (!linkElement || linkElement.getAttribute('target') === '_blank') {
            return null;
        }
        const href = linkElement.getAttribute('href');
        if (!href) {
            return null;
        }
        if (linkElement.hasAttribute(WIKI_URL_ATTR)) {
            return parseBukURL(href);
        }
        const baseURL = target.ownerDocument.documentElement.getAttribute(BASE_BUK_URL_ATTR);
        if (baseURL) {
            const baseAddress = parseBukURL(baseURL);
            const bid = baseAddress.bid;
            const bookURLMatch = new RegExp(`^(\\.?)/@?${bid}`).exec(href);
            if (bookURLMatch) {
                return parseBukURL(href.substring(bookURLMatch[1].length));
            }
            if (href[0] === '#') {
                const address = baseAddress.clone();
                address.anchor = href.substring(1);
                return address;
            }
            if (href.indexOf('/wiki/') === 0) {
                return new Address(bid, href.substr(6));
            }
        }
        return null;
    }
    getMediaOverlayText(target) {
        if (!isNode(target)) {
            return null;
        }
        return findNodeFrom(target, (node) => isElement(node) && node.hasAttribute(SMIL_TEXT_ITEM_ATTR));
    }
    getHighlightElementFromNode(node) {
        if (node.nodeType !== Node.ELEMENT_NODE &&
            node.nodeType !== Node.TEXT_NODE) {
            return null;
        }
        const highlightElement = findNodeFrom(node, (element) => {
            return this._highlightStyleClasses.some((c) => isElement(element) && element.classList.contains(c));
        }, 2);
        return highlightElement ? highlightElement : null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: ContentsClickInterceptorService, deps: [{ token: LibConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: ContentsClickInterceptorService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: ContentsClickInterceptorService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: LibConfigService }] });

var coverStyle = `html.buk-image-cover body,html.buk-image-cover .buk-scroll-wrapper{height:100%}body{font-size:12px}table{width:100% !important}table td{font-family:"Open Sans" !important;line-height:1.4 !important;vertical-align:top !important}table td:first-child{width:30% !important;text-align:right !important;padding-right:.5rem !important;font-weight:700 !important}table td:last-child{width:70% !important;text-align:left !important;padding-left:.5rem !important}a{text-decoration:none;background:0 0;color:#4a77bb}.bu.page{width:100%;height:100vh;overflow:hidden}.bu.cover{text-align:center}.bu.cover.page{font-family:"Open Sans",Arial,Helvetica,sans-serif}.bu.cover:not(.wiki){padding:0}.bu.cover .bu.collection{height:3em;line-height:3em;color:#fff;font-size:1.5em;font-weight:700;letter-spacing:1px;background-color:rgba(76,97,149,.9)}.bu.cover .title-block{display:-webkit-flex;display:flex;-webkit-flex-direction:column;flex-direction:column;-webkit-justify-content:center;justify-content:center}.bu.cover .title-block>div:first-child{color:#383838}.bu.flex>.expand{-webkit-flex-grow:1;flex-grow:1;-webkit-flex-shrink:1;flex-shrink:1}.bu.flex.column{height:100vh;display:-webkit-flex;display:flex;-webkit-flex-direction:column;flex-direction:column}.bu.flex.row{width:100% !important;display:-webkit-flex;display:flex;-webkit-flex-direction:row;flex-direction:row}.bu.color.white{color:#fff}.bu.color.blue{color:#3d88c7}.bu.color.red{color:#f05656}.bu.color.green{color:#2fb88b}.bu.color.dark{color:#444}.bu.color.light{color:#d3d3d3}.bu.color.black{color:#000}.bu.background.white{background:#fff}.bu.background.blue{background:#3d88c7}.bu.background.red{background:#f05656}.bu.background.green{background:#2fb88b}.bu.background.dark{background:#444}.bu.background.light{background:#d3d3d3}.bu.background.black{background:#000}.bu.text.center{text-align:center}.bu.text.left{text-align:left}.bu.text.right{text-align:right}.bu.text.justify{text-align:justify}.bu.text.bold{font-weight:700}`;

var commonStyle = `[data-bukv-theme=light]{--bukv-text-color: #383838;--bukv-bg-color: #fff;--bukv-column-rule-img: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' height='2' width='1'%3E%3Cline x1='0' y1='0' x2='0' y2='1' style='stroke:%23e0e0e0;stroke-width:2' /%3E%3C/svg%3E")}[data-bukv-theme=sepia]{--bukv-text-color: #685f5e;--bukv-bg-color: #f2efec;--bukv-column-rule-img: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' height='2' width='1'%3E%3Cline x1='0' y1='0' x2='0' y2='1' style='stroke:%23e0e0e0;stroke-width:2' /%3E%3C/svg%3E")}[data-bukv-theme=dark]{--bukv-text-color: #fff;--bukv-bg-color: #212121;--bukv-column-rule-img: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' height='2' width='1'%3E%3Cline x1='0' y1='0' x2='0' y2='1' style='stroke:%23e0e0e0;stroke-width:2' /%3E%3C/svg%3E")}html,body{margin:0}@media(max-width: 480px){:root{--bukv-padding-left: 24px;--bukv-padding-right: 24px;--bukv-padding-top: 40px;--bukv-padding-bottom: 40px}}@media(min-width: 481px){:root{--bukv-padding-left: 60px;--bukv-padding-right: 60px;--bukv-padding-top: 60px;--bukv-padding-bottom: 60px}}@media(min-width: 900px){[data-bukv-multi-column=false]{--bukv-padding-left: calc((100vw - 900px) / 2 + 60px);--bukv-padding-right: calc((100vw - 900px) / 2 + 60px)}}#bukv-page-filler{display:none;user-select:none}[data-bukv-layout=column]{height:100%;-webkit-columns:100vw auto;columns:100vw auto;-webkit-column-gap:0;column-gap:0;position:relative;-webkit-column-fill:auto;column-fill:auto;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden;will-change:left;left:0}[data-bukv-layout=column]:not(.bukv_page-located){transition:none !important}[data-bukv-layout=column][data-bukv-page-animation=true]{-webkit-transition:left .2s ease;transition:left .2s ease}[data-bukv-layout=column][data-bukv-multi-column=true]:not([data-bukv-is-cover=true]){column-width:50vw}[data-bukv-layout=column][data-bukv-multi-column=true]:not([data-bukv-is-cover=true]) body{background-image:var(--bukv-column-rule-img);background-size:1px 200vh;background-position:right top;background-repeat:repeat-y;min-height:100vh}[data-bukv-layout=column] body{padding-top:0;padding-right:var(--bukv-padding-right);padding-bottom:0;padding-left:var(--bukv-padding-left)}[data-bukv-layout=column] pre{overflow-x:hidden}[data-bukv-layout=column] img{object-fit:contain;max-height:calc(100vh - 0.8em)}[data-bukv-layout=column] body{height:auto}[data-bukv-layout=column] #bukv-page-filler{display:block}[data-bukv-layout=scroll]{height:auto;overflow-x:hidden}[data-bukv-layout=scroll].fix-scroll-freeze{transform:translateZ(0px)}[data-bukv-layout=scroll] body{overflow-x:hidden;padding-top:var(--bukv-padding-top);padding-right:var(--bukv-padding-right);padding-bottom:var(--bukv-padding-bottom);padding-left:var(--bukv-padding-left);-webkit-overflow-scrolling:touch}[data-bukv-layout=scroll] .bu.flex.column{height:calc(100vh - var(--bukv-padding-top) - var(--bukv-padding-bottom))}[data-bukv-layout=scroll] #bukv-page-filler{display:block}[data-bukv-layout=fixed]{height:100%;overflow:hidden;-webkit-backface-visibility:hidden;backface-visibility:hidden}[data-bukv-layout=fixed] img{object-fit:fill;max-height:none;max-width:none}[data-bukv-layout=fixed] body{transform-origin:0 0}[data-bukv-layout=fixed] .bu.page{height:100% !important}img{max-width:100%}p{widows:initial !important;orphans:initial !important}tr>x{display:none}rt x{background:transparent !important}figure img,img[bukscalable]{cursor:pointer}img,svg{-webkit-user-select:none;-ms-user-select:none;user-select:none}body>p:last-of-type{margin-bottom:0}.bukv_mo-active{background:#ff0 !important}html{width:100%;zoom:reset;background-color:var(--bukv-bg-color);color:var(--bukv-text-color);font-weight:400;white-space:normal;vertical-align:baseline;text-rendering:optimizeLegibility;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-font-smoothing:antialiased;-webkit-text-size-adjust:100%;-webkit-user-drag:none;-ms-user-select:text;-webkit-backface-visibility:hidden;-webkit-transform-style:preserve-3d;transform-style:preserve-3d}@media(max-width: 480px){html{font-size:15px;line-height:1.4}}@media(min-width: 481px){html{font-size:18px;line-height:1.6}}html body{background-color:transparent;max-width:none}html,html body{box-sizing:border-box}[data-bukv-theme=dark]:not([data-bukv-layout=fixed]) *{color:var(--bukv-text-color) !important;-webkit-text-fill-color:currentcolor}[data-bukv-theme=dark]:not([data-bukv-layout=fixed]) *:not(x):not([data-bukv-mo-text]){background-color:transparent !important}[data-bukv-theme=dark]:not([data-bukv-layout=fixed]) img{background-color:#fff !important}`;

var wikiContentStyle = `[data-bukv-theme=light]{--bukv-text-color: #383838;--bukv-bg-color: #fff;--bukv-column-rule-img: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' height='2' width='1'%3E%3Cline x1='0' y1='0' x2='0' y2='1' style='stroke:%23e0e0e0;stroke-width:2' /%3E%3C/svg%3E")}[data-bukv-theme=sepia]{--bukv-text-color: #685f5e;--bukv-bg-color: #f2efec;--bukv-column-rule-img: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' height='2' width='1'%3E%3Cline x1='0' y1='0' x2='0' y2='1' style='stroke:%23e0e0e0;stroke-width:2' /%3E%3C/svg%3E")}[data-bukv-theme=dark]{--bukv-text-color: #fff;--bukv-bg-color: #212121;--bukv-column-rule-img: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' height='2' width='1'%3E%3Cline x1='0' y1='0' x2='0' y2='1' style='stroke:%23e0e0e0;stroke-width:2' /%3E%3C/svg%3E")}@media(max-width: 640px),(max-height: 640px){.bukv_wiki-table-wrapper{overflow:auto;max-height:100vh}}#page-secondary-actions,.infobox,.metadata,.mw-editsection,.mw-stack .infobox,.navbox,.reference span,.thumbcaption>.magnify,.toc,.vertical-navbox,div.portal,span.error,sup.Inline-Template,table.plainlinks{display:none !important}@media only screen and (max-width: 320px){.thumbcaption{display:none}}@media only screen and (min-width: 321px)and (max-width: 480px){.thumbcaption{display:none}}table{width:auto !important}table:not(.infobox){font-size:.8em}td>table.infobox{display:block !important}@media only screen and (max-width: 320px){.thumb.tleft,.thumb.tright{max-width:60%}}@media only screen and (min-width: 321px)and (max-width: 480px){.thumb.tleft,.thumb.tright{max-width:60%}}@media only screen and (min-width: 481px)and (max-width: 640px){.thumb.tleft,.thumb.tright{max-width:50%}}@media only screen and (min-width: 641px){.thumb.tleft,.thumb.tright{max-width:40%}}.mw-stack .thumb.tleft,.mw-stack .thumb.tright{max-width:none}table .thumb.tleft,table .thumb.tright{max-width:none}.thumbinner{overflow:visible;max-width:100% !important}.thumbinner *{max-width:100% !important;overflow:visible !important}.thumbcaption{font-family:"Open Sans",Arial,Helvetica,sans-serif;line-height:1.2em}span.IPA a{text-decoration:none}span.IPA a span{border:none !important}div.reflist{-webkit-column-count:1 !important;column-count:1 !important}div.column-count{-moz-column-count:1 !important;-webkit-column-count:1 !important;column-count:1 !important}div.references-column-width{-moz-column-width:auto !important;-webkit-column-width:auto !important;column-width:auto !important}blockquote.toccolours::after,blockquote.toccolours::before{content:none}html.lookup ol{margin-left:1.3em}html.lookup ol ul{margin-left:0}html.lookup ul{margin-left:1em}html.lookup dl dd{margin-left:.5em}html.lookup .NavFrame{margin-left:0 !important;font-size:.8em}html.lookup .toc{display:block !important;background-color:transparent !important}html.lookup .thumb{display:none}div.thumb .thumbimage,.gallerybox .thumb img{background-color:#fff}.mw-mf-image-replacement{display:none}div.tright,div.floatright,table.floatright{clear:right;float:right}div.tleft,div.floatleft,table.floatleft{float:left;clear:left}div.floatright,table.floatright,div.floatleft,table.floatleft{position:relative}.visualhide{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}body{background-image:none !important;font-family:"Noto Serif",Georgia,serif}body[wiki-lang=ko]{font-family:sans-serif}body *{-ms-user-select:text}a[href^="#"],a[href^="/wiki"]{color:inherit !important;background-image:linear-gradient(to right, currentColor 100%, currentColor 0);background-position:0 calc(100% - 2px);background-size:1px 1px;background-repeat:repeat-x}img{object-fit:fill !important}a.new,span.IPA a{pointer-events:none;cursor:default;background:0 0}a{color:inherit;text-decoration:none}a.external{padding-right:0;background:none;background-image:linear-gradient(to right, currentColor 50%, transparent 50%);background-position:0 calc(100% - 2px);background-size:4px 1px;background-repeat:repeat-x}a.external:visited{color:inherit}code,pre{font-family:"Source Code Pro","Courier New",Courier,monospace;word-break:break-word;font-style:normal}h1,h2,h3,h4,h5,h6{color:var(--bukv-text-color);border-bottom:0}`;

function getReversedCharInCodeRange(start, end, char) {
    const charCode = char.charCodeAt(0);
    if (charCode >= start && charCode <= end) {
        return String.fromCharCode(end - charCode + start);
    }
    return null;
}
function obfuscateHangul(char) {
    return getReversedCharInCodeRange(0xac00, 0xd7a3, char);
}
function deobfuscateHangul(char) {
    return getReversedCharInCodeRange(0xac00, 0xd7a3, char);
}
const alphabetMap = [
    'iljftrsczaxkyevguohnqbdpwmIJLSFZEPYTCRKBXAVGDUNHOQMW',
    'lijfrtszcxaykevgouhnbqpdwmIJSLFZEYPTCRBKXAVGUDHNQOMW',
];
function processAlphabet(fromMap, toMap, char) {
    const index = fromMap.indexOf(char);
    if (index !== -1) {
        return toMap[index];
    }
    return null;
}
function obfuscateAlphabet(char) {
    return processAlphabet(alphabetMap[0], alphabetMap[1], char);
}
function deobfuscateAlphabet(char) {
    return processAlphabet(alphabetMap[1], alphabetMap[0], char);
}
function processText(text, functions) {
    return text.replace(/\S/g, (char) => {
        for (const fn of functions) {
            const result = fn(char);
            if (result) {
                return result;
            }
        }
        return char;
    });
}
function obfuscateText(text) {
    return processText(text, [obfuscateAlphabet, obfuscateHangul]);
}
function deobfuscateText(text) {
    return processText(text, [deobfuscateAlphabet, deobfuscateHangul]);
}
function getRandomAlphabet() {
    return String.fromCharCode(getRandomNumber(97, 122));
}
function getRandomHangul() {
    return String.fromCharCode(getRandomNumber(0xac00, 0xd7a3));
}
function generateGarbageTagName() {
    const length = getRandomNumber(2, 5);
    let randomString = '';
    for (let i = 0; i < length; i++) {
        randomString += getRandomAlphabet();
    }
    for (let i = 0; i < 4; i++) {
        if (i === 0) {
            randomString += getRandomNumber(0, 9);
        }
        else if (i === 3) {
            randomString += getRandomAlphabet();
        }
        else {
            randomString +=
                Math.random() > 0.5 ? getRandomNumber(0, 9) : getRandomAlphabet();
        }
    }
    return randomString;
}
/**
 * 요소에 가비지 태그를 삽입하는 함수
 * @param element 가비지 태그를 삽입할 요소
 * @returns 삽입된 가비지 태그 이름들
 */
function insertGarbageTag(element) {
    const iterator = element.ownerDocument.createNodeIterator(element, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    const garbageTagNames = [];
    while (iterator.nextNode()) {
        textNodes.push(iterator.referenceNode);
    }
    const chunkSize = 8;
    textNodes.forEach((node) => {
        if (!node.nodeValue) {
            return;
        }
        const texts = node.nodeValue.split(/(\s+)/);
        const nodesWithGarbageTag = [];
        for (let i = 0; i < texts.length; i += chunkSize) {
            if (i !== 0) {
                const tagName = generateGarbageTagName();
                garbageTagNames.push(tagName);
                const garbageTag = element.ownerDocument.createElement(tagName);
                garbageTag.innerText = getRandomHangul();
                nodesWithGarbageTag.push(garbageTag);
            }
            const chunk = texts.slice(i, i + chunkSize);
            nodesWithGarbageTag.push(new Text(chunk.join('')));
        }
        node.replaceWith(...nodesWithGarbageTag);
    });
    return garbageTagNames;
}

function createHighlightStyleHTML(highlightStyles) {
    const basicStyle = highlightStyles
        .map((highlightStyle) => {
        return `x.${highlightStyle.styleClass}{${highlightStyle.style}}`;
    })
        .join('\n');
    const pointerStyle = highlightStyles
        .map((highlightStyle) => `x.${highlightStyle.styleClass}`)
        .join(',') + `{ cursor: pointer; }`;
    return `<style>${[basicStyle, pointerStyle].join('\n')}</style>`;
}
function flagClickHandledElements() {
    const _addEventListener = Element.prototype.addEventListener;
    Element.prototype.addEventListener = function (...args) {
        if (args[0] === 'click') {
            if ('setAttribute' in this) {
                this.setAttribute('data-bukv-click-handled', '');
            }
        }
        else if (args[0] === '_click') {
            args[0] = 'click';
        }
        if (_addEventListener) {
            _addEventListener.apply(this, args);
        }
    };
    const scriptElem = document.querySelector('script#flagClickHandledElements');
    scriptElem && scriptElem.parentElement?.removeChild(scriptElem);
}
function injectScript(doc, fn, scriptElemId) {
    const codeString = '(' + fn + ')();';
    const script = doc.createElement('script');
    script.textContent = codeString;
    if (scriptElemId) {
        script.id = scriptElemId;
    }
    doc.head.appendChild(script);
}
class ContentsProcessorService {
    constructor(_libConfig) {
        this._libConfig = _libConfig;
    }
    processContentsHTML(book, item, html) {
        const detachedDocument = document.implementation.createHTMLDocument('');
        detachedDocument.open();
        detachedDocument.write(html);
        detachedDocument.close();
        injectScript(detachedDocument, flagClickHandledElements, 'flagClickHandledElements');
        /**
         * html에 포함된 리소스들을 콘텐츠 서버 루트에서 가져와야 하는 경우
         */
        if (book.meta.type === BookType.Wiki) {
            detachedDocument.head.insertAdjacentHTML('afterbegin', `<base href="https://${book.meta.bid}.${isWiktionaryBid(book.meta.bid) ? 'wiktionary' : 'wikipedia'}.org"/>`);
        }
        else if (!book.meta.nobase) {
            detachedDocument.head.insertAdjacentHTML('afterbegin', `<base href="${this._libConfig.contentsBaseURL}/"/>`);
        }
        /**
         * 유저 에이전트 스타일 삭제 (순서 중요, 콘텐츠 스타일보다 앞에 와야함)
         */
        detachedDocument.head.insertAdjacentHTML('afterbegin', `<style>p{-webkit-margin-before:0em;-webkit-margin-after:0em;}</style>`);
        /**
         * 콘텐츠 폰트 스타일 추가
         */
        const bookLangauge = getISO639CodeFromBookLanguage(book.meta.languages[0]);
        const fontForBookLanguage = bookLangauge && this._libConfig.fonts[bookLangauge];
        if (fontForBookLanguage) {
            detachedDocument.head.insertAdjacentHTML('beforeend', fontForBookLanguage.fontFaces
                .map((fontFace) => {
                return `<link rel="stylesheet" href="${fontFace}">`;
            })
                .join('\n'));
            detachedDocument.head.insertAdjacentHTML('beforeend', '<style>' +
                fontForBookLanguage.fontFamilies
                    .map((fontFamily) => {
                    return `html[${FONT_FACE_SETTING_ATTR}="${fontFamily}"] * { font-family: ${fontFamily} !important; }`;
                })
                    .join('\n') +
                '</style>');
        }
        /**
         * 콘텐츠 스타일 추가
         */
        detachedDocument.head.insertAdjacentHTML('beforeend', `<style>${commonStyle}</style>`);
        if (item.iid === 'cover') {
            detachedDocument.head.insertAdjacentHTML('beforeend', `<style>${coverStyle}</style>`);
        }
        if (book.meta.type === BookType.Wiki) {
            detachedDocument.head.insertAdjacentHTML('beforeend', `<style>${wikiContentStyle}</style>`);
        }
        /**
         * 커스텀 콘텐츠 스타일 추가 - 외부 스타일
         */
        this._libConfig.contentsStyleURLs.forEach((style) => {
            detachedDocument.head.insertAdjacentHTML('beforeend', `<link rel="stylesheet" href="${style}" type="text/css">`);
        });
        /**
         * 커스텀 콘텐츠 스타일 추가 - 인라인 스타일 - 순서를 지정하기 위해 미리 태그만 추가, 내용은 런타임에 수정됨
         */
        detachedDocument.head.insertAdjacentHTML('beforeend', `<style id="${LIB_CONFIG_STYLE_ID}"></style>`);
        /**
         * 하이라이트 스타일 추가
         */
        detachedDocument.head.insertAdjacentHTML('beforeend', createHighlightStyleHTML(this._libConfig.highlightStyles));
        /**
         * 기타 조작 - '읽기 모드' 방지
         */
        if (book.meta.type !== BookType.Wiki) {
            Array.from(detachedDocument.querySelectorAll('p, div, span, h1, h2, h3, h4, h5, h6, li, blockquote, td, pre')).forEach((textElement) => {
                textElement.classList.add('comment');
                textElement.classList.add('comment-buk');
            });
        }
        /**
         * 기타 조작 - 이미지 드래그 방지
         */
        Array.from(detachedDocument.querySelectorAll('img')).forEach((element) => {
            element.setAttribute('draggable', 'false');
        });
        /**
         * 기타 조작 - 외부 링크 새 창으로 열게
         */
        Array.from(detachedDocument.querySelectorAll('a')).forEach((element) => {
            const href = element.getAttribute('href');
            const bukURLMatch = href?.match(/^(https?:\/\/buk\.io\/@)/);
            // 북이오 뷰어 위키 링크 처리
            if (bukURLMatch && element.getAttribute('target') !== '_blank') {
                const address = parseBukURL(href.substring(bukURLMatch[0].length - 1));
                if (isWikiBid(address.bid)) {
                    element.href = address.toString();
                    element.setAttribute(WIKI_URL_ATTR, '');
                }
            }
            // 그 외 외부 링크 처리
            if (href?.match(/^https?:\/\//) && !element.hasAttribute(WIKI_URL_ATTR)) {
                element.setAttribute('target', '_blank');
            }
        });
        /**
         * 기타 조작 - fixed layout
         */
        if (item.layout === 'fixed') {
            detachedDocument.body.style.width = item.fixedWidth + 'px';
            detachedDocument.body.style.height = item.fixedHeight + 'px';
        }
        /**
         * 기타 조작 - 미디어 오버레이 요소 체크
         */
        item.smil?.forEach((smilParItem) => {
            detachedDocument
                .getElementById(smilParItem.text_id)
                ?.setAttribute(SMIL_TEXT_ITEM_ATTR, '');
        });
        /**
         * multi column - column-rule 표시를 위해 body의 시작점이 자식 요소의 마진으로 인해 아래로 내려가지 않게
         */
        detachedDocument.body.insertAdjacentHTML('afterbegin', '<div style="width: 100px; height: 1px; margin-top: -1px;"></div>');
        /**
         * multi column - 커버 페이지에선 multi column 무시하도록
         */
        const isCover = item.iid === 'cover';
        /* && !detachedDocument.querySelector('.bu.cover.back')*/
        detachedDocument.documentElement.setAttribute('data-bukv-is-cover', isCover.toString());
        /**
         * page-list 요소 체크
         */
        book.page_list
            .filter((plItem) => plItem.iid === item.iid)
            .forEach((item) => {
            let anchorElement;
            if (item.anchor) {
                anchorElement = detachedDocument.getElementById(item.anchor);
            }
            else {
                anchorElement = detachedDocument.body;
            }
            anchorElement?.setAttribute(PAGE_LIST_ANCHOR_ATTR, item.page.toString());
        });
        /**
         * 현재 아이템의 buk 주소 지정
         */
        detachedDocument.documentElement.setAttribute(BASE_BUK_URL_ATTR, createBukURL(book.meta.bid, item.iid, undefined, book.meta.version ? { version: book.meta.version } : undefined));
        /**
         * 스크롤 모드에서 페이지 모드와 같은 방식으로 현재 페이지를 계산하기 위해 쓰이는 요소 추가
         */
        detachedDocument.body.insertAdjacentHTML('beforeend', `<div id="${PAGE_FILLER_ID}"></div>`);
        /**
         * 위키피디아 테이블 처리
         */
        if (book.meta.type === BookType.Wiki) {
            Array.from(detachedDocument.body.querySelectorAll('table:not(.infobox)')).forEach((table) => {
                table.outerHTML = `<div class="bukv_wiki-table-wrapper">${table.outerHTML}</div>`;
            });
        }
        const textContent = detachedDocument.body.textContent || '';
        /**
         * 난독화
         */
        if (this._libConfig.enableEpubObfuscation) {
            let tagNames = [];
            detachedDocument.querySelectorAll('p').forEach((p) => {
                tagNames = tagNames.concat(insertGarbageTag(p));
            });
            const styles = tagNames
                .map((tagName) => `<style>${tagName}{display: none;}</style>`)
                .join('');
            // const styles = tagNames
            //   .map(
            //     (tagName) =>
            //       `<style>${tagName}{float:left;width:0;height:0;overflow:hidden;font-size:0;}</style>`
            //   )
            //   .join('');
            // const styles = tagNames
            //   .map(
            //     (tagName) =>
            //       `<style>${tagName}{pointer-events:none;position:absolute;color:transparent;}${tagName}::selection{background:transparent;}</style>`
            //   )
            //   .join('');
            detachedDocument.body.insertAdjacentHTML('beforeend', styles);
        }
        return {
            html: detachedDocument.documentElement.outerHTML,
            textContent,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: ContentsProcessorService, deps: [{ token: LibConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: ContentsProcessorService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: ContentsProcessorService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: LibConfigService }] });

class LRUCache {
    constructor(_max = 10) {
        this._max = _max;
        this._cache = new Map();
    }
    get(key) {
        const item = this._cache.get(key);
        if (item !== undefined) {
            this._cache.delete(key);
            this._cache.set(key, item);
        }
        return item;
    }
    getFirst() {
        return this._cache.keys().next().value;
    }
    set(key, val) {
        if (this.has(key)) {
            this._cache.delete(key);
        }
        else if (this._cache.size === this._max) {
            this._cache.delete(this.getFirst());
        }
        this._cache.set(key, val);
    }
    has(key) {
        return this._cache.has(key);
    }
}

class PDFImageLoaderService {
    constructor(_contentsService) {
        this._contentsService = _contentsService;
        this._cache = new LRUCache(6);
    }
    preload(imageURL) {
        this._loadAndSaveCache(imageURL).subscribe();
    }
    load(imageURL) {
        const cached = this._cache.get(imageURL);
        if (cached) {
            return cached;
        }
        return this._loadAndSaveCache(imageURL);
    }
    _loadAndSaveCache(imageURL) {
        return this._contentsService.getPDFImage(imageURL).pipe(tap((image) => {
            this._cache.set(imageURL, image);
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: PDFImageLoaderService, deps: [{ token: ContentsService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: PDFImageLoaderService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: PDFImageLoaderService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: ContentsService }] });

function resolveClockValue(value) {
    let hours = 0;
    let mins = 0;
    let secs = 0;
    if (value.indexOf('min') !== -1) {
        mins = parseFloat(value.substr(0, value.indexOf('min')));
    }
    else if (value.indexOf('ms') !== -1) {
        const ms = parseFloat(value.substr(0, value.indexOf('ms')));
        secs = ms / 1000;
    }
    else if (value.indexOf('s') !== -1) {
        secs = parseFloat(value.substr(0, value.indexOf('s')));
    }
    else if (value.indexOf('h') !== -1) {
        hours = parseFloat(value.substr(0, value.indexOf('h')));
    }
    else {
        const arr = value.split(':');
        secs = parseFloat(arr.pop());
        if (arr.length > 0) {
            mins = parseFloat(arr.pop());
            if (arr.length > 0) {
                hours = parseFloat(arr.pop());
            }
        }
    }
    return hours * 3600 + mins * 60 + secs;
}

const INTERVAL_TIME = 20;
function canSetCurrentTimeOnCanPlay(testSrc) {
    return new Observable((observer) => {
        const audio = new Audio();
        audio.oncanplay = () => {
            audio.oncanplay = null;
            audio.currentTime = audio.duration;
            observer.next(audio.currentTime === audio.duration);
            observer.complete();
        };
        audio.src = testSrc;
        audio.load();
    });
}
class MediaOverlayPlayer {
    constructor() {
        this._audio = new Audio();
        this._playbackRate = 1;
        this._clipEnded$ = new Subject();
        this.clipEnded$ = this._clipEnded$.asObservable();
        this.useBlobSrc = false;
    }
    setPlaybackRate(value) {
        this._playbackRate = value;
        this._audio.playbackRate = value;
    }
    playClip(src, clipStart = 0, clipEnd) {
        this._clipEndSubscription?.unsubscribe();
        this._clipEnd$ = interval(INTERVAL_TIME).pipe(startWith(), skipWhile(() => {
            if (clipEnd) {
                if (clipEnd > this._audio.duration) {
                    return this._audio.currentTime < this._audio.duration;
                }
                return this._audio.currentTime < clipEnd;
            }
            if (!isNaN(this._audio.duration)) {
                return this._audio.currentTime < this._audio.duration;
            }
            return true;
        }), take(1));
        if (this._audio.dataset.src === src) {
            if (Math.abs(clipStart - this._audio.currentTime) >= 0.3) {
                this._audio.currentTime = clipStart;
            }
            this.play();
            return;
        }
        this._audio.dataset.src = src;
        const onSrcLoad = (_src) => {
            const eventName = MO_NOT_WORKING_ON_CAN_PLAY
                ? 'oncanplaythrough'
                : 'oncanplay';
            this._audio[eventName] = () => {
                this._audio[eventName] = null;
                this._audio.playbackRate = this._playbackRate;
                this._audio.currentTime = clipStart;
            };
            this._audio.src = _src;
            this._audio.load();
            this.play();
        };
        if (this.useBlobSrc) {
            // clear previous resources
            this._abortBlobSrcRequest?.();
            URL.revokeObjectURL(this._audio.src);
            // create blob src request
            const request = new XMLHttpRequest();
            this._abortBlobSrcRequest = () => {
                request.abort();
            };
            request.open('GET', src, true);
            request.responseType = 'blob';
            request.onload = () => {
                if (request.status === 200 && this._audio.dataset.src === src) {
                    onSrcLoad(URL.createObjectURL(request.response));
                    this._abortBlobSrcRequest = undefined;
                }
            };
            request.send();
        }
        else {
            onSrcLoad(src);
        }
    }
    play() {
        this._play();
    }
    pause() {
        this._pause();
    }
    destroy() {
        this._pause();
        this._clipEnded$.complete();
    }
    _play() {
        this._clipEndSubscription?.unsubscribe();
        if (!this._clipEnd$) {
            return;
        }
        this._audio.play();
        this._clipEndSubscription = this._clipEnd$.subscribe(() => {
            this._clipEnded$.next();
        });
    }
    _pause() {
        this._clipEndSubscription?.unsubscribe();
        this._audio.pause();
    }
}

function isSamePosition(p1, p2) {
    return p1.iid === p2.iid && p1.parIndex === p2.parIndex;
}
class MediaOverlay {
    constructor(book) {
        this._currentPosition$ = new BehaviorSubject(undefined);
        this.currentPosition$ = this._currentPosition$.asObservable();
        this._player = new MediaOverlayPlayer();
        const testSMILItem = book.items.find((bookItem) => bookItem.smil && bookItem.smil.length > 0)?.smil;
        const testSrc = testSMILItem && testSMILItem[0].audio_url;
        if (testSrc) {
            canSetCurrentTimeOnCanPlay(testSrc)
                .pipe(timeout(1000), catchError(() => of(true)))
                .subscribe((can) => {
                this._player.useBlobSrc = !can;
                if (!can) {
                    console.log('use blob src');
                }
            });
        }
        this._iidSMILMap = book.items.reduce((result, bookItem) => {
            result[bookItem.iid] = (bookItem.smil ?? [])
                .map((par) => {
                return {
                    ...par,
                    clipBegin: par.clip_begin
                        ? resolveClockValue(par.clip_begin)
                        : undefined,
                    clipEnd: par.clip_end
                        ? resolveClockValue(par.clip_end)
                        : undefined,
                };
            })
                .filter((par) => par.audio_url);
            return result;
        }, {});
    }
    get clipEnded$() {
        return this._player.clipEnded$;
    }
    get currentPosition() {
        return this._currentPosition$.value;
    }
    set currentPosition(position) {
        if (position) {
            const __lastPausedPosition = this._lastPausedPosition;
            this._lastPausedPosition = undefined;
            if (position === __lastPausedPosition) {
                this._player.play();
            }
            else {
                const par = this.getParByPosition(position);
                if (!par) {
                    throw new Error('invalid media overlay position');
                }
                this._playPar(par);
            }
        }
        else {
            this._player.pause();
        }
        this._currentPosition$.next(position);
    }
    get lastPausedPosition() {
        return this._lastPausedPosition;
    }
    get isPlaying() {
        return !!this.currentPosition;
    }
    _getPrevOrNextPosition(isNext) {
        if (!this.currentPosition) {
            return undefined;
        }
        // 현재 아이템 내에 다음 미디어 오버레이 포지션이 있는 경우
        const currentIid = this.currentPosition.iid;
        let newParIndex = this.currentPosition.parIndex + (isNext ? 1 : -1);
        if (this._iidSMILMap[currentIid][newParIndex]) {
            return {
                iid: currentIid,
                parIndex: newParIndex,
            };
        }
        // 현재 아이템 내에 다음 미디어 오버레이 포지션이 없는 경우 -> 다른 아이템에서 찾음
        const iids = Object.keys(this._iidSMILMap);
        const newIid = findItemToDirection(iids, isNext ? 1 : -1, (iid) => this._iidSMILMap[iid].length > 0, iids.indexOf(currentIid));
        if (newIid) {
            newParIndex = isNext ? 0 : this._iidSMILMap[newIid].length - 1;
            if (this._iidSMILMap[newIid][newParIndex]) {
                return {
                    iid: newIid,
                    parIndex: newParIndex,
                };
            }
        }
        return undefined;
    }
    getNextPosition() {
        return this._getPrevOrNextPosition(true);
    }
    getPrevPosition() {
        return this._getPrevOrNextPosition(false);
    }
    getParByPosition(position) {
        return this._iidSMILMap[position.iid][position.parIndex];
    }
    getPositionByTextId(iid, textId) {
        const parIndex = this._iidSMILMap[iid].findIndex((par) => par.text_id === textId);
        if (parIndex === -1) {
            return undefined;
        }
        return { iid, parIndex };
    }
    setPlaybackRate(value) {
        this._player.setPlaybackRate(value);
    }
    play(position) {
        this.currentPosition = position;
    }
    pause() {
        this._lastPausedPosition = this.currentPosition;
        this.stop();
    }
    stop() {
        this.currentPosition = undefined;
    }
    destroy() {
        this.stop();
        this._currentPosition$.complete();
        this._player.destroy();
    }
    _playPar(par) {
        if (!par.audio_url) {
            return false;
        }
        this._player.playClip(par.audio_url, par.clipBegin, par.clipEnd);
        return true;
    }
}

class EnterZoneScheduler {
    constructor(zone, scheduler) {
        this.zone = zone;
        this.scheduler = scheduler;
    }
    schedule(...args) {
        return this.zone.run(() => this.scheduler.schedule.apply(this.scheduler, args));
    }
}
function enterZone(zone) {
    return new EnterZoneScheduler(zone, asyncScheduler);
}

const LAST_PPAGE$1 = 0.9999999;
function calculatePPageFromPage(page, totalPageCount) {
    const pPage = Math.ceil(parseFloat(((page - 1) / totalPageCount).toPrecision(8)) * 10000000) / 10000000;
    return clamp(0, pPage, LAST_PPAGE$1);
}
function calculatePageFromPPage(pPage, totalPageCount) {
    const page = Math.round(totalPageCount * pPage) + 1;
    return clamp(1, page, totalPageCount);
}
function getContentsScale(pageSize, contentsSize) {
    if (pageSize.width / pageSize.height >
        contentsSize.width / contentsSize.height) {
        return pageSize.height / contentsSize.height;
    }
    else {
        return pageSize.width / contentsSize.width;
    }
}

function isSameAnnotation(annot1, annot2) {
    return (isSameAddress(annot1.address, annot2.address) &&
        annot1.styleClass === annot2.styleClass);
}
function getDeletedAnnotations(oldAnnotations, newAnnotations) {
    return oldAnnotations.filter((oldAnnot) => {
        return !newAnnotations.find((newAnnot) => {
            return isSameAnnotation(oldAnnot, newAnnot);
        });
    });
}

function getPageChangeDirectionFromKeyboardEvent(event) {
    switch (event.key) {
        case 'Left':
        case 'ArrowLeft':
        case 'Up':
        case 'ArrowUp':
        case 'PageUp':
            return Direction.Prev;
        case 'Right':
        case 'ArrowRight':
        case 'Down':
        case 'ArrowDown':
        case 'PageDown':
            return Direction.Next;
        default:
            return null;
    }
}

function fromUserScrollEvent(target) {
    return fromEvent(target, 'scroll').pipe(timestamp(), //
    pairwise(), //
    filter(([v1, v2]) => v2.timestamp - v1.timestamp < 150), // 프로그램에 의한 scroll 무시
    map(([, v2]) => v2.value));
}
function fromResizeEvent(target) {
    return new Observable((observer) => {
        const resizeObserver = new ResizeObserver((entries) => {
            observer.next(entries[0].borderBoxSize[0].inlineSize);
        });
        resizeObserver.observe(target);
        return () => {
            resizeObserver.unobserve(target);
        };
    }).pipe(startWith(undefined), pairwise(), filter(([w1, w2]) => w1 !== w2), debounceTime(300), map(() => undefined));
}
var SwipeDirection;
(function (SwipeDirection) {
    SwipeDirection[SwipeDirection["Left"] = -1] = "Left";
    SwipeDirection[SwipeDirection["Right"] = 1] = "Right";
})(SwipeDirection || (SwipeDirection = {}));
function fromSwipeEvent(target) {
    const touchstart$ = fromEvent(target, 'touchstart', { passive: true });
    const touchmove$ = fromEvent(target, 'touchmove', { passive: true });
    const touchend$ = fromEvent(target, 'touchend', { passive: true });
    return touchstart$.pipe(map((event) => {
        return {
            timeDown: Date.now(),
            xDown: event.touches[0].clientX,
            yDown: event.touches[0].clientY,
            xDiff: 0,
            yDiff: 0,
            maxTouchLength: event.touches.length,
        };
    }), switchMap((initialState) => {
        return touchmove$.pipe(takeUntil(touchend$), scan((state, event) => {
            state.xDiff = state.xDown - event.touches[0].clientX;
            state.yDiff = state.yDown - event.touches[0].clientY;
            state.maxTouchLength = Math.max(state.maxTouchLength, event.touches.length);
            return state;
        }, initialState), takeLast(1), map((state) => {
            if (state.maxTouchLength > 1) {
                return 0;
            }
            const timeDiff = Date.now() - state.timeDown;
            if (Math.abs(state.xDiff) > Math.abs(state.yDiff)) {
                if (Math.abs(state.xDiff) > 20 && timeDiff < 500) {
                    return state.xDiff > 0
                        ? SwipeDirection.Left
                        : SwipeDirection.Right;
                }
            }
            return 0;
        }), filter((dir) => dir !== 0));
    }));
}
function getCenter(events) {
    const pointersLength = events.length;
    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: Math.round(events[0].clientX),
            y: Math.round(events[0].clientY),
        };
    }
    let x = 0;
    let y = 0;
    let i = 0;
    while (i < pointersLength) {
        x += events[i].clientX;
        y += events[i].clientY;
        i++;
    }
    return {
        x: Math.round(x / pointersLength),
        y: Math.round(y / pointersLength),
    };
}
function fromClickEvent(target, isEpub) {
    // const click$ = fromEvent<MouseEvent>(target, isEpub ? '_click' : 'click');
    // const pointerdown$ = fromEvent<PointerEvent>(target, 'pointerdown');
    // const _click$ = pointerdown$.pipe(
    //   switchMap((downEvent) => {
    //     console.warn(downEvent);
    //     const startX = Math.floor(downEvent.screenX);
    //     const startY = Math.floor(downEvent.screenY);
    //     return click$.pipe(
    //       first(),
    //       filter((event) => {
    //         console.warn('dfsdfsf', startX, startY, event.screenX, event.screenY);
    //         return event.screenX === startX && event.screenY === startY;
    //       }),
    //     );
    //   }),
    // );
    // return _click$.pipe(
    //   buffer(_click$.pipe(debounceTime(250))),
    //   filter((events) => events.length <= 2),
    //   map((events) => {
    //     return {
    //       type: events.length === 1 ? 'single' : 'double',
    //       center: getCenter(events),
    //       target: events[events.length - 1].target ?? target,
    //       srcEvents: events,
    //       viewerDefaultPrevented: events.some(
    //         (event) => (event as any).bukvEventHandled,
    //       ),
    //     };
    //   }),
    // );
    return new Observable((subscriber) => {
        let startX;
        let startY;
        let clicks = [];
        let clickEndTimeoutId = undefined;
        const clickEndHandler = () => {
            if (clicks.length <= 2) {
                subscriber.next({
                    type: clicks.length === 1 ? 'single' : 'double',
                    center: getCenter(clicks),
                    target: clicks[clicks.length - 1].target ?? target,
                    srcEvents: clicks,
                    viewerDefaultPrevented: clicks.some((event) => event.bukvEventHandled),
                });
            }
            clicks = [];
        };
        const clickHandler = (event) => {
            if (startX == null || startY == null) {
                return;
            }
            if (Math.abs(event.screenX - startX) < 5 &&
                Math.abs(event.screenY - startY) < 5) {
                if (clickEndTimeoutId != null) {
                    window.clearTimeout(clickEndTimeoutId);
                }
                clicks.push(event);
                clickEndTimeoutId = window.setTimeout(() => clickEndHandler(), 250);
            }
        };
        const pointerdownHandler = (event) => {
            if (event.bukvEventHandled) {
                startX = null;
                startY = null;
            }
            else {
                startX = event.screenX;
                startY = event.screenY;
            }
        };
        const clickEventName = (isEpub ? '_click' : 'click');
        target.addEventListener(clickEventName, clickHandler);
        target.addEventListener('pointerdown', pointerdownHandler);
        return () => {
            if (clickEndTimeoutId != null) {
                window.clearTimeout(clickEndTimeoutId);
            }
            target.removeEventListener(clickEventName, clickHandler);
            target.removeEventListener('pointerdown', pointerdownHandler);
            clicks = [];
        };
    });
}
function fromPageChangeKeydownEvent(target) {
    return fromEvent(target, 'keydown').pipe(map((event) => {
        const direction = getPageChangeDirectionFromKeyboardEvent(event);
        if (direction != null) {
            event.preventDefault();
        }
        return direction;
    }), filter((x) => x !== null), throttleTime(200));
}
function fromDoubleClickEvent(target) {
    return fromEvent(target, 'mousedown').pipe(filter((event) => event.detail === 2));
}
function fromHammerPinchEvent(target, touchAction) {
    return new Observable((observer) => {
        if (touchAction) {
            Hammer.defaults.touchAction = touchAction;
        }
        const hammer = new Hammer(target);
        hammer.get('pinch').set({ enable: true });
        const handler = (event) => {
            if (event.maxPointers > 2) {
                return;
            }
            observer.next(event);
        };
        hammer.on('pinchend pinchstart pinchin pinchout pinchcancel', handler);
        if (touchAction) {
            Hammer.defaults.touchAction = 'compute';
        }
        return () => {
            hammer.off('pinchend pinchstart pinchin pinchout pinchcancel', handler);
            hammer.destroy();
        };
    });
}

var FrameLayout;
(function (FrameLayout) {
    FrameLayout["Column"] = "column";
    FrameLayout["Scroll"] = "scroll";
    FrameLayout["Fixed"] = "fixed";
})(FrameLayout || (FrameLayout = {}));

const PAGE_CHANGE_GESTURE_AREA = 0.2;

function getDocumentFromRange(range) {
    if (range.startContainer instanceof Document) {
        return range.startContainer;
    }
    return range.startContainer.ownerDocument;
}
function getBoundingClientRect(range) {
    const rect = getRectFromDOMRect(range.getBoundingClientRect());
    const rangeDoc = getDocumentFromRange(range);
    const frameElement = rangeDoc.defaultView?.frameElement;
    if (frameElement) {
        const frameBoundingRect = frameElement.getBoundingClientRect();
        const zoom = frameBoundingRect.width / frameElement.contentWindow.innerWidth;
        rect.x *= zoom;
        rect.y *= zoom;
        rect.width *= zoom;
        rect.height *= zoom;
        rect.x += frameBoundingRect.left;
        rect.y += frameBoundingRect.top;
    }
    return rect;
}
function getClientRects(range) {
    const rects = Array.from(range.getClientRects()).map(getRectFromDOMRect);
    const rangeDoc = getDocumentFromRange(range);
    const frameElement = rangeDoc.defaultView?.frameElement;
    if (frameElement) {
        const frameBoundingRect = frameElement.getBoundingClientRect();
        const zoom = frameBoundingRect.width / frameElement.contentWindow.innerWidth;
        rects.forEach((rect) => {
            rect.x *= zoom;
            rect.y *= zoom;
            rect.width *= zoom;
            rect.height *= zoom;
            rect.x += frameBoundingRect.left;
            rect.y += frameBoundingRect.top;
        });
    }
    return rects;
}
function createRangeFromNodes(startNode, endNode) {
    const doc = startNode.ownerDocument;
    if (!doc) {
        throw new Error('cannot get owner document');
    }
    const startRange = doc.createRange();
    startRange.selectNodeContents(startNode);
    const endRange = doc.createRange();
    endRange.selectNodeContents(endNode);
    const range = doc.createRange();
    range.setStart(startRange.startContainer, startRange.startOffset);
    range.setEnd(endRange.endContainer, endRange.endOffset);
    return range;
}
function findStart(root, start, end, horizontal) {
    const stack = [root];
    let $el;
    let found;
    let $prev = root;
    while (stack.length) {
        $el = stack.shift();
        found = walk($el, (node) => {
            let left, right, top, bottom;
            // let elPos;
            // let elRange;
            const elPos = nodeBounds(node);
            if (horizontal) {
                left = elPos.left;
                right = elPos.right;
                if (left >= start && left <= end) {
                    return node;
                }
                else if (right > start) {
                    return node;
                }
                else {
                    $prev = node;
                    stack.push(node);
                }
            }
            else {
                top = elPos.top;
                bottom = elPos.bottom;
                if (top >= start && top <= end) {
                    return node;
                }
                else if (bottom > start) {
                    return node;
                }
                else {
                    $prev = node;
                    stack.push(node);
                }
            }
        });
        if (found) {
            return findTextStartRange(found, start, end, horizontal);
        }
    }
    // Return last element
    return findTextStartRange($prev, start, end, horizontal);
}
function findEnd(root, start, end, horizontal) {
    const stack = [root];
    let $el;
    let $prev = root;
    let found;
    while (stack.length) {
        $el = stack.shift();
        found = walk($el, (node) => {
            let left, right, top; //, bottom;
            // var elPos;
            // var elRange;
            const elPos = nodeBounds(node);
            if (horizontal) {
                left = Math.round(elPos.left);
                right = Math.round(elPos.right);
                if (left > end && $prev) {
                    return $prev;
                }
                else if (right > end) {
                    return node;
                }
                else {
                    $prev = node;
                    stack.push(node);
                }
            }
            else {
                top = Math.round(elPos.top);
                // bottom = Math.round(elPos.bottom);
                if (top > end && $prev) {
                    return $prev;
                } /*else if (bottom > end) { // 아래의 가장 '오른쪽' 요소를 찾기 위해 이 조건은 사용하지 않음
                  return node;
                } */
                else {
                    $prev = node;
                    stack.push(node);
                }
            }
        });
        if (found) {
            return findTextEndRange(found, start, end, horizontal);
        }
    }
    // end of chapter
    return findTextEndRange($prev, start, end, horizontal);
}
function findTextStartRange(node, start, end, horizontal) {
    const ranges = splitTextNodeIntoRanges(node);
    let range;
    let pos;
    let left, top, right, bottom;
    // let prev;
    for (let i = 0; i < ranges.length; i++) {
        range = ranges[i];
        pos = range.getBoundingClientRect();
        if (horizontal) {
            left = pos.left;
            right = pos.right;
            if (left >= start) {
                return range;
            }
            else if (right >= start) {
                //
                return range;
            }
        }
        else {
            top = pos.top;
            bottom = pos.bottom;
            if (top >= start) {
                return range;
            }
            else if (bottom >= start) {
                //
                return range;
            }
        }
        // prev = range;
    }
    return ranges[0];
}
function findTextEndRange(node, start, end, horizontal) {
    const ranges = splitTextNodeIntoRanges(node);
    let prev;
    let range;
    let pos;
    let left, right, top, bottom;
    for (let i = 0; i < ranges.length; i++) {
        range = ranges[i];
        pos = range.getBoundingClientRect();
        if (horizontal) {
            left = pos.left;
            right = pos.right;
            if (right > end && prev) {
                return prev;
            } /*else if (right > end) { // 다음 페이지에 있는 문자 사용하지 않도록 하기 위해 이 조건은 사용하지 않음
              return range;
            }*/
        }
        else {
            top = Math.round(pos.top);
            bottom = Math.round(pos.bottom);
            if (top > end && prev) {
                return prev;
            } /*else if (bottom > end) { // 아래의 가장 '오른쪽' 문자를 찾기 위해 이 조건은 사용하지 않음
              return range;
            }*/
        }
        prev = range;
    }
    // Ends before limit
    return ranges[ranges.length - 1];
}
function splitTextNodeIntoRanges(node) {
    if (node.nodeType !== Node.TEXT_NODE) {
        const range = node.ownerDocument.createRange();
        range.selectNodeContents(node);
        return [range];
    }
    return textNodeToRangeArray(node);
}
function textNodeToRangeArray(textNode) {
    const rangeArray = [];
    const text = textNode.textContent || '';
    for (let i = 0; i < text.length; i++) {
        const range = document.createRange();
        range.setStart(textNode, i);
        range.setEnd(textNode, i + 1);
        rangeArray.push(range);
    }
    return rangeArray;
}
function nodeBounds(node) {
    let elPos;
    const doc = node.ownerDocument;
    if (node.nodeType === Node.TEXT_NODE) {
        const elRange = doc.createRange();
        elRange.selectNodeContents(node);
        elPos = elRange.getBoundingClientRect();
    }
    else {
        elPos = node.getBoundingClientRect();
    }
    return elPos;
}
function walk(root, func) {
    // IE11 has strange issue, if root is text node IE throws exception on
    // calling treeWalker.nextNode(), saying
    // Unexpected call to method or property access instead of returning null value
    if (root && root.nodeType === Node.TEXT_NODE) {
        return;
    }
    // safeFilter is required so that it can work in IE as filter is a function for IE
    // and for other browser filter is an object.
    const filter = {
        acceptNode: (node) => {
            if (node.data.trim().length > 0) {
                return NodeFilter.FILTER_ACCEPT;
            }
            else {
                return NodeFilter.FILTER_REJECT;
            }
        },
    };
    // const safeFilter = filter.acceptNode;
    // safeFilter.acceptNode = filter.acceptNode;
    const treeWalker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, filter);
    let node;
    let result;
    while ((node = treeWalker.nextNode())) {
        result = func(node);
        if (result) {
            break;
        }
    }
    return result;
}

function createFontLoadFinishObserver(observeTarget) {
    return new Observable((observer) => {
        const currentFontFamily = observeTarget.ownerDocument
            .defaultView.getComputedStyle(observeTarget)
            .fontFamily.split(',')[0]
            .replace(/"/g, '')
            .trim();
        if (!currentFontFamily) {
            observer.next(true);
            observer.complete();
            return;
        }
        const ffo = new FontFaceObserver(currentFontFamily);
        ffo.load(null, 1000 * 5).finally(() => {
            // console.log(
            //   `font loading time - ${currentFontFamily} : ${(
            //     (performance.now() - loadStartTime) /
            //     1000
            //   ).toFixed(2)}s`
            // );
            observer.next(true);
            observer.complete();
        });
    });
}

class FrameBaseComponent {
    constructor() {
        this.frameSelectionChange = new EventEmitter();
        this.framePageChangeKeydown = new EventEmitter();
        this.frameHighlightClick = new EventEmitter();
        this.frameDoubleClick = new EventEmitter();
        this.frameClick = new EventEmitter();
        this.frameSwipe = new EventEmitter();
        this.framePinch = new EventEmitter();
    }
    get _document() {
        throw new Error('not implemented');
    }
    querySelectorAll(selector) {
        try {
            return Array.from(this._document?.querySelectorAll(selector) ?? []);
        }
        catch (error) {
            console.warn(error);
            return [];
        }
    }
    querySelector(selector) {
        try {
            return this._document?.querySelector(selector) ?? null;
        }
        catch (error) {
            console.warn(error);
            return null;
        }
    }
    containsRange(range) {
        const rangeDocument = getDocumentFromRange(range);
        return this._document === rangeDocument;
    }
    hasSelection() {
        const selection = this._document?.getSelection();
        return !!selection && !selection.isCollapsed;
    }
    clearSelection() {
        const selection = this._document?.getSelection();
        if (selection?.rangeCount === 0) {
            this._emitEmptySelectionChangeEvent();
        }
        else {
            selection?.removeAllRanges();
        }
    }
    createRangeFromElements(startId, endId) {
        if (!this._document) {
            throw new Error('no active document');
        }
        const startElem = this.querySelector(`#${startId}`);
        const endElem = this.querySelector(`#${endId}`);
        if (!startElem || !endElem) {
            throw new Error('no elements were found with the given id');
        }
        return createRangeFromNodes(startElem, endElem);
    }
    _emitEmptySelectionChangeEvent() {
        this._document &&
            this.frameSelectionChange.emit({
                selection: null,
                doc: this._document,
            });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: FrameBaseComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.3", type: FrameBaseComponent, selector: "ng-component", outputs: { frameSelectionChange: "frameSelectionChange", framePageChangeKeydown: "framePageChangeKeydown", frameHighlightClick: "frameHighlightClick", frameDoubleClick: "frameDoubleClick", frameClick: "frameClick", frameSwipe: "frameSwipe", framePinch: "framePinch" }, ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: FrameBaseComponent, decorators: [{
            type: Component,
            args: [{ template: '' }]
        }], propDecorators: { frameSelectionChange: [{
                type: Output
            }], framePageChangeKeydown: [{
                type: Output
            }], frameHighlightClick: [{
                type: Output
            }], frameDoubleClick: [{
                type: Output
            }], frameClick: [{
                type: Output
            }], frameSwipe: [{
                type: Output
            }], framePinch: [{
                type: Output
            }] } });

function createHighlightIdFromAnnotation(annotation) {
    if (!annotation.address.range) {
        throw new Error();
    }
    return createHighlightId(annotation.address.range, annotation.styleClass);
}
class HighlightableFrameComponent extends FrameBaseComponent {
    constructor(_libConfig) {
        super();
        this._userHighlightClasses = _libConfig.highlightStyles.map((style) => style.styleClass);
    }
    get _baseURL() {
        return (this._document?.documentElement.getAttribute(BASE_BUK_URL_ATTR) ??
            undefined);
    }
    getContentsSelection() {
        const selection = this._document?.getSelection();
        if (!selection || selection.isCollapsed || selection.rangeCount === 0) {
            return null;
        }
        const range = selection.getRangeAt(0);
        let url = null;
        if (!isSelectionStringEmpty(selection)) {
            const address = parseBukURL(this._baseURL);
            const hSelection = this._highlighter.select(this._document, range);
            if (hSelection) {
                address.anchor = hSelection.address;
                url = address.toString();
            }
        }
        return {
            rect: getBoundingClientRect(range),
            rects: getClientRects(range),
            range,
            url,
        };
    }
    //
    highlightAnnotation(annotation) {
        if (!annotation.address.range || !this._document) {
            return;
        }
        const highlightId = createHighlightIdFromAnnotation(annotation);
        const selector = this._highlighter.createSelectorString(highlightId);
        if (this.querySelector(selector)) {
            return;
        }
        try {
            this._highlighter.highlight(this._document, annotation.address.range, annotation.styleClass, highlightId);
        }
        catch (error) {
            console.log('highlight error >>>>', error);
        }
    }
    unhighlightAnnotation(annotation) {
        if (!annotation.address.range || !this._document) {
            return;
        }
        try {
            this._highlighter.remove(this._document, createHighlightIdFromAnnotation(annotation));
        }
        catch (error) {
            console.log('unhighlight error >>>>', error);
        }
    }
    //
    highlightAnchor(anchor, color) {
        if (!isBukAnchor(anchor) || !this._document) {
            return;
        }
        const hId = this._highlighter.highlight(this._document, anchor, ANCHOR_HIGHLIGHT_CLASS);
        if (!hId) {
            return;
        }
        const hElements = this.querySelectorAll(this._highlighter.createSelectorString(hId));
        hElements.forEach((element) => {
            element.setAttribute('style', `background-color: ${color}`);
        });
    }
    clearAnchorHighlight() {
        const anchorElem = this.getHighlightElements(undefined, ANCHOR_HIGHLIGHT_CLASS);
        if (anchorElem.length === 0) {
            return;
        }
        const anchorElemId = this._highlighter.getHighlightIdFromElement(anchorElem[0]);
        if (!anchorElemId) {
            return;
        }
        this._highlighter.remove(this._document, anchorElemId);
    }
    //
    createBookmark() {
        if (!this._document) {
            return null;
        }
        const selection = getFirstVisibleSelection(this._document);
        if (selection) {
            const id = this._highlighter.highlight(this._document, selection.address, BOOKMARK_HIGHLIGHT_CLASS, createHighlightId(selection.address, BOOKMARK_HIGHLIGHT_CLASS));
            if (id != null) {
                return createAnnotation(this._baseURL, AnnotationType.Bookmark, selection);
            }
        }
        return null;
    }
    createHighlight(range, styleClass, options) {
        if (!this._document) {
            throw new Error('document not defined');
        }
        range = this._toHighlightableRange(range);
        // 단어 단위 확장
        if (options.expandToWord !== false) {
            const selection = this._document.getSelection();
            selection?.removeAllRanges();
            selection?.addRange(range);
            this._highlighter.expandToWord(this._document);
            const expandedRange = this._document.getSelection()?.getRangeAt(0);
            if (expandedRange) {
                range = expandedRange;
            }
        }
        let selection = this._highlighter.select(this._document, range);
        // 머지
        const mergedAnnotations = [];
        const mergedHighlightIds = [];
        if (options.mergeWith && options.mergeWith.length > 0) {
            const { selections, styleClassMap } = this._getRelatedHighlights(selection);
            if (selections.length > 0) {
                const mergeTargetSelections = selections.filter((selection) => {
                    const styleClass = styleClassMap.get(selection);
                    return styleClass && options.mergeWith.indexOf(styleClass) !== -1;
                });
                const addresses = [selection.address].concat(mergeTargetSelections.map((s) => s.address));
                const mergedAddress = mergeAddress(addresses);
                const mergedRange = this._highlighter.getRangeFromAddress(this._document, mergedAddress);
                if (mergedRange) {
                    range = mergedRange;
                    selection = this._highlighter.select(this._document, range);
                    mergeTargetSelections.forEach((mSelection) => {
                        if (mSelection.address === mergedAddress) {
                            return;
                        }
                        const styleClass = styleClassMap.get(mSelection);
                        mergedHighlightIds.push(createHighlightId(mSelection.address, styleClass));
                        mergedAnnotations.push(createAnnotation(this._baseURL, AnnotationType.Highlight, mSelection, styleClass));
                    });
                }
            }
        }
        const highlightId = createHighlightId(selection.address, styleClass);
        // 기존에 같은 범위로 칠해져 있던 하이라이트 삭제
        this._highlighter.remove(this._document, highlightId);
        // 하이라이트
        this._highlighter.highlight(this._document, selection.address, styleClass, highlightId);
        // 머지된 하이라이트 삭제
        this._highlighter.remove(this._document, mergedHighlightIds);
        return {
            created: createAnnotation(this._baseURL, AnnotationType.Highlight, selection, styleClass),
            merged: mergedAnnotations,
        };
    }
    changeHighlight(range, currStyleClass, newStyleClass) {
        if (!this._document) {
            return null;
        }
        range = this._toHighlightableRange(range);
        const highlight = this._getHighlightByRange(range, currStyleClass);
        this._highlighter.remove(this._document, createHighlightId(highlight.address, currStyleClass));
        this._highlighter.highlight(this._document, highlight.address, newStyleClass, createHighlightId(highlight.address, newStyleClass));
        return createAnnotation(this._baseURL, AnnotationType.Highlight, highlight, newStyleClass);
    }
    removeHighlight(range, styleClass) {
        if (!this._document) {
            return null;
        }
        range = this._toHighlightableRange(range);
        const highlight = this._getHighlightByRange(range, styleClass);
        this._highlighter.remove(this._document, createHighlightId(highlight.address, styleClass));
        return createAnnotation(this._baseURL, AnnotationType.Highlight, highlight, styleClass);
    }
    getHighlightElements(highlightId, styleClasses) {
        if (typeof styleClasses === 'string') {
            styleClasses = [styleClasses];
        }
        let selector;
        if (styleClasses) {
            selector = styleClasses
                .map((styleClass) => {
                return this._highlighter.createSelectorString(highlightId, [
                    STARTING_HIGHLIGHT_CLASS,
                    styleClass,
                ]);
            })
                .join(',');
        }
        else {
            selector = this._highlighter.createSelectorString(highlightId);
        }
        return this.querySelectorAll(selector);
    }
    getParentHighlightsFromRange(range) {
        if (!this._document) {
            return [];
        }
        const selection = this._highlighter.select(this._document, range);
        const { selections, styleClassMap } = this._getRelatedHighlights(selection);
        const parentSelections = selections.filter((relSelection) => {
            return isParentSelection(selection, relSelection);
        });
        return parentSelections.reduce((result, pSelection) => {
            const range = this._highlighter.getRangeFromAddress(this._document, pSelection.address);
            if (!range) {
                return result;
            }
            const annotation = createAnnotation(this._baseURL, AnnotationType.Highlight, pSelection, styleClassMap.get(pSelection));
            result.push({ range, annotation });
            return result;
        }, []);
    }
    getHighlightsFromElement(element) {
        if (!this._document) {
            return [];
        }
        const baseSelection = this._highlighter.select(this._document, element);
        if (!baseSelection) {
            return [];
        }
        const { selections, styleClassMap } = this._getRelatedHighlights(baseSelection);
        return selections.reduce((result, selection) => {
            const range = this._highlighter.getRangeFromAddress(this._document, selection.address);
            if (!range) {
                return result;
            }
            const address = parseBukURL(this._baseURL);
            address.anchor = selection.address;
            result.push({
                rect: getBoundingClientRect(range),
                rects: getClientRects(range),
                range,
                annotation: {
                    type: AnnotationType.Highlight,
                    url: address.toString(),
                    text: selection.text,
                    styleClass: styleClassMap.get(selection) ?? null,
                },
            });
            return result;
        }, []);
    }
    getAddressFromRange(range) {
        if (range.collapsed || range.toString().trim().length === 0) {
            return null;
        }
        const selection = this._highlighter.select(getDocumentFromRange(range), range);
        if (!selection) {
            throw new Error('failed to get text range');
        }
        const address = parseBukURL(this._baseURL);
        address.anchor = selection.address;
        return address;
    }
    _getHighlightByRange(range, styleClass) {
        const selection = this._highlighter.select(this._document, range);
        const element = this.querySelector(this._highlighter.createSelectorString(createHighlightId(selection.address, styleClass)));
        if (!element) {
            throw new Error('Cannot find highlight by a given range');
        }
        return selection;
    }
    _getRelatedHighlights(selection) {
        const styleClassMap = new Map();
        const selections = [];
        selection.highlightIds?.forEach((hId) => {
            const highlightElem = this.querySelector(this._highlighter.createSelectorString(hId));
            if (!highlightElem) {
                return;
            }
            const styleClass = this._getHighlightClassFromElement(highlightElem);
            // 유저 하이라이트가 아니면 return
            if (!styleClass) {
                return;
            }
            const sel = this._highlighter.select(this._document, highlightElem);
            selections.push(sel);
            styleClassMap.set(sel, styleClass);
        });
        return {
            selections,
            styleClassMap,
        };
    }
    _getHighlightClassFromElement(element) {
        return this._userHighlightClasses.find((className) => element.classList.contains(className));
    }
    _toHighlightableRange(range) {
        if (typeof range !== 'string') {
            return range;
        }
        const rangeFromAddress = this._highlighter.getRangeFromAddress(this._document, range);
        if (!rangeFromAddress) {
            throw new Error('Invalid Range >> ' + range);
        }
        return rangeFromAddress;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: HighlightableFrameComponent, deps: [{ token: LibConfigService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.3", type: HighlightableFrameComponent, selector: "ng-component", usesInheritance: true, ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: HighlightableFrameComponent, decorators: [{
            type: Component,
            args: [{ template: '' }]
        }], ctorParameters: () => [{ type: LibConfigService }] });

/// <reference types="css-font-loading-module" />
/**
 * 콘텐츠 html을 iframe에 뿌리는 역할
 * dom 조작
 * iframe 내 이벤트 핸들링
 */
class FrameComponent extends HighlightableFrameComponent {
    constructor(_element, _renderer, _ngZone, _contentsClickInterceptor, _libConfig) {
        super(_libConfig);
        this._element = _element;
        this._renderer = _renderer;
        this._ngZone = _ngZone;
        this._contentsClickInterceptor = _contentsClickInterceptor;
        this._libConfig = _libConfig;
        this.frameLoad = new EventEmitter();
        this.frameDOMLoad = new EventEmitter();
        this.frameScrolled = new EventEmitter(); // true - scrolling, false - scroll end
        this.frameBoundaryScroll = new EventEmitter();
        this.frameAddressClick = new EventEmitter();
        this.frameMediaOverlayClick = new EventEmitter();
        this.framePageSettled = new EventEmitter();
        this._fixNotScrollableIframe = NOT_SCROLLABLE_IFRAME;
        this.isUserScrolling = false;
        this._highlighter = new Highlighter({
            EXCLUDE_ELEMENT_FILTER: isEpubGarbageElement,
        });
    }
    ngOnInit() {
        if (this._fixNotScrollableIframe) {
            this._ngZone.runOutsideAngular(() => {
                const scrollByUser$ = fromUserScrollEvent(this._element.nativeElement).pipe(filter(() => this.getLayout() === FrameLayout.Scroll));
                scrollByUser$
                    .pipe(throttleTime(300, undefined, { leading: false, trailing: true }), observeOn(enterZone(this._ngZone)))
                    .subscribe(() => {
                    this._onContentScroll();
                });
                scrollByUser$
                    .pipe(debounceTime(300), observeOn(enterZone(this._ngZone)))
                    .subscribe(() => {
                    this._onContentScrollEnd();
                });
                /**
                 * 스크롤 감지
                 */
                scrollByUser$.subscribe(() => {
                    this.isUserScrolling = true;
                });
            });
        }
    }
    get _document() {
        return this._iframe?.contentDocument ?? undefined;
    }
    get document() {
        return this._document;
    }
    get window() {
        return this._iframe?.contentWindow ?? undefined;
    }
    get iframe() {
        return this._iframe;
    }
    loadHTML(html, layout, settings) {
        this._createIframe();
        fromEvent(this._iframe, 'load')
            .pipe(tap(() => {
            this.applyContentsStyles();
            this.setLayout(layout);
            this.setTheme(settings.theme.value);
            this.setFontFace(settings.fontFace.value);
            this.setPageAnimation(settings.pageAnimation.value);
            this.setMultiColumn(settings.multiColumn.value);
            this.setClickToPlayMediaOverlay(settings.clickToPlayMediaOverlay.value);
            this._storeOriginalFontSize();
            this.setFontSizeAndLineHeight(settings.fontSize.value, settings.lineHeight.value);
        }), switchMap(() => {
            if (SUPPORT_FONT_FACE_SET) {
                return from(this.document.fonts.ready);
            }
            else {
                return createFontLoadFinishObserver(this.document.documentElement);
            }
        }), observeOn(enterZone(this._ngZone)))
            .subscribe(() => {
            this._onIframeLoad();
            this.frameLoad.emit();
        });
        this.document?.open();
        this.document?.write(html);
        this.document?.close();
        const onDOMContentLoaded = () => {
            this._onIframeDOMContentLoaded();
            this.frameDOMLoad.emit();
        };
        if (this.document?.readyState === 'loading') {
            this._iframe?.contentWindow?.addEventListener('DOMContentLoaded', () => {
                this._ngZone.run(() => onDOMContentLoaded());
            });
        }
        else {
            onDOMContentLoaded();
        }
    }
    applyContentsStyles() {
        if (!this.document) {
            return;
        }
        const styleElem = this.document.querySelector(`#${LIB_CONFIG_STYLE_ID}`);
        if (!styleElem) {
            return;
        }
        styleElem.innerHTML = this._libConfig.contentsStyles.join('\n');
    }
    setLayout(layout) {
        this._renderer.setAttribute(this._element.nativeElement, 'data-bukv-layout', layout);
        this._iframe?.setAttribute('scrolling', layout === FrameLayout.Scroll ? 'yes' : 'no');
        this.document?.documentElement.setAttribute('data-bukv-layout', layout);
        if (layout === FrameLayout.Fixed) {
            const frameWidth = this._getPageWidth();
            const bodyWidth = this.document.body.offsetWidth;
            const scale = Math.round((frameWidth / bodyWidth) * 10000) / 10000;
            this.document.body.style.transform = `scale(${scale})`;
        }
        this._setScrollFillerHeight();
    }
    setTheme(value) {
        if (this.getLayout() === FrameLayout.Fixed) {
            return;
        }
        this.document?.documentElement.setAttribute('data-bukv-theme', value);
    }
    setFontSizeAndLineHeight(fontSize, lineHeight) {
        if (this.getLayout() === FrameLayout.Fixed) {
            return;
        }
        const textElements = this.getElementsAtIframe('p, div, span, h1, h2, h3, h4, h5, h6, li, blockquote, td, pre');
        textElements.forEach((textElement) => {
            if (textElement.bukOriginalFontSize) {
                textElement.style.fontSize =
                    (textElement.bukOriginalFontSize * fontSize) / 100 + 'px';
            }
            if (textElement.bukOriginalLineHeight) {
                textElement.style.lineHeight =
                    (((textElement.bukOriginalLineHeight * fontSize) / 100) *
                        lineHeight) /
                        100 +
                        'px';
            }
        });
        this._setScrollFillerHeight();
    }
    setFontFace(value) {
        if (this.getLayout() === FrameLayout.Fixed) {
            return;
        }
        this.document?.documentElement.setAttribute(FONT_FACE_SETTING_ATTR, value);
        this._setScrollFillerHeight();
    }
    setPageAnimation(value) {
        this.document?.documentElement.setAttribute('data-bukv-page-animation', value.toString());
    }
    setMultiColumn(value) {
        this._renderer.setAttribute(this._element.nativeElement, 'data-bukv-multi-column', value.toString());
        this.document?.documentElement.setAttribute('data-bukv-multi-column', value.toString());
    }
    setClickToPlayMediaOverlay(value) {
        this.document?.documentElement.setAttribute('data-bukv-mo-enable-click', value.toString());
    }
    setPage(anchor) {
        const layout = this.getLayout();
        if (layout === FrameLayout.Fixed) {
            this.framePageSettled.emit();
        }
        else if (layout === FrameLayout.Column) {
            let page = 1;
            if (typeof anchor === 'number') {
                page = calculatePageFromPPage(anchor, this.getTotalPageCount());
            }
            else if (typeof anchor === 'string') {
                page = this.getPageForAnchor(anchor);
            }
            const pageChanged = this._setPageLeft(-1 * (page - 1) * 100);
            if (!pageChanged || !this._hasTransitionLeft()) {
                this.framePageSettled.emit();
            }
        }
        else {
            let top = 0;
            if (typeof anchor === 'number') {
                const page = calculatePageFromPPage(anchor, this.getTotalPageCount());
                top = (page - 1) * this._getPageHeight();
            }
            else if (typeof anchor === 'string') {
                if (isBukAnchor(anchor)) {
                    const highlight = this._getBukAnchorElem(anchor);
                    if (highlight) {
                        const pageTop = this._getPageTop();
                        let elementVertPosition = highlight.getBoundingClientRect().bottom;
                        if (this._fixNotScrollableIframe) {
                            elementVertPosition -= this._getPageTop();
                        }
                        top = pageTop + elementVertPosition - this._getPageHeight() / 2;
                        const hId = this._highlighter.getHighlightIdFromElement(highlight);
                        this._highlighter.remove(this.document, hId);
                    }
                }
                else {
                    const anchorElement = this._getAnchorElem(anchor);
                    if (anchorElement) {
                        top = anchorElement.offsetTop - this._getPageHeight() / 2;
                    }
                }
            }
            this._setPageTop(top);
            this.framePageSettled.emit();
        }
    }
    getTotalPageCount() {
        switch (this.getLayout()) {
            case FrameLayout.Fixed:
                return 1;
            case FrameLayout.Column:
                return Math.round(this._getContentWidth() / this._getPageWidth());
            case FrameLayout.Scroll:
                return Math.ceil(Math.floor((this._getContentHeight() / this._getPageHeight()) * 10) /
                    10);
            default:
                return 1;
        }
    }
    getCurrentPage() {
        switch (this.getLayout()) {
            case FrameLayout.Fixed:
                return 1;
            case FrameLayout.Column:
                return (clamp(0, Math.round(Math.abs(this._getPageLeft()) / this._getPageWidth()), this.getTotalPageCount() - 1) + 1);
            case FrameLayout.Scroll:
                return (Math.floor(this._getPageTop() / this._getPageHeight() + 0.001) + 1);
            default:
                return 1;
        }
    }
    getPageForElement(element, checkEnd) {
        if (!element) {
            return 1;
        }
        switch (this.getLayout()) {
            case FrameLayout.Fixed:
                return 1;
            case FrameLayout.Column: {
                const pageLeft = this._getPageLeft();
                const elementHorizPosition = element.getBoundingClientRect()[checkEnd ? 'right' : 'left'];
                return (clamp(0, Math.floor((Math.abs(pageLeft) + elementHorizPosition) /
                    this._getPageWidth()), this.getTotalPageCount() - 1) + 1);
            }
            case FrameLayout.Scroll: {
                const pageTop = this._getPageTop();
                let elementVertPosition = element.getBoundingClientRect()[checkEnd ? 'bottom' : 'top'];
                if (this._fixNotScrollableIframe) {
                    elementVertPosition -= this._getPageTop();
                }
                return (Math.floor((pageTop + elementVertPosition) / this._getPageHeight()) +
                    1);
            }
            default:
                return 1;
        }
    }
    getPageForAnchor(anchor) {
        let result = 1;
        if (isBukAnchor(anchor)) {
            const highlight = this._getBukAnchorElem(anchor);
            if (highlight) {
                result = this.getPageForElement(highlight);
                const hId = this._highlighter.getHighlightIdFromElement(highlight);
                this._highlighter.remove(this.document, hId);
            }
        }
        else {
            const anchorElement = this._getAnchorElem(anchor);
            if (anchorElement) {
                result = this.getPageForElement(anchorElement);
            }
        }
        return result;
    }
    getBaseBukURL() {
        return this._baseURL ?? null;
    }
    getLayout() {
        return [FrameLayout.Column, FrameLayout.Scroll, FrameLayout.Fixed].find((layout) => {
            return (this.document?.documentElement.getAttribute('data-bukv-layout') ===
                layout);
        });
    }
    isMultiColumn() {
        return (this.document?.documentElement.getAttribute('data-bukv-multi-column') ===
            'true');
    }
    getClickToPlayMediaOverlay() {
        const value = this.document?.documentElement.getAttribute('data-bukv-mo-enable-click');
        return !!value && value === 'true';
    }
    setLanguages(languages) {
        Object.entries(languages).forEach(([lang, isOn]) => {
            if (isOn) {
                this.document?.body.classList.add(lang);
            }
            else {
                this.document?.body.classList.remove(lang);
            }
        });
    }
    getElementsAtIframe(selector) {
        try {
            return Array.from(this.document?.querySelectorAll(selector) || []);
        }
        catch (error) {
            console.warn(error);
            return [];
        }
    }
    getIframeBoundingRect() {
        return this._iframe.getBoundingClientRect();
    }
    getHighlightElementsAtIframe(highlightId, styleClasses) {
        if (typeof styleClasses === 'string') {
            styleClasses = [styleClasses];
        }
        let selector;
        if (styleClasses) {
            selector = styleClasses
                .map((styleClass) => {
                return this._highlighter.createSelectorString(highlightId, [
                    STARTING_HIGHLIGHT_CLASS,
                    styleClass,
                ]);
            })
                .join(',');
        }
        else {
            selector = this._highlighter.createSelectorString(highlightId);
        }
        return this.getElementsAtIframe(selector);
    }
    getPrintPagesByPage() {
        let pages;
        const pageCount = this.getTotalPageCount();
        try {
            pages = new Array(pageCount).fill(undefined).map(() => []);
        }
        catch (error) {
            throw new Error(`Invalid array length: ${pageCount}`);
        }
        this.getElementsAtIframe(`[${PAGE_LIST_ANCHOR_ATTR}]`).forEach((elem) => {
            const page = this.getPageForElement(elem);
            const printPage = parseInt(elem.getAttribute(PAGE_LIST_ANCHOR_ATTR));
            pages[page - 1].push(printPage);
        });
        pages.forEach((printPages, index) => {
            const prevPrintPages = pages[index - 1];
            if (prevPrintPages?.length > 0) {
                printPages.push(prevPrintPages[prevPrintPages.length - 1]);
            }
            printPages.sort((p1, p2) => p1 - p2);
        });
        return pages;
    }
    isElementAtCurrentPage(element, checkEnd) {
        const rect = element.getBoundingClientRect();
        switch (this.getLayout()) {
            case FrameLayout.Fixed:
            case FrameLayout.Column:
                return rect.left >= 0 && rect.left < this._getPageWidth();
            case FrameLayout.Scroll: {
                let top = rect.top;
                let bottom = rect.bottom;
                if (this._fixNotScrollableIframe) {
                    top -= this._getPageTop();
                    bottom -= this._getPageTop();
                }
                return checkEnd
                    ? (top >= 0 && bottom <= this._getPageHeight()) ||
                        (top < 0 && bottom > this._getPageHeight())
                    : top >= 0 && top < this._getPageHeight();
            }
            default:
                return false;
        }
    }
    getVisibleRange() {
        if (!this.document) {
            return null;
        }
        const layout = this.getLayout();
        if (layout === FrameLayout.Fixed) {
            const firstElem = this.document.body.firstElementChild;
            const lastElem = this.document.body.lastElementChild;
            if (!firstElem || !lastElem) {
                return null;
            }
            return createRangeFromNodes(firstElem, lastElem);
        }
        const isHorizontal = layout === FrameLayout.Column;
        let start = 0;
        let end;
        if (isHorizontal) {
            end = this.document.defaultView.innerWidth;
        }
        else {
            start += 10;
            end = this._getPageHeight() - 10;
            if (this._fixNotScrollableIframe) {
                const scrollTop = this._getPageTop();
                start += scrollTop;
                end += scrollTop;
            }
        }
        const startRange = findStart(this.document.body, start, end, isHorizontal);
        const endRange = findEnd(this.document.body, start, end, isHorizontal);
        const range = this.document.createRange();
        range.setStart(startRange.startContainer, startRange.startOffset);
        range.setEnd(endRange.endContainer, endRange.endOffset);
        return range;
    }
    highlightAnnotation(annotation) {
        return this._lockScrollTop(() => {
            super.highlightAnnotation(annotation);
        });
    }
    unhighlightAnnotation(annotation) {
        return this._lockScrollTop(() => {
            super.unhighlightAnnotation(annotation);
        });
    }
    createBookmark() {
        if (this.getLayout() === FrameLayout.Fixed) {
            return null;
        }
        return this._lockScrollTop(() => {
            return super.createBookmark();
        });
    }
    // iOS 12 이하 모바일 사파리에서 iframe 내 DOM 변경 시 스크롤이 최상단으로 이동하는 문제 해결
    _lockScrollTop(fn) {
        if (!this._fixNotScrollableIframe) {
            return fn();
        }
        const currTop = this._element.nativeElement.scrollTop;
        const result = fn();
        this._element.nativeElement.scrollTop = currTop;
        return result;
    }
    createHighlight(range, styleClass, options) {
        return this._lockScrollTop(() => {
            return super.createHighlight(range, styleClass, options);
        });
    }
    removeHighlight(range, styleClass) {
        return this._lockScrollTop(() => {
            return super.removeHighlight(range, styleClass);
        });
    }
    pauseAllMedia() {
        this.getElementsAtIframe('video, audio').forEach((element) => {
            element.pause();
        });
    }
    setStyleClassToDocElementAtIframe(className, isRemove) {
        if (isRemove) {
            this.document?.documentElement.classList.remove(className);
        }
        else {
            this.document?.documentElement.classList.add(className);
        }
    }
    setStyleClassToElementsAtIframe(selector, className, isRemove) {
        // clear previous
        if (!isRemove) {
            this.getElementsAtIframe(`.${className}`).forEach((element) => element.classList.remove(className));
        }
        // set
        this.getElementsAtIframe(selector).forEach((element) => {
            if (isRemove) {
                element.classList.remove(className);
            }
            else {
                element.classList.add(className);
            }
        });
    }
    _onIframeLoad() { }
    _setScrollFillerHeight() {
        if (this.getLayout() !== FrameLayout.Scroll) {
            return;
        }
        const fillerElem = this.document.getElementById(PAGE_FILLER_ID);
        fillerElem.style.height = '0px';
        const pageCount = this.getTotalPageCount();
        const pagedContentHeight = pageCount * this._getPageHeight();
        const contentHeight = this._getContentHeight();
        fillerElem.style.height = `${pagedContentHeight - contentHeight}px`;
    }
    _onIframeDOMContentLoaded() {
        this.isUserScrolling = false;
        this._setCrossBrowsingClasses();
        this._initEventListeners();
        this._disableLinkClick();
    }
    _onContentClick(event) {
        IS_TOUCH_DEVICE && this._emitEmptySelectionChangeEvent(); // 데스크탑에서는 빈 공간 클릭하는 순간 selection change가 발생하는데 모바일에서는 그렇지 않기 때문에 동작 통일하기 위해 수동으로 이벤트 트리거
        if (!event.target) {
            return;
        }
        if (event.viewerDefaultPrevented) {
            return;
        }
        let interceptable;
        if ((interceptable = this._contentsClickInterceptor.getHighlightElement(event.target))) {
            this.frameHighlightClick.emit({
                highlights: this.getHighlightsFromElement(interceptable),
                clientPoint: { x: event.center.x, y: event.center.y },
            });
        }
        else if ((interceptable = this._contentsClickInterceptor.getAddress(event.target))) {
            this.frameAddressClick.emit(interceptable);
        }
        else if (this.getClickToPlayMediaOverlay() &&
            (interceptable = this._contentsClickInterceptor.getMediaOverlayText(event.target))) {
            this.frameMediaOverlayClick.emit(interceptable.id);
        }
        if (!interceptable) {
            const clickableElement = isNode(event.target) && findNodeFrom(event.target, isClickableElement);
            if (!clickableElement) {
                this.frameClick.emit(event);
            }
        }
    }
    _onContentScroll() {
        this.frameScrolled.emit(false);
    }
    _onContentScrollEnd() {
        this.isUserScrolling = false;
        this.frameScrolled.emit(true);
    }
    _createIframe() {
        if (this._iframe) {
            this._renderer.removeChild(this._element.nativeElement, this._iframe);
        }
        const iframe = this._renderer.createElement('iframe');
        iframe.style.width = `${this._element.nativeElement.offsetWidth}px`;
        this._renderer.appendChild(this._element.nativeElement, iframe);
        this._iframe = iframe;
    }
    /**
     * 폰트 사이즈 변경시 사이즈 계산에 사용할 기준값(원본 요소 사이즈)을 미리 저장해둠
     */
    _storeOriginalFontSize() {
        const textElements = this.getElementsAtIframe('p, div, span, h1, h2, h3, h4, h5, h6, li, blockquote, td, pre');
        let originalFontSize;
        let originalLineHeight;
        textElements.forEach((textElement) => {
            const style = textElement.ownerDocument.defaultView.getComputedStyle(textElement);
            originalFontSize = parseInt(style.fontSize);
            originalLineHeight = parseInt(style.lineHeight); // TODO line-height: normal =(getComputedStyle)=> 'normal'
            !isNaN(originalFontSize) &&
                (textElement.bukOriginalFontSize = originalFontSize);
            !isNaN(originalLineHeight) &&
                (textElement.bukOriginalLineHeight = originalLineHeight);
        });
    }
    _setCrossBrowsingClasses() {
        if (SCROLL_FREEZE) {
            this.document?.documentElement.classList.add('fix-scroll-freeze');
        }
    }
    _initEventListeners() {
        /**
         * (데스크탑 환경) Fixed Layout에서 더블 클릭으로 텍스트 선택 막음, 확대 축소 제스처로 사용
         */
        if (!IS_TOUCH_DEVICE) {
            fromDoubleClickEvent(this.document)
                .pipe(filter(() => this.getLayout() === FrameLayout.Fixed))
                .subscribe((event) => {
                event.preventDefault();
            });
        }
        else {
            fromSwipeEvent(this.document)
                .pipe(filter(() => {
                return (this.getLayout() !== FrameLayout.Scroll &&
                    !this._hasSelectedText());
            }), observeOn(enterZone(this._ngZone)))
                .subscribe((direction) => {
                this._emitEmptySelectionChangeEvent(); // 데스크탑에서는 빈 공간 클릭하는 순간 selection change가 발생하는데 모바일에서는 그렇지 않기 때문에 동작 통일하기 위해 수동으로 이벤트 트리거
                this.frameSwipe.emit(direction === SwipeDirection.Left ? 1 : -1);
            });
            // 모바일 환경에서 텍스트가 선택되어있는 상황에서 선택을 터치 시 페이지가 넘어가지 않도록 함
            this.document.documentElement.addEventListener('pointerdown', (event) => {
                const selection = this._document?.getSelection();
                if (!selection || selection.rangeCount === 0) {
                    return;
                }
                if (selection.getRangeAt(0).collapsed) {
                    return;
                }
                const rects = selection.getRangeAt(0).getClientRects();
                const clickPoint = { x: event.clientX, y: event.clientY };
                for (let i = 0; i < rects.length; i++) {
                    if (isPointInRect(clickPoint, rects[i])) {
                        event.bukvEventHandled = true;
                        break;
                    }
                }
            });
        }
        fromClickEvent(this.document.documentElement, true)
            .pipe(observeOn(enterZone(this._ngZone)))
            .subscribe((event) => {
            switch (event.type) {
                case 'double':
                    this.frameDoubleClick.emit(event);
                    break;
                case 'single':
                    this._onContentClick(event);
                    break;
            }
        });
        /**
         * keydown
         */
        fromPageChangeKeydownEvent(this.document)
            .pipe(observeOn(enterZone(this._ngZone)))
            .subscribe((direction) => {
            this.framePageChangeKeydown.emit(direction);
        });
        const scrollDeltaY$ = fromEvent(this.document, 'wheel').pipe(filter(() => this.getLayout() === FrameLayout.Scroll), debounceTime(300), map((event) => event.deltaY));
        /**
         * 콘텐츠 맨 처음 또는 마지막에서 스크롤 액션 감지
         */
        const touchStart$ = fromEvent(this.document, 'touchstart', {
            passive: true,
        });
        const touchMove$ = fromEvent(this.document, 'touchmove');
        const touchEnd$ = fromEvent(this.document, 'touchend');
        const touchmoveDeltaY$ = touchStart$.pipe(filter(() => this.getLayout() === FrameLayout.Scroll), switchMap((startEvent) => {
            return touchMove$.pipe(takeUntil(touchEnd$), takeLast(1), map((endEvent) => {
                return startEvent.touches[0].clientY - endEvent.touches[0].clientY;
            }));
        }), filter((deltaY) => Math.abs(deltaY) > 10));
        merge(scrollDeltaY$, touchmoveDeltaY$)
            .pipe(observeOn(enterZone(this._ngZone)))
            .subscribe((deltaY) => {
            if (this._hasSelectedText()) {
                return;
            }
            const scrollTop = this._getPageTop();
            if (deltaY < 0 && scrollTop <= 0) {
                this.frameBoundaryScroll.emit(-1);
            }
            else if (deltaY > 0 &&
                Math.ceil(scrollTop) >=
                    this._getContentHeight() - this._getPageHeight() - 1) {
                this.frameBoundaryScroll.emit(1);
            }
        });
        const scrollByUser$ = fromUserScrollEvent(this.document).pipe(filter(() => this.getLayout() === FrameLayout.Scroll));
        /**
         * 콘텐츠 맨 처음 또는 마지막에서 스크롤 액션 감지
         * 스크롤 감지
         */
        scrollByUser$
            .pipe(throttleTime(300, undefined, { leading: false, trailing: true }), observeOn(enterZone(this._ngZone)))
            .subscribe(() => {
            this._onContentScroll();
        });
        scrollByUser$
            .pipe(debounceTime(300), observeOn(enterZone(this._ngZone)))
            .subscribe(() => {
            this._onContentScrollEnd();
        });
        /**
         * 스크롤 감지
         */
        scrollByUser$.subscribe(() => {
            this.isUserScrolling = true;
            this.clearSelection();
        });
        /**
         * 페이지 에니메이션 끝남 감지
         */
        fromEvent(this.document.documentElement, 'transitionend')
            .pipe(filter((event) => event.propertyName === 'left'), observeOn(enterZone(this._ngZone)))
            .subscribe(() => {
            this.framePageSettled.emit();
        });
        /**
         * 텍스트 선택 감지
         */
        fromEvent(this.document, 'selectionchange')
            .pipe(debounceTime(50), observeOn(enterZone(this._ngZone)))
            .subscribe(() => {
            this.frameSelectionChange.emit({
                selection: this.getContentsSelection(),
                doc: this.document,
            });
        });
        /**
         * 컨텍스트 메뉴 disable
         */
        this.document?.addEventListener('contextmenu', (event) => {
            event.preventDefault();
        });
    }
    /**
     * iframe 내부에서 페이지가 이동되는 것을 막음
     */
    _disableLinkClick() {
        this.getElementsAtIframe('a').forEach((linkElement) => {
            if (linkElement.getAttribute('target') === '_blank') {
                return;
            }
            linkElement.addEventListener('_click', (event) => {
                event.preventDefault();
            });
        });
    }
    _getContentWidth() {
        return this.document.documentElement.scrollWidth;
    }
    _getContentHeight() {
        return this.document.documentElement.scrollHeight;
    }
    _getPageWidth() {
        return this._iframe?.offsetWidth ?? this._element.nativeElement.offsetWidth;
    }
    _getPageHeight() {
        return this._element.nativeElement.offsetHeight;
    }
    _getPageLeft() {
        const leftStyle = this.document?.documentElement.style.left;
        if (!leftStyle) {
            return 0;
        }
        const result = /^(-?\d+)vw$/.exec(leftStyle);
        return result ? (parseInt(result[1]) / 100) * this._getPageWidth() : 0;
    }
    _getBukAnchorElem(anchor) {
        if (!isBukAnchor(anchor)) {
            return null;
        }
        const existingAnchorElem = this.getHighlightElementsAtIframe(undefined, ANCHOR_HIGHLIGHT_CLASS);
        if (existingAnchorElem.length > 0) {
            const existingAnchorElemId = this._highlighter.getHighlightIdFromElement(existingAnchorElem[0]);
            existingAnchorElemId != null &&
                this._highlighter.remove(this.document, existingAnchorElemId);
        }
        const hId = this._highlighter.highlight(this.document, anchor, ANCHOR_HIGHLIGHT_CLASS);
        if (hId == null) {
            return null;
        }
        const hElements = this.getElementsAtIframe(this._highlighter.createSelectorString(hId));
        return hElements.length > 0 ? hElements[0] : null;
    }
    _getAnchorElem(anchor) {
        let anchorElement = this.document?.getElementById(anchor);
        if (!anchorElement) {
            anchorElement = this.document?.getElementById(decodeURIComponent(anchor));
        }
        // section tag에 id가 붙어있는 경우 safari에서 위치를 잘못찾는 문제
        if (anchorElement && anchorElement.tagName === 'SECTION') {
            const firstVisibleElement = Array.prototype.find.call(anchorElement.children, (element) => hasSize(element));
            if (firstVisibleElement) {
                anchorElement = firstVisibleElement;
            }
        }
        return anchorElement ?? null;
    }
    _getPageTop() {
        return this._fixNotScrollableIframe
            ? this._element.nativeElement.scrollTop
            : this.window.pageYOffset;
    }
    _setPageLeft(vw) {
        const prevLeft = this.document.documentElement.style.left;
        this.document.documentElement.style.left = `${vw}vw`;
        if (!this.document.documentElement.classList.contains('bukv_page-located')) {
            setTimeout(() => {
                this.document?.documentElement.classList.add('bukv_page-located');
            });
        }
        return prevLeft !== this.document.documentElement.style.left;
    }
    _setPageTop(top) {
        if (this._fixNotScrollableIframe) {
            this._element.nativeElement.scrollTop = top;
            // scrollTop이 임의로 0으로 셋팅되는 문제 수정..
            if (top !== 0) {
                let i = 0;
                const intervalId = setInterval(() => {
                    if (++i > 100) {
                        clearInterval(intervalId);
                    }
                    else {
                        this._element.nativeElement.scrollTop = top;
                    }
                }, 5);
            }
        }
        else {
            this.window.scrollTo(0, top);
        }
    }
    _hasTransitionLeft() {
        const transitionProps = getStyle(this.document.documentElement, 'transition-property') ?? '';
        const hasTransitionLeft = transitionProps === 'all' ||
            transitionProps?.split(',').some((prop) => prop.trim() === 'left');
        const hasTransitionDuration = getStyle(this.document.documentElement, 'transition-duration') !== '0s';
        return hasTransitionDuration && hasTransitionLeft;
    }
    _hasSelectedText() {
        const selection = this.document?.getSelection();
        return !!selection && !selection.isCollapsed;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: FrameComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.NgZone }, { token: ContentsClickInterceptorService }, { token: LibConfigService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.3", type: FrameComponent, selector: "bukv-frame", outputs: { frameLoad: "frameLoad", frameDOMLoad: "frameDOMLoad", frameScrolled: "frameScrolled", frameBoundaryScroll: "frameBoundaryScroll", frameAddressClick: "frameAddressClick", frameMediaOverlayClick: "frameMediaOverlayClick", framePageSettled: "framePageSettled" }, host: { properties: { "class.fix-not-scrollable-iframe": "this._fixNotScrollableIframe" } }, usesInheritance: true, ngImport: i0, template: '', isInline: true, styles: [":host{display:inline-block}:host.fix-not-scrollable-iframe{overflow-y:auto;-webkit-overflow-scrolling:touch}:host[data-bukv-layout=column]{padding-top:var(--bukv-contents-padding-top);padding-bottom:var(--bukv-contents-padding-bottom)}iframe{display:block;border:none;width:100%;height:100%}:host[data-bukv-layout=column][data-bukv-multi-column=true] iframe{max-width:1800px;margin:0 auto}:host[data-bukv-layout=fixed] iframe{background:#fff}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: FrameComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bukv-frame', template: '', changeDetection: ChangeDetectionStrategy.OnPush, styles: [":host{display:inline-block}:host.fix-not-scrollable-iframe{overflow-y:auto;-webkit-overflow-scrolling:touch}:host[data-bukv-layout=column]{padding-top:var(--bukv-contents-padding-top);padding-bottom:var(--bukv-contents-padding-bottom)}iframe{display:block;border:none;width:100%;height:100%}:host[data-bukv-layout=column][data-bukv-multi-column=true] iframe{max-width:1800px;margin:0 auto}:host[data-bukv-layout=fixed] iframe{background:#fff}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.NgZone }, { type: ContentsClickInterceptorService }, { type: LibConfigService }], propDecorators: { frameLoad: [{
                type: Output
            }], frameDOMLoad: [{
                type: Output
            }], frameScrolled: [{
                type: Output
            }], frameBoundaryScroll: [{
                type: Output
            }], frameAddressClick: [{
                type: Output
            }], frameMediaOverlayClick: [{
                type: Output
            }], framePageSettled: [{
                type: Output
            }], _fixNotScrollableIframe: [{
                type: HostBinding,
                args: ['class.fix-not-scrollable-iframe']
            }] } });

function animate(duration, frameFn) {
    const end = +new Date() + duration;
    let animId;
    const step = () => {
        const current = +new Date();
        const remaining = end - current;
        if (remaining < 60) {
            frameFn(1);
            return;
        }
        else {
            frameFn(1 - remaining / duration);
        }
        animId = requestAnimationFrame(step);
    };
    step();
    return () => {
        console.warn('cancel');
        cancelAnimationFrame(animId);
    };
}

const ZOOM_FLICKER_FIX_CLASS$1 = 'bukv_fix-zoom-flicker';
function getDistance(a, b) {
    const x = a.screenX - b.screenX;
    const y = a.screenY - b.screenY;
    return Math.sqrt(x * x + y * y);
}
class ScrollZoomComponent {
    constructor(_element, _renderer, _ngZone, _libConfig) {
        this._element = _element;
        this._renderer = _renderer;
        this._ngZone = _ngZone;
        this._libConfig = _libConfig;
        this.animDuration = 200;
        this.toggleScale = 200;
        this.scaleChange = new EventEmitter();
        this.scaleStart = new EventEmitter();
        this.scaleEnd = new EventEmitter();
        this._prevScale = 100;
        this._scale = 100; // 애니메이션 중의 scale값도 포함
        this._translateX = 0;
        this._translateY = 0;
        this._pinchEnded = true;
        this._nthPinch = 0;
    }
    ngOnInit() {
        if (this._libConfig && IMAGE_FLICKERING_WITH_ZOOM) {
            this._renderer.addClass(this._zoomContentElem.nativeElement, ZOOM_FLICKER_FIX_CLASS$1);
        }
    }
    get scale() {
        return this._scale;
    }
    get isZoomed() {
        return this._scale > 100;
    }
    toggle(center) {
        if (this.isZoomed) {
            this.zoom(100);
        }
        else {
            this._zoomToCenter(center);
        }
    }
    zoom(scale, skipAnimation) {
        if (skipAnimation) {
            this._zoomWithoutAnimation(scale);
        }
        else {
            this._zoomWithAnimation(scale);
        }
    }
    pinchZoom(event) {
        switch (event.type) {
            case 'pinchstart':
                this._onPinchZoomStart();
                break;
            case 'pinchend':
            case 'pinchcancel':
                this._onPinchZoomEnd();
                break;
            default:
                this._onPinchZoomInOut(event);
        }
    }
    reset(scale = 100, centerHorizontally) {
        this._onScaleStart();
        this._scale = scale;
        this._updateZoomContentStyle(scale);
        this._element.nativeElement.scrollTop = 0;
        this._element.nativeElement.scrollLeft = centerHorizontally
            ? this._element.nativeElement.scrollWidth / 2 -
                this._element.nativeElement.offsetWidth / 2
            : 0;
        this._onScaleEnd();
    }
    scrollToElement(element) {
        if (!this.isZoomed) {
            return;
        }
        const rect = element.getBoundingClientRect();
        const frameElement = element.ownerDocument.defaultView?.frameElement;
        if (frameElement) {
            const frameBoundingRect = frameElement.getBoundingClientRect();
            const zoom = frameBoundingRect.width /
                frameElement.contentWindow.innerWidth;
            rect.x *= zoom;
            rect.y *= zoom;
            rect.width *= zoom;
            rect.height *= zoom;
            rect.x += frameBoundingRect.left;
            rect.y += frameBoundingRect.top;
        }
        const { x, y } = getLocationInElement(this._zoomContentElem.nativeElement, {
            x: rect.x,
            y: rect.y,
        });
        this._element.nativeElement.scrollLeft =
            x - (this._element.nativeElement.offsetWidth - rect.width) / 2;
        this._element.nativeElement.scrollTop =
            y - (this._element.nativeElement.offsetHeight - rect.height) / 2;
    }
    _zoomToCenter(center) {
        this._onScaleStart();
        const scaleStart = this._scale;
        const scaleEnd = this.toggleScale;
        this._ngZone.runOutsideAngular(() => {
            this._animCancelFn = animate(this.animDuration, (rate) => {
                const scale = scaleStart + (scaleEnd - scaleStart) * rate;
                this._scale = scale;
                this._updateZoomContentStyle(scale);
                this._element.nativeElement.scrollTop =
                    center.y * (scale / 100) - center.y;
                this._element.nativeElement.scrollLeft =
                    center.x * (scale / 100) - center.x;
                rate === 1 && this._ngZone.run(() => this._onScaleEnd());
            });
        });
    }
    _zoomWithAnimation(scale) {
        this._onScaleStart();
        const scaleStart = this._scale;
        const scaleEnd = scale;
        const scrollDeltaCalculator = this._getScrollDeltaCalculator();
        let prevScale = scaleStart;
        this._ngZone.runOutsideAngular(() => {
            this._animCancelFn = animate(this.animDuration, (rate) => {
                this._zoomContentElem.nativeElement.offsetHeight;
                let rateScale;
                if (scaleStart < scaleEnd) {
                    rateScale = scaleStart + (scaleEnd - scaleStart) * rate;
                }
                else {
                    rateScale = scaleEnd + (scaleStart - scaleEnd) * (1 - rate);
                }
                const scrollDelta = scrollDeltaCalculator(prevScale, rateScale);
                this._scale = rateScale;
                this._updateZoomContentStyle(rateScale);
                this._element.nativeElement.scrollTop += scrollDelta.y;
                this._element.nativeElement.scrollLeft += scrollDelta.x;
                prevScale = rateScale;
                rate === 1 && this._ngZone.run(() => this._onScaleEnd());
            });
        });
    }
    _zoomWithoutAnimation(scale) {
        this._onScaleStart();
        const scaleStart = this._scale;
        const scaleEnd = scale;
        const scrollDeltaCalculator = this._getScrollDeltaCalculator();
        this._scale = scale;
        this._updateZoomContentStyle(scale);
        const scrollDelta = scrollDeltaCalculator(scaleStart, scaleEnd);
        this._element.nativeElement.scrollTop += scrollDelta.y;
        this._element.nativeElement.scrollLeft += scrollDelta.x;
        this._onScaleEnd();
    }
    _onScaleEnd() {
        this._animCancelFn = undefined;
        if (this._scale !== this._prevScale) {
            this.scaleChange.emit(this._scale);
        }
        this._setScrollable(this._scale > 100);
        this._prevScale = this._scale;
        this.scaleEnd.emit();
    }
    _onScaleStart() {
        this._animCancelFn?.();
        this._animCancelFn = undefined;
        this._setScrollable(true);
        this.scaleStart.emit();
    }
    // TODO: pinchend 발생하지 않는 경우도 있음
    _onPinchZoomEnd() {
        this._pinchEnded = true;
        this._nthPinch = 0;
        this._prevDistance = undefined;
        const pageRect = this._zoomContentElem.nativeElement.getBoundingClientRect();
        this._updateZoomContentStyle(this._scale);
        this._setScrollable(false);
        requestAnimationFrame(() => {
            this._setScrollable(true);
            this._element.nativeElement.scrollLeft = Math.abs(pageRect.left);
            this._element.nativeElement.scrollTop = Math.abs(pageRect.top);
            this._onScaleEnd();
        });
    }
    _onPinchZoomStart() {
        this._nthPinch = 0;
        this._prevDistance = undefined;
        if (this._pinchEnded) {
            this._translateX = -this._element.nativeElement.scrollLeft;
            this._translateY = -this._element.nativeElement.scrollTop;
            this._element.nativeElement.scrollLeft = 0;
            this._element.nativeElement.scrollTop = 0;
            this._updateZoomContentStyle(this._scale, {
                x: this._translateX,
                y: this._translateY,
            });
        }
        this._pinchEnded = false;
        this._onScaleStart();
    }
    _onPinchZoomInOut(event) {
        const pointers = event.pointers;
        if (pointers.length < 2) {
            return;
        }
        const distance = getDistance(pointers[0], pointers[1]);
        const prevDistance = this._prevDistance;
        this._prevDistance = distance;
        if (++this._nthPinch < 2) {
            return;
        }
        if (!prevDistance) {
            return;
        }
        if (Math.abs(prevDistance - this._prevDistance) > 300) {
            // palm rejection
            return;
        }
        const deltaScale = distance / prevDistance;
        const currentScale = this._scale / 100;
        let nextScale = currentScale;
        if (event.type === 'pinchout') {
            // nextScale = Math.min(nextScale + 0.03, 3);
            nextScale = nextScale * deltaScale;
        }
        else if (event.type === 'pinchin') {
            // nextScale = Math.max(nextScale - 0.03, 1);
            nextScale = nextScale * Math.min(1, deltaScale);
        }
        nextScale = clamp(1, nextScale, 3);
        if (nextScale === currentScale) {
            return;
        }
        if (nextScale === 1) {
            this._translateX = 0;
            this._translateY = 0;
        }
        else {
            const center = event.center;
            const frameElem = event.target.ownerDocument.defaultView?.frameElement;
            if (frameElem) {
                center.x *= currentScale;
                center.y *= currentScale;
                center.x += frameElem.getBoundingClientRect().left;
                center.y += frameElem.getBoundingClientRect().top;
            }
            const biasX = ((center.x - this._translateX) * nextScale) / currentScale -
                (center.x - this._translateX);
            const biasY = ((center.y - this._translateY) * nextScale) / currentScale -
                (center.y - this._translateY);
            this._translateX -= biasX;
            this._translateY -= biasY;
        }
        this._scale = nextScale * 100;
        this._updateZoomContentStyle(this._scale, {
            x: this._translateX,
            y: this._translateY,
        });
    }
    /**
     * 'overflow: auto'로 두면 모바일 사파리 + 스크롤 모드에서 포커스 문제로 스크롤 되지 않는 문제가 있어
     * 필요한 때에만 auto 로 지정
     */
    _setScrollable(scrollable) {
        if (scrollable) {
            this._renderer.setStyle(this._element.nativeElement, 'overflow', 'auto');
        }
        else {
            this._renderer.setStyle(this._element.nativeElement, 'overflow', 'hidden');
        }
    }
    _updateZoomContentStyle(scale, translate) {
        if (scale < 100) {
            this._renderer.setStyle(this._zoomContentElem.nativeElement, 'transform-origin', 'center center');
        }
        else {
            this._renderer.setStyle(this._zoomContentElem.nativeElement, 'transform-origin', '0 0');
        }
        let transform = `scale(${scale / 100})`;
        if (translate) {
            transform =
                `translateX(${translate.x}px) translateY(${translate.y}px) ` +
                    transform;
        }
        this._renderer.setStyle(this._zoomContentElem.nativeElement, 'transform', transform);
    }
    _getScrollDeltaCalculator() {
        const offsetWidth = this._element.nativeElement.offsetWidth;
        const offsetHeight = this._element.nativeElement.offsetHeight;
        const scrollCenterX = (this._element.nativeElement.scrollLeft +
            this._element.nativeElement.offsetWidth / 2) /
            this._element.nativeElement.scrollWidth;
        const scrollCenterY = (this._element.nativeElement.scrollTop +
            this._element.nativeElement.offsetHeight / 2) /
            this._element.nativeElement.scrollHeight;
        return (prevScale, scale) => {
            const prevW = offsetWidth * (prevScale / 100);
            const prevH = offsetHeight * (prevScale / 100);
            const currW = offsetWidth * (scale / 100);
            const currH = offsetHeight * (scale / 100);
            return {
                x: (currW - prevW) * scrollCenterX,
                y: (currH - prevH) * scrollCenterY,
            };
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: ScrollZoomComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.NgZone }, { token: LibConfigService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.3", type: ScrollZoomComponent, selector: "bukv-scroll-zoom", inputs: { animDuration: "animDuration", toggleScale: "toggleScale" }, outputs: { scaleChange: "scaleChange", scaleStart: "scaleStart", scaleEnd: "scaleEnd" }, viewQueries: [{ propertyName: "_zoomContentElem", first: true, predicate: ["zoomContent"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"bukv_zoom-content\" #zoomContent>\n  <ng-content></ng-content>\n</div>\n", styles: [":host{display:block;height:100%;-webkit-overflow-scrolling:auto;overscroll-behavior:none}.bukv_zoom-content{height:100%}.bukv_zoom-content.bukv_fix-zoom-flicker{will-change:transform}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: ScrollZoomComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bukv-scroll-zoom', template: "<div class=\"bukv_zoom-content\" #zoomContent>\n  <ng-content></ng-content>\n</div>\n", styles: [":host{display:block;height:100%;-webkit-overflow-scrolling:auto;overscroll-behavior:none}.bukv_zoom-content{height:100%}.bukv_zoom-content.bukv_fix-zoom-flicker{will-change:transform}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.NgZone }, { type: LibConfigService }], propDecorators: { _zoomContentElem: [{
                type: ViewChild,
                args: ['zoomContent', { static: true }]
            }], animDuration: [{
                type: Input
            }], toggleScale: [{
                type: Input
            }], scaleChange: [{
                type: Output
            }], scaleStart: [{
                type: Output
            }], scaleEnd: [{
                type: Output
            }] } });

const DEFAULT_MO_PLAYBACK_ACTIVE_CLASS = 'bukv_mo-playback-active';
const DEFAULT_MO_ACTIVE_CLASS = 'bukv_mo-active';
class PageComponent {
    constructor(_element, _libConfig, _settingStoreService, _addressStoreService, _eventBus) {
        this._element = _element;
        this._libConfig = _libConfig;
        this._settingStoreService = _settingStoreService;
        this._addressStoreService = _addressStoreService;
        this._eventBus = _eventBus;
        this.loaded = new EventEmitter();
        this.domLoaded = new EventEmitter();
        this.pageScrolled = new EventEmitter();
        this.pageSettled = new EventEmitter();
        this.mediaOverlayClick = new EventEmitter();
        this.zoomScaleChange = new EventEmitter();
        this._unsubscriber = new Subject();
        this._frameLoadEventUnsubscriber = new Subject();
        this._isMultiColumn = false;
    }
    get zoomScale() {
        if (!this._zoomElem) {
            return 1;
        }
        return this._zoomElem.scale;
    }
    get isUserScrolling() {
        return (this._frameComps.find((frameComp) => frameComp.isUserScrolling) !==
            undefined);
    }
    ngOnInit() { }
    ngAfterViewInit() {
        fromClickEvent(this._element.nativeElement, false)
            .pipe(takeUntil(this._unsubscriber))
            .subscribe((event) => {
            switch (event.type) {
                case 'double':
                    this._onPageDblClick(event);
                    break;
                case 'single':
                    this._onPageClick(event);
                    break;
            }
        });
    }
    ngOnDestroy() {
        this._unsubscriber.next();
        this._unsubscriber.complete();
    }
    loadPage(rightPageInfo, leftPageInfo) {
        this._frameLoadEventUnsubscriber.next();
        this._leftItem = leftPageInfo?.item;
        this._rightItem = rightPageInfo.item;
        const itemCompPair = [
            [rightPageInfo, this._frameComps.last],
        ];
        if (leftPageInfo) {
            itemCompPair.push([leftPageInfo, this._frameComps.first]);
        }
        zip(...itemCompPair.map(([, frameComp]) => frameComp.frameLoad))
            .pipe(takeUntil(this._frameLoadEventUnsubscriber), take(1))
            .subscribe(() => {
            this._setPrintPageInfo();
            this.loaded.emit({
                totalPageCount: this.getTotalPageCount(),
            });
        });
        zip(...itemCompPair.map(([, frameComp]) => frameComp.frameDOMLoad))
            .pipe(takeUntil(this._frameLoadEventUnsubscriber), take(1))
            .subscribe(() => {
            this.domLoaded.emit();
        });
        this._isMultiColumn = itemCompPair.length > 1;
        this.resetZoom();
        const framesSize = this._calculateFramesSize(itemCompPair.map(([pageInfo]) => pageInfo.item));
        if (framesSize.width * framesSize.height > 0) {
            this._framesWidth = framesSize.width;
            this._framesHeight = framesSize.height;
        }
        else {
            this._framesWidth = undefined;
            this._framesHeight = undefined;
        }
        const settings = this._settingStoreService.settings;
        itemCompPair.forEach(([pageInfo, frameComp]) => {
            let frameLayout;
            if (pageInfo.item.layout === 'fixed') {
                frameLayout = FrameLayout.Fixed;
            }
            else {
                frameLayout =
                    settings.pagingMode.value === PagingMode.Page
                        ? FrameLayout.Column
                        : FrameLayout.Scroll;
            }
            // frame 사이즈 정해진 다음
            setTimeout(() => {
                frameComp.loadHTML(pageInfo.html, frameLayout, settings);
            });
        });
    }
    setPage(anchor) {
        const rightPage = this._frameComps.last;
        rightPage.setPage(anchor);
    }
    getTotalPageCount() {
        const rightPage = this._frameComps.last;
        return rightPage.getTotalPageCount();
    }
    getCurrentPage() {
        const rightPage = this._frameComps.last;
        return rightPage.getCurrentPage();
    }
    getPageForAnchor(anchor) {
        return this._frameComps.last.getPageForAnchor(anchor);
    }
    highlightAnchor(iid, anchor, color) {
        this._getFrameComponentForIid(iid)?.highlightAnchor(anchor, color);
    }
    clearAnchorHighlight() {
        this._frameComps.forEach((frameComp) => frameComp.clearAnchorHighlight());
    }
    isAnnotationAtCurrentPage(annotation) {
        if (!this.isShowingItem(annotation.address.iid)) {
            return false;
        }
        if (annotation.address.range) {
            const frameComp = this._getFrameComponentForIid(annotation.address.iid);
            if (!frameComp) {
                return false;
            }
            const element = frameComp?.getHighlightElementsAtIframe(createHighlightId(annotation.address.range, annotation.styleClass))[0];
            return !!element && frameComp.isElementAtCurrentPage(element);
        }
        const pPage = annotation.address.page ?? 0;
        const page = calculatePageFromPPage(pPage, this.getTotalPageCount());
        return this.getCurrentPage() === page;
    }
    applyContentsStyles() {
        this._frameComps.forEach((frameComp, compIndex) => {
            if ((compIndex === 0 && !this._leftItem) ||
                (compIndex === 1 && !this._rightItem)) {
                return;
            }
            frameComp.applyContentsStyles();
        });
        this._setPrintPageInfo();
    }
    applySettings(settings) {
        this._frameComps.forEach((frameComp, compIndex) => {
            if ((compIndex === 0 && !this._leftItem) ||
                (compIndex === 1 && !this._rightItem)) {
                return;
            }
            frameComp.setFontSizeAndLineHeight(settings.fontSize.value, settings.lineHeight.value);
            frameComp.setFontFace(settings.fontFace.value);
            frameComp.setTheme(settings.theme.value);
            frameComp.setPageAnimation(settings.pageAnimation.value);
            frameComp.setMultiColumn(settings.multiColumn.value);
            frameComp.setClickToPlayMediaOverlay(settings.clickToPlayMediaOverlay.value);
            if (frameComp.getLayout() !== FrameLayout.Fixed) {
                frameComp.setLayout(settings.pagingMode.value === PagingMode.Page
                    ? FrameLayout.Column
                    : FrameLayout.Scroll);
            }
        });
        this._setPrintPageInfo();
    }
    highlight(annotations) {
        annotations.forEach((annotation) => {
            this._getFrameComponentForIid(annotation.address.iid)?.highlightAnnotation(annotation);
        });
    }
    unhighlight(annotations) {
        annotations.forEach((annotation) => {
            this._getFrameComponentForIid(annotation.address.iid)?.unhighlightAnnotation(annotation);
        });
    }
    createBookmark() {
        const iid = this._leftItem?.iid ?? this._rightItem?.iid;
        if (iid == null) {
            throw new Error();
        }
        const frameComp = this._getFrameComponentForIid(iid);
        const rangeBookmark = frameComp.createBookmark();
        if (rangeBookmark) {
            return rangeBookmark;
        }
        const baseURL = frameComp.getBaseBukURL();
        const address = parseBukURL(baseURL);
        address.anchor = calculatePPageFromPage(this.getCurrentPage(), this.getTotalPageCount());
        return {
            type: AnnotationType.Bookmark,
            url: address.toString(),
            text: '',
            styleClass: null,
        };
    }
    createHighlight(range, styleClass, options) {
        const frameComp = this._getFrameComponentContainingRange(range);
        return frameComp.createHighlight(range instanceof Address ? range.range : range, styleClass, options);
    }
    changeHighlight(range, currStyleClass, newStyleClass) {
        const frameComp = this._getFrameComponentContainingRange(range);
        return frameComp.changeHighlight(range instanceof Address ? range.range : range, currStyleClass, newStyleClass);
    }
    removeHighlight(range, styleClass) {
        const frameComp = this._getFrameComponentContainingRange(range);
        return frameComp.removeHighlight(range instanceof Address ? range.range : range, styleClass);
    }
    getParentHighlightsFromRange(range) {
        const frameComp = this._getFrameComponentContainingRange(range);
        return frameComp.getParentHighlightsFromRange(range);
    }
    getSelection() {
        let selection = null;
        this._frameComps.forEach((frameComp, compIndex) => {
            if ((compIndex === 0 && !this._leftItem) ||
                (compIndex === 1 && !this._rightItem)) {
                return;
            }
            selection = frameComp.getContentsSelection();
        });
        return selection;
    }
    clearSelection() {
        this._frameComps.forEach((frameComp) => frameComp.clearSelection());
    }
    zoom(scale) {
        if (!this._canZoom()) {
            return;
        }
        this._zoomElem.zoom(scale);
    }
    resetZoom(scale, centerHorizontally) {
        this._zoomElem.reset(scale, centerHorizontally);
    }
    pauseAllMedia() {
        this._frameComps.forEach((frameComp, compIndex) => {
            if ((compIndex === 0 && !this._leftItem) ||
                (compIndex === 1 && !this._rightItem)) {
                return;
            }
            frameComp.pauseAllMedia();
        });
    }
    isShowingItem(iid = '') {
        return this._leftItem?.iid === iid || this._rightItem?.iid === iid;
    }
    clearMediaOverlayActiveClass() {
        const playbackActiveClass = this._getMediaOverlayPlaybackActiveClass();
        const activeClass = this._getMediaOverlayActiveClass();
        this._frameComps.forEach((frameComp) => {
            frameComp.setStyleClassToDocElementAtIframe(playbackActiveClass, true);
            frameComp.setStyleClassToElementsAtIframe(`.${activeClass}`, activeClass, true);
        });
    }
    setMediaOverlayActiveClass(iid, textId) {
        const playbackActiveClass = this._getMediaOverlayPlaybackActiveClass();
        const activeClass = this._getMediaOverlayActiveClass();
        this._frameComps.forEach((frameComp, index) => {
            const item = index === 0 ? this._leftItem : this._rightItem;
            if (!item) {
                return;
            }
            if (item.iid !== iid) {
                frameComp.setStyleClassToDocElementAtIframe(playbackActiveClass, true);
                frameComp.setStyleClassToElementsAtIframe(`.${activeClass}`, activeClass, true);
            }
            else {
                frameComp.setStyleClassToDocElementAtIframe(playbackActiveClass);
                frameComp.setStyleClassToElementsAtIframe(`#${textId}`, activeClass);
            }
        });
    }
    getMediaOverlayElementInfoFromRange(range) {
        const findMOElement = (startElement) => {
            return findNodeFrom(startElement, (node) => isElement(node) && node.hasAttribute(SMIL_TEXT_ITEM_ATTR), 4);
        };
        const moElement = findElementFromRange(range, findMOElement);
        if (!moElement) {
            return null;
        }
        const frameComp = this._getFrameComponentContainingRange(range);
        const address = parseBukURL(frameComp.getBaseBukURL());
        return {
            iid: address.iid,
            textId: moElement.id,
        };
    }
    getMediaOverlayElementsInfo() {
        const result = [];
        this._frameComps.forEach((frameComp, compIndex) => {
            const iid = (compIndex === 0 ? this._leftItem : this._rightItem)?.iid;
            if (!iid) {
                return;
            }
            const textElems = frameComp.getElementsAtIframe(`[${SMIL_TEXT_ITEM_ATTR}]`);
            textElems.forEach((elem) => {
                if (!elem.id) {
                    return;
                }
                result.push({
                    iid,
                    textId: elem.id,
                    page: frameComp.getPageForElement(elem),
                });
            });
        });
        return result;
    }
    getFirstVisibleMediaOverlayElementInfo() {
        let result;
        this._frameComps.forEach((frameComp, compIndex) => {
            const iid = (compIndex === 0 ? this._leftItem : this._rightItem)?.iid;
            if (!iid) {
                return;
            }
            if (result) {
                return;
            }
            const currentPage = frameComp.getCurrentPage();
            const textId = frameComp
                .getElementsAtIframe(`[${SMIL_TEXT_ITEM_ATTR}]`)
                .find((elem) => {
                if (frameComp.getLayout() === FrameLayout.Scroll) {
                    return isInViewport(elem);
                }
                else {
                    return frameComp.getPageForElement(elem) === currentPage;
                }
            })?.id;
            if (textId) {
                result = {
                    iid,
                    textId,
                };
            }
        });
        return result;
    }
    getCurrentPrintPages() {
        const printPages = new Set();
        this._frameComps.forEach((frameComp) => {
            const printPagesByPage = this._printPageInfo?.get(frameComp);
            if (!printPagesByPage) {
                return;
            }
            const currentPrintPages = printPagesByPage[frameComp.getCurrentPage() - 1];
            currentPrintPages?.forEach((page) => printPages.add(page));
        });
        return [...printPages];
    }
    setLanguages(languages) {
        const rightPage = this._frameComps.last;
        rightPage.setLanguages(languages);
    }
    isFragmentInViewport(fragment) {
        const element = this._frameComps.last.getElementsAtIframe(`#${fragment}`)[0];
        return (element && this._frameComps.last.isElementAtCurrentPage(element, true));
    }
    createRangeFromElements(startId, endId, iid) {
        const frameComp = iid
            ? this._getFrameComponentForIid(iid)
            : this._frameComps.last;
        if (!frameComp) {
            throw new Error('no active page with the given iid');
        }
        return frameComp.createRangeFromElements(startId, endId);
    }
    getVisibleRanges() {
        return this._frameComps.reduce((result, frameComp, index) => {
            if ((index === 0 && !this._leftItem) ||
                (index === 1 && !this._rightItem)) {
                return result;
            }
            const range = frameComp.getVisibleRange();
            range && result.push(range);
            return result;
        }, []);
    }
    getAddressFromRange(range) {
        return this._getFrameComponentContainingRange(range).getAddressFromRange(range);
    }
    _setPrintPageInfo() {
        const map = new Map();
        this._frameComps.forEach((frameComp, compIndex) => {
            if ((compIndex === 0 && !this._leftItem) ||
                (compIndex === 1 && !this._rightItem)) {
                return;
            }
            map.set(frameComp, frameComp.getPrintPagesByPage());
        });
        this._printPageInfo = map;
    }
    _canZoom() {
        return this._frameComps
            .map((frameComp, compIndex) => {
            if ((compIndex === 0 && !this._leftItem) ||
                (compIndex === 1 && !this._rightItem)) {
                return true;
            }
            return frameComp.getLayout() === FrameLayout.Fixed;
        })
            .every((canZoom) => canZoom);
    }
    _toggleZoom(center = { x: 0, y: 0 }) {
        if (!this._canZoom()) {
            return;
        }
        this._zoomElem.toggle(center);
    }
    _canChangePageByTap() {
        return (this._settingStoreService.settings.pagingMode.value !==
            PagingMode.Scroll && this._libConfig.pageGestureEnabled);
    }
    _changePageByTap(tapOffsetX) {
        if (!this._canChangePageByTap()) {
            return false;
        }
        const pageWidth = this._element.nativeElement.offsetWidth;
        if (tapOffsetX < pageWidth * PAGE_CHANGE_GESTURE_AREA) {
            this._eventBus.emit('changePage', {
                direction: Direction.Prev,
                trigger: 'gesture',
            });
            return true;
        }
        if (tapOffsetX > pageWidth * (1 - PAGE_CHANGE_GESTURE_AREA)) {
            this._eventBus.emit('changePage', {
                direction: Direction.Next,
                trigger: 'gesture',
            });
            return true;
        }
        return false;
    }
    _getMediaOverlayPlaybackActiveClass() {
        return (this.mediaOverlayMeta?.playback_active_class ??
            DEFAULT_MO_PLAYBACK_ACTIVE_CLASS);
    }
    _getMediaOverlayActiveClass() {
        return this.mediaOverlayMeta?.active_class ?? DEFAULT_MO_ACTIVE_CLASS;
    }
    _pageClicked(target, clickLocation) {
        let clientX = clickLocation.x;
        if (IS_TOUCH_DEVICE) {
            const windowScale = getWindowScale();
            clientX *= windowScale;
        }
        const offset = getLocationInElement(this._element.nativeElement, clickLocation);
        const isPageChangeGesture = this._changePageByTap(this._element.nativeElement.getBoundingClientRect().left < 0
            ? clientX
            : offset.x);
        this._eventBus.emit('pageTap', {
            target,
            offsetX: offset.x,
            offsetY: offset.y,
            isPageChangeGesture,
        });
    }
    _onPageClick(event) {
        this.clearSelection();
        this._pageClicked(event.target, event.center);
    }
    _onPageDblClick(event) {
        if (IS_TOUCH_DEVICE) {
            return;
        }
        this.clearSelection();
        const offset = getLocationInElement(this._element.nativeElement, event.center);
        this._toggleZoom({
            x: offset.x,
            y: offset.y,
        });
    }
    _onZoomScaleChange(scale) {
        this.zoomScaleChange.emit({ target: this, scale });
    }
    _onFrameContentDblClick(frameIndex, event) {
        if (IS_TOUCH_DEVICE) {
            return;
        }
        const iframe = this._frameComps.get(frameIndex).iframe;
        this._toggleZoom({
            x: event.center.x + iframe.offsetLeft,
            y: event.center.y + iframe.offsetTop,
        });
    }
    _onFrameContentMediaOverlayClick(frameIndex, textId) {
        const item = frameIndex === 0 ? this._leftItem : this._rightItem;
        this.mediaOverlayClick.emit({ iid: item.iid, textId });
    }
    _onFrameContentAddressClick(frameIndex, address) {
        this._addressStoreService.update(address);
    }
    _onFrameContentHighlightClick(frameIndex, event) {
        const zoomScale = Math.round(this._pageContentElem.nativeElement.getBoundingClientRect().width) / this._pageContentElem.nativeElement.offsetWidth;
        const iframeBoundingRect = this._frameComps
            .get(frameIndex)
            .getIframeBoundingRect();
        const client = {
            x: event.clientPoint.x * zoomScale + iframeBoundingRect.left,
            y: event.clientPoint.y * zoomScale + iframeBoundingRect.top,
        };
        const offset = getLocationInElement(this._element.nativeElement, client);
        this._eventBus.emit('highlightClick', {
            highlights: event.highlights,
            offsetX: offset.x,
            offsetY: offset.y,
        });
    }
    _onFramePageClick(frameIndex, event) {
        const zoomScale = Math.round(this._pageContentElem.nativeElement.getBoundingClientRect().width) / this._pageContentElem.nativeElement.offsetWidth;
        const iframeBoundingRect = this._frameComps
            .get(frameIndex)
            .getIframeBoundingRect();
        const client = {
            x: event.center.x * zoomScale + iframeBoundingRect.left,
            y: event.center.y * zoomScale + iframeBoundingRect.top,
        };
        this._pageClicked(event.target, client);
    }
    _onFramePageSwipe(frameIndex, direction) {
        getWindowScale() === 1 &&
            !isWindowZoomed() &&
            this._eventBus.emit('changePage', {
                direction: direction < 0 ? Direction.Prev : Direction.Next,
                trigger: 'gesture',
            });
    }
    _onFrameContentSelectionChange(frameIndex, event) {
        this._eventBus.emit('selectionChange', event);
    }
    _onFrameContentKeydown(frameIndex, direction) {
        if (this._zoomElem.isZoomed) {
            return;
        }
        this._eventBus.emit('changePage', { direction, trigger: 'keyboard' });
    }
    _onFrameBoundaryScroll(frameIndex, direction) {
        this._eventBus.emit('changePage', {
            direction: direction < 0 ? Direction.Prev : Direction.Next,
            trigger: 'scroll',
        });
    }
    _onFrameScrolled(frameIndex, event) {
        this.pageScrolled.emit(event);
    }
    _onFramePageSettled(frameIndex) {
        this.pageSettled.emit();
    }
    _getFrameComponentForIid(iid = '') {
        if (iid === this._leftItem?.iid) {
            return this._frameComps.first;
        }
        else if (iid === this._rightItem?.iid) {
            return this._frameComps.last;
        }
        return null;
    }
    _getFrameComponentContainingRange(range) {
        let frameComp;
        if (range instanceof Address) {
            frameComp = this._getFrameComponentForIid(range.iid);
        }
        else {
            const rangeDocument = getDocumentFromRange(range);
            frameComp = this._frameComps.find((comp) => comp.document === rangeDocument);
        }
        if (!frameComp) {
            throw new Error('Cannot find an active page containing a given range');
        }
        return frameComp;
    }
    _calculateFramesSize(items) {
        const pageSize = {
            width: this._pageContentElem.nativeElement.offsetWidth / items.length,
            height: this._pageContentElem.nativeElement.offsetHeight,
        };
        return items.reduce((result, item) => {
            if (item.layout !== 'fixed') {
                return result;
            }
            const scale = getContentsScale(pageSize, {
                width: item.fixedWidth,
                height: item.fixedHeight,
            });
            result.width += item.fixedWidth * scale;
            result.height = Math.max(result.height, item.fixedHeight * scale);
            return result;
        }, { width: 0, height: 0 });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: PageComponent, deps: [{ token: i0.ElementRef }, { token: LibConfigService }, { token: SettingsStoreService }, { token: AddressStoreService }, { token: EventBusService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.3", type: PageComponent, selector: "bukv-page", inputs: { mediaOverlayMeta: "mediaOverlayMeta" }, outputs: { loaded: "loaded", domLoaded: "domLoaded", pageScrolled: "pageScrolled", pageSettled: "pageSettled", mediaOverlayClick: "mediaOverlayClick", zoomScaleChange: "zoomScaleChange" }, viewQueries: [{ propertyName: "_zoomElem", first: true, predicate: ScrollZoomComponent, descendants: true }, { propertyName: "_pageContentElem", first: true, predicate: ["pageContent"], descendants: true }, { propertyName: "_frameComps", predicate: FrameComponent, descendants: true }], ngImport: i0, template: "<bukv-scroll-zoom (scaleChange)=\"_onZoomScaleChange($event)\">\n  <div class=\"bukv_page-content\" #pageContent>\n    <div\n      class=\"bukv_frames\"\n      [class.bukv_is-multi-column]=\"_isMultiColumn\"\n      [style.width.px]=\"_framesWidth\"\n      [style.height.px]=\"_framesHeight\"\n    >\n      <bukv-frame\n        (frameSelectionChange)=\"_onFrameContentSelectionChange(0, $event)\"\n        (framePageChangeKeydown)=\"_onFrameContentKeydown(0, $event)\"\n        (frameBoundaryScroll)=\"_onFrameBoundaryScroll(0, $event)\"\n        (frameDoubleClick)=\"_onFrameContentDblClick(0, $event)\"\n        (frameAddressClick)=\"_onFrameContentAddressClick(0, $event)\"\n        (frameHighlightClick)=\"_onFrameContentHighlightClick(0, $event)\"\n        (frameMediaOverlayClick)=\"_onFrameContentMediaOverlayClick(0, $event)\"\n        (frameClick)=\"_onFramePageClick(0, $event)\"\n        (frameSwipe)=\"_onFramePageSwipe(0, $event)\"\n      ></bukv-frame>\n      <bukv-frame\n        (frameSelectionChange)=\"_onFrameContentSelectionChange(1, $event)\"\n        (framePageChangeKeydown)=\"_onFrameContentKeydown(1, $event)\"\n        (frameBoundaryScroll)=\"_onFrameBoundaryScroll(1, $event)\"\n        (frameScrolled)=\"_onFrameScrolled(1, $event)\"\n        (frameDoubleClick)=\"_onFrameContentDblClick(1, $event)\"\n        (frameAddressClick)=\"_onFrameContentAddressClick(1, $event)\"\n        (frameHighlightClick)=\"_onFrameContentHighlightClick(1, $event)\"\n        (frameMediaOverlayClick)=\"_onFrameContentMediaOverlayClick(1, $event)\"\n        (frameClick)=\"_onFramePageClick(1, $event)\"\n        (frameSwipe)=\"_onFramePageSwipe(1, $event)\"\n        (framePageSettled)=\"_onFramePageSettled(1)\"\n      ></bukv-frame>\n    </div>\n  </div>\n</bukv-scroll-zoom>\n", styles: [":host{display:block;height:100%;-webkit-user-select:none;user-select:none}.bukv_page-content{height:100%;position:relative;display:flex;align-items:center;justify-content:center}.bukv_frames{width:100%;height:100%;overflow:hidden}bukv-frame{width:100%;height:100%}.bukv_frames.bukv_is-multi-column bukv-frame{width:50%}.bukv_frames:not(.bukv_is-multi-column) bukv-frame:first-child{display:none}\n"], dependencies: [{ kind: "component", type: FrameComponent, selector: "bukv-frame", outputs: ["frameLoad", "frameDOMLoad", "frameScrolled", "frameBoundaryScroll", "frameAddressClick", "frameMediaOverlayClick", "framePageSettled"] }, { kind: "component", type: ScrollZoomComponent, selector: "bukv-scroll-zoom", inputs: ["animDuration", "toggleScale"], outputs: ["scaleChange", "scaleStart", "scaleEnd"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: PageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bukv-page', template: "<bukv-scroll-zoom (scaleChange)=\"_onZoomScaleChange($event)\">\n  <div class=\"bukv_page-content\" #pageContent>\n    <div\n      class=\"bukv_frames\"\n      [class.bukv_is-multi-column]=\"_isMultiColumn\"\n      [style.width.px]=\"_framesWidth\"\n      [style.height.px]=\"_framesHeight\"\n    >\n      <bukv-frame\n        (frameSelectionChange)=\"_onFrameContentSelectionChange(0, $event)\"\n        (framePageChangeKeydown)=\"_onFrameContentKeydown(0, $event)\"\n        (frameBoundaryScroll)=\"_onFrameBoundaryScroll(0, $event)\"\n        (frameDoubleClick)=\"_onFrameContentDblClick(0, $event)\"\n        (frameAddressClick)=\"_onFrameContentAddressClick(0, $event)\"\n        (frameHighlightClick)=\"_onFrameContentHighlightClick(0, $event)\"\n        (frameMediaOverlayClick)=\"_onFrameContentMediaOverlayClick(0, $event)\"\n        (frameClick)=\"_onFramePageClick(0, $event)\"\n        (frameSwipe)=\"_onFramePageSwipe(0, $event)\"\n      ></bukv-frame>\n      <bukv-frame\n        (frameSelectionChange)=\"_onFrameContentSelectionChange(1, $event)\"\n        (framePageChangeKeydown)=\"_onFrameContentKeydown(1, $event)\"\n        (frameBoundaryScroll)=\"_onFrameBoundaryScroll(1, $event)\"\n        (frameScrolled)=\"_onFrameScrolled(1, $event)\"\n        (frameDoubleClick)=\"_onFrameContentDblClick(1, $event)\"\n        (frameAddressClick)=\"_onFrameContentAddressClick(1, $event)\"\n        (frameHighlightClick)=\"_onFrameContentHighlightClick(1, $event)\"\n        (frameMediaOverlayClick)=\"_onFrameContentMediaOverlayClick(1, $event)\"\n        (frameClick)=\"_onFramePageClick(1, $event)\"\n        (frameSwipe)=\"_onFramePageSwipe(1, $event)\"\n        (framePageSettled)=\"_onFramePageSettled(1)\"\n      ></bukv-frame>\n    </div>\n  </div>\n</bukv-scroll-zoom>\n", styles: [":host{display:block;height:100%;-webkit-user-select:none;user-select:none}.bukv_page-content{height:100%;position:relative;display:flex;align-items:center;justify-content:center}.bukv_frames{width:100%;height:100%;overflow:hidden}bukv-frame{width:100%;height:100%}.bukv_frames.bukv_is-multi-column bukv-frame{width:50%}.bukv_frames:not(.bukv_is-multi-column) bukv-frame:first-child{display:none}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: LibConfigService }, { type: SettingsStoreService }, { type: AddressStoreService }, { type: EventBusService }], propDecorators: { _frameComps: [{
                type: ViewChildren,
                args: [FrameComponent]
            }], _zoomElem: [{
                type: ViewChild,
                args: [ScrollZoomComponent]
            }], _pageContentElem: [{
                type: ViewChild,
                args: ['pageContent']
            }], loaded: [{
                type: Output
            }], domLoaded: [{
                type: Output
            }], pageScrolled: [{
                type: Output
            }], pageSettled: [{
                type: Output
            }], mediaOverlayClick: [{
                type: Output
            }], zoomScaleChange: [{
                type: Output
            }], mediaOverlayMeta: [{
                type: Input
            }] } });

class SearchService {
    constructor(_ngZone) {
        this._ngZone = _ngZone;
        this._workCallbacks = {};
        const blobURL = URL.createObjectURL(new Blob([
            '(',
            (() => {
                onmessage = (event) => {
                    if (!event.data?.workId) {
                        return;
                    }
                    const { workId, keyword } = event.data;
                    let contents = event.data.contents;
                    const words = contents.split(/\s+/);
                    contents = words.join(' ');
                    // no whitespace, lower case
                    const contentsForSearch = words.join('').toLowerCase();
                    const keywordForSearch = keyword.replace(/\s/g, '').toLowerCase();
                    const result = [];
                    if (keywordForSearch.length > 0) {
                        try {
                            let i = 0;
                            while ((i = contentsForSearch.indexOf(keywordForSearch, i)) > -1) {
                                const start = i + 1;
                                const end = start + keywordForSearch.length - 1;
                                let startIndexIncludingWhitespace;
                                let prevWordEnd = -1;
                                for (let j = 0; j < words.length; j++) {
                                    const wordStart = prevWordEnd + 1;
                                    const wordEnd = prevWordEnd + words[j].length;
                                    if (wordStart <= i && i <= wordEnd) {
                                        startIndexIncludingWhitespace = i + j;
                                        break;
                                    }
                                    prevWordEnd = wordEnd;
                                }
                                result.push({
                                    text: contents.substr(Math.max(0, startIndexIncludingWhitespace - 40), 100),
                                    address: `${start}-${end}`,
                                });
                                i += keywordForSearch.length;
                            }
                        }
                        catch (error) {
                            console.log(error);
                        }
                    }
                    postMessage({
                        workId,
                        result,
                    });
                };
            }).toString(),
            ')()',
        ], { type: 'application/javascript' }));
        this._worker = new Worker(blobURL);
        // 퍼포먼스를 위해 존 바깥에서 실행
        this._ngZone.runOutsideAngular(() => {
            this._worker.addEventListener('message', (event) => {
                if (this._workCallbacks[event.data.workId]) {
                    this._workCallbacks[event.data.workId](event);
                    delete this._workCallbacks[event.data.workId];
                }
            });
        });
    }
    searchContents(keyword, contents) {
        return new Observable((observer) => {
            const workId = Math.floor(Math.random() * 10000000000).toString();
            const timeoutId = setTimeout(() => {
                delete this._workCallbacks[workId];
                observer.complete();
            }, 60 * 1000);
            this._workCallbacks[workId] = (event) => {
                clearTimeout(timeoutId);
                observer.next(event.data.result);
                observer.complete();
            };
            this._worker.postMessage({
                workId,
                keyword,
                contents,
            });
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: SearchService, deps: [{ token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: SearchService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: SearchService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i0.NgZone }] });

const LAST_PPAGE = 0.9999999;
class PagesComponent extends PagesBaseComponent {
    constructor(_renderer, _element, _ngZone, _libConfig, _eventBus, _addressStore, _settingsStore, _contentsService, _contentsProcessorService, _searchService) {
        super(_renderer, _element, _libConfig, _eventBus, _settingsStore);
        this._renderer = _renderer;
        this._element = _element;
        this._ngZone = _ngZone;
        this._addressStore = _addressStore;
        this._settingsStore = _settingsStore;
        this._contentsService = _contentsService;
        this._contentsProcessorService = _contentsProcessorService;
        this._searchService = _searchService;
        this._itemLoadEventUnsubscriber$ = new Subject();
        this._contentsCache = new Map();
        this._isLoadingItem = false;
        this._isSettingPage = false;
        /**
         * 유저 스크롤에 의해 주소 변경 이벤트가 일어날 때 해당 주소로 다시 iframe의 scrollTop을 셋팅하지 않기 위한 변수
         */
        this._isAddressChangedByUserScroll = false;
        this._mediaOverlayPlaybackRate = 1;
        this._toc = [];
    }
    get _isScrollPagingMode() {
        return this._settingsStore.settings.pagingMode.value === PagingMode.Scroll;
    }
    get _inactivePageComp() {
        return this._pageComps.find((c) => c !== this._activePageComp);
    }
    ngOnInit() { }
    ngAfterViewInit() {
        this._addressChange$.subscribe(({ newAddress, oldAddress, changeType }) => {
            this._onAddressChange(changeType, newAddress, oldAddress);
        });
        this._changePage$.subscribe((direction) => {
            this._changePageToDirection(direction);
        });
        this._settingsChange$.subscribe(({ oldSettings, newSettings }) => {
            this._onSettingsChange(newSettings, oldSettings);
        });
        fromResizeEvent(this._element.nativeElement)
            .pipe(takeUntil(this._unsubscriber))
            .subscribe(() => {
            this._settingsStore.resetSettings(this.book, this._getViewerSize());
            if (!this._isLoadingItem) {
                this._onItemChange(this._address);
            }
        });
        IS_TOUCH_DEVICE &&
            fromSwipeEvent(this._element.nativeElement)
                .pipe(takeUntil(this._unsubscriber), filter(() => getWindowScale() === 1 && !isWindowZoomed()))
                .subscribe((direction) => {
                this._eventBus.emit('changePage', {
                    direction: direction === SwipeDirection.Left
                        ? Direction.Next
                        : Direction.Prev,
                    trigger: 'gesture',
                });
            });
    }
    ngOnDestroy() {
        this._mediaOverlay?.destroy();
        super.ngOnDestroy();
    }
    set annotations(annotations) {
        const deletedAnnotataions = getDeletedAnnotations(this._annotations ?? [], annotations ?? []);
        this._unhighlightAnnotations(deletedAnnotataions);
        this._annotations = annotations;
        if (!this._isLoadingItem) {
            this._setPageHighlights();
            this._checkPageBookmarks();
        }
    }
    get annotations() {
        return this._annotations;
    }
    set mediaOverlayPlaybackRate(value) {
        this._mediaOverlayPlaybackRate = value;
        this._mediaOverlay?.setPlaybackRate(value);
    }
    get mediaOverlayPlaybackRate() {
        return this._mediaOverlayPlaybackRate;
    }
    createHighlight(range, styleClass, options = {}) {
        if (!this._activePageComp) {
            return null;
        }
        const { created: annotation, merged: mergedAnnotations } = this._activePageComp.createHighlight(range, styleClass, options);
        if (options.emitEvent !== false) {
            this.annotationCreated.emit({
                annotation,
                mergedAnnotations,
            });
        }
        return {
            annotation,
            mergedAnnotations,
        };
    }
    changeHighlight(range, currStyleClass, newStyleClass, options = {}) {
        if (!this._activePageComp) {
            return null;
        }
        const annotation = this._activePageComp.changeHighlight(range, currStyleClass, newStyleClass);
        if (annotation && options.emitEvent !== false) {
            this.annotationChanged.emit({
                annotation,
                oldStyleClass: currStyleClass,
            });
        }
        return annotation;
    }
    removeHighlight(range, styleClass, options = {}) {
        if (!this._activePageComp) {
            return null;
        }
        const annotation = this._activePageComp.removeHighlight(range, styleClass);
        if (annotation && options.emitEvent !== false) {
            this.annotationRemoved.emit({
                annotations: [annotation],
            });
        }
        return annotation;
    }
    getHighlightsFromRange(range) {
        if (!this._activePageComp) {
            throw new Error('no active page');
        }
        return this._activePageComp.getParentHighlightsFromRange(range);
    }
    getSelection() {
        if (!this._activePageComp) {
            return null;
        }
        return this._activePageComp.getSelection();
    }
    clearSelection() {
        this._activePageComp?.clearSelection();
    }
    search(keyword) {
        const searches = this.book.items.map((item) => {
            return this._getContents(item).pipe(catchError(() => of({ textContent: '' })), switchMap(({ textContent }) => {
                return this._searchService.searchContents(keyword, textContent);
            }), map((results) => {
                return results.map(({ text, address }) => {
                    return {
                        text,
                        url: createBukURL(this.book.meta.bid, item.iid, address),
                    };
                });
            }));
        });
        return zip(...searches).pipe(map((results) => {
            return results.reduce((bookResult, itemResult) => {
                return bookResult.concat(itemResult);
            }, []);
        }), observeOn(enterZone(this._ngZone)));
    }
    zoom(scale) {
        this._activePageComp?.zoom(scale);
    }
    _onPageZoomScaleChange(event) {
        if (event.target !== this._activePageComp) {
            return;
        }
        if (event.scale !== this._zoomScale) {
            this._zoomScale = event.scale;
            this.zoomScaleChange.emit({ scale: event.scale });
        }
    }
    _onPageScrolled(isEnded) {
        const currentPage = this._activePageComp.getCurrentPage();
        const newAddress = this._address.clone();
        newAddress.anchor = this._getPPageFromPage(currentPage);
        delete newAddress.query?.highlight;
        delete newAddress.query?.force;
        this._isAddressChangedByUserScroll = true;
        const updated = this._addressStore.update(newAddress);
        if (updated) {
            if (isEnded) {
                this._checkPageBookmarks();
                this._eventBus.emit('pageTransitionEnd');
            }
        }
        else {
            this._isAddressChangedByUserScroll = false;
            this._setPage(this._address);
        }
    }
    _onPageSettled() {
        if (!this._isLoadingItem) {
            this._eventBus.emit('pageTransitionEnd');
        }
        this._isSettingPage = false;
        this._checkPageBookmarks();
        this._checkMediaOverlayAfterPageSettled();
    }
    _onMediaOverlayClick({ iid, textId }) {
        const moPosition = this._mediaOverlay.getPositionByTextId(iid, textId);
        if (moPosition) {
            this._mediaOverlay.play(moPosition);
        }
    }
    _getPPageFromPage(page) {
        return calculatePPageFromPage(page, this._activePageComp.getTotalPageCount());
    }
    _changePageToDirection(direction) {
        if (!this._activePageComp) {
            return;
        }
        const totalPageCount = this._activePageComp.getTotalPageCount();
        const currentPage = this._activePageComp.getCurrentPage();
        const nextPage = currentPage + (direction === Direction.Prev ? -1 : 1);
        if (nextPage > totalPageCount || nextPage < 1) {
            this._changeItemToDirection(direction);
            return;
        }
        const newAddress = this._address.clone();
        newAddress.anchor = this._getPPageFromPage(nextPage);
        delete newAddress.query?.highlight;
        delete newAddress.query?.force;
        this._addressStore.update(newAddress);
    }
    _changeItemToDirection(direction) {
        if (!this._address) {
            return;
        }
        const currentIid = this._address.iid ?? this.book.items[0].iid;
        const nextItem = calculateNextItem(this.book, currentIid, direction, this._settingsStore.settings.multiColumn.value);
        if (!nextItem) {
            this.pageChangeCanceled.emit({
                direction,
                code: PageChangeCancelCode.NoNextItem,
            });
            return;
        }
        const newAddress = this._address.clone();
        newAddress.iid = nextItem.iid;
        newAddress.anchor = direction === Direction.Prev ? LAST_PPAGE : undefined;
        delete newAddress.query?.highlight;
        delete newAddress.query?.force;
        this._addressStore.update(newAddress);
    }
    _onAddressChange(type, newAddress, oldAddress) {
        const fixed = this._fixAddress(newAddress);
        if (fixed) {
            this._addressStore.update(newAddress);
        }
        switch (type) {
            case AddressChangeType.Book:
                this._contentsCache.clear();
                this._pageBookmarks = [];
                this._initMediaOverlay();
                this._initTOC();
                this._onItemChange(newAddress, oldAddress);
                break;
            case AddressChangeType.Item:
                if (!this._settingsStore.settings.multiColumn.value ||
                    this._isSpreadItemsChanged(newAddress, oldAddress)) {
                    this._onItemChange(newAddress, oldAddress);
                }
                break;
            case AddressChangeType.Page:
                this._onPageChange(newAddress, oldAddress);
                break;
            case AddressChangeType.Query:
                this._onQueryChange(newAddress, oldAddress);
                break;
            default:
                break;
        }
    }
    /**
     * Address 객체에 생략된 정보 추가, 기존 객체를 수정함
     * @param address 변경할 Address 객체
     * @returns 변경 여부
     */
    _fixAddress(address) {
        let fixed = false;
        /**
         * 다국어 책 언어 파라미터 추가
         */
        if (this.book.meta.locales &&
            this.book.meta.locales.length > 0 &&
            !address.query?.l) {
            if (!address.query) {
                address.query = {};
            }
            address.query.l = this.book.meta.locales.map(([lang]) => lang).join(',');
            fixed = true;
        }
        return fixed;
    }
    playMediaOverlay(prevOrNext) {
        if (!this._activePageComp || !this._mediaOverlay) {
            return;
        }
        if (prevOrNext != null && this._mediaOverlay.isPlaying) {
            const newPosition = prevOrNext < 0
                ? this._mediaOverlay.getPrevPosition()
                : this._mediaOverlay.getNextPosition();
            if (newPosition) {
                this._playMediaOverlay(newPosition);
            }
            else {
                this._mediaOverlay.stop();
            }
            return;
        }
        const currentPage = this._activePageComp.getCurrentPage();
        const moElementsInfoAtPage = this._activePageComp.getMediaOverlayElementsInfo();
        // 현재 보여지고 있는 페이지에 재생을 멈췄던 미디어 오버레이 요소가 있는 경우
        const lastPausedPosition = this._mediaOverlay.lastPausedPosition;
        if (lastPausedPosition) {
            const iid = lastPausedPosition.iid;
            const textId = this._mediaOverlay.getParByPosition(lastPausedPosition).text_id;
            const isVisible = moElementsInfoAtPage.find((info) => info.iid === iid &&
                info.textId === textId &&
                info.page === currentPage);
            if (isVisible) {
                this._playMediaOverlay(lastPausedPosition);
                return;
            }
        }
        // 현재 페이지부터 시작해서 제일 먼저 나오는 미디어 오버레이 요소 찾음
        const nearestFromPage = moElementsInfoAtPage.find((info) => info.page >= currentPage);
        if (nearestFromPage) {
            const nearestPosition = this._mediaOverlay.getPositionByTextId(nearestFromPage.iid, nearestFromPage.textId);
            if (nearestPosition) {
                this._playMediaOverlay(nearestPosition);
                return;
            }
        }
        // 현재 아이템부터 시작해서 제일 먼저 나오는 미디어 오버레이 요소 찾음
        const currentIid = this._address.iid ?? this.book.items[0].iid;
        const currentItemIndex = this.book.getItemIndex(currentIid);
        const nearestFromItem = findItemToDirection(this.book.items, prevOrNext ?? 1, (item) => !!item.smil?.length, currentItemIndex);
        if (nearestFromItem) {
            this._playMediaOverlay({ iid: nearestFromItem.iid, parIndex: 0 });
        }
    }
    playMediaOverlayFromRange(range) {
        if (!this._mediaOverlay) {
            return;
        }
        const smilInfo = this._activePageComp?.getMediaOverlayElementInfoFromRange(range);
        if (!smilInfo) {
            return;
        }
        const position = this._mediaOverlay.getPositionByTextId(smilInfo.iid, smilInfo.textId);
        if (!position) {
            return;
        }
        this._playMediaOverlay(position);
    }
    pauseMediaOverlay() {
        this._mediaOverlay?.pause();
    }
    isPlayingMediaOverlay() {
        return !!this._mediaOverlay?.isPlaying;
    }
    canPlayMediaOverlayFromRange(range) {
        if (!this._mediaOverlay) {
            return false;
        }
        return !!this._activePageComp?.getMediaOverlayElementInfoFromRange(range);
    }
    createRangeFromElements(startId, endId, iid) {
        if (!this._activePageComp) {
            throw new Error('no active page');
        }
        return this._activePageComp.createRangeFromElements(startId, endId, iid);
    }
    getVisibleRanges() {
        if (!this._activePageComp) {
            throw new Error('no active page');
        }
        return this._activePageComp.getVisibleRanges();
    }
    getAddressFromRange(range) {
        if (!this._activePageComp) {
            throw new Error('no active page');
        }
        return this._activePageComp.getAddressFromRange(range);
    }
    _playMediaOverlay(position) {
        if (!this._activePageComp || !this._mediaOverlay) {
            return;
        }
        const par = this._mediaOverlay.getParByPosition(position);
        if (!par) {
            console.warn('invalid mo position');
            return;
        }
        // 재생해야 하는 미디어 오버레이가 현재 아이템에 해당하지 않음
        if (!this._activePageComp.isShowingItem(position.iid)) {
            const updated = this._addressStore.update(new Address(this._address.bid, position.iid, par.text_id));
            if (updated) {
                this._pendingMediaOverlayPosition = position;
            }
            return;
        }
        // 현재 아이템 내에 있지만 현재 페이지는 아님
        if (!this._activePageComp.isFragmentInViewport(par.text_id) &&
            !this._activePageComp.isUserScrolling) {
            const updated = this._addressStore.updateAnchor(par.text_id);
            if (!updated) {
                return;
            }
        }
        this._mediaOverlay.play(position);
    }
    _checkMediaOverlayAfterPageSettled() {
        if (!this._mediaOverlay) {
            return;
        }
        // 재생 중 아이템 변경이 필요하여 딜레이 된 상태
        if (this._pendingMediaOverlayPosition) {
            const canPlayPendingMOPosition = this._activePageComp?.isShowingItem(this._pendingMediaOverlayPosition.iid);
            if (canPlayPendingMOPosition) {
                this._mediaOverlay.play(this._pendingMediaOverlayPosition);
                this._pendingMediaOverlayPosition = undefined;
                return;
            }
        }
        else if (this._mediaOverlay.isPlaying) {
            // 재생을 이어가야 하는 상태
            const currentMOPosition = this._mediaOverlay.currentPosition;
            const par = this._mediaOverlay.getParByPosition(currentMOPosition);
            const currentPage = this._activePageComp.getCurrentPage();
            const page = this._activePageComp.getPageForAnchor(par.text_id); // FIXME: fixed layout
            if (this._activePageComp.isShowingItem(currentMOPosition.iid) &&
                page === currentPage) {
                // 이미 재생 중
                return;
            }
            else {
                // 다른 페이지에서 재생 중이었음 -> 현재 페이지에서 재생 재개
                const firstVisible = this._activePageComp.getFirstVisibleMediaOverlayElementInfo();
                if (firstVisible) {
                    // 재개 가능 아이템이 있음
                    const firstPosition = this._mediaOverlay.getPositionByTextId(firstVisible.iid, firstVisible.textId);
                    firstPosition && this._mediaOverlay.play(firstPosition);
                    return;
                }
            }
        }
        this._mediaOverlay.stop();
    }
    _initMediaOverlay() {
        if (this._mediaOverlay) {
            this._mediaOverlay.destroy();
            this._mediaOverlay = undefined;
        }
        if (!this.book._isMediaOverlayContent) {
            return;
        }
        this._mediaOverlay = new MediaOverlay(this.book);
        this._mediaOverlay.setPlaybackRate(this.mediaOverlayPlaybackRate);
        this._mediaOverlay.currentPosition$
            .pipe(takeUntil(this._unsubscriber), pairwise())
            .subscribe(([prevPosition, newPosition]) => {
            if (!this._activePageComp) {
                return;
            }
            if (!!prevPosition !== !!newPosition) {
                this.mediaOverlayPlayStateChange.emit({
                    isPlaying: !!newPosition,
                });
            }
            if (newPosition) {
                const par = this._mediaOverlay.getParByPosition(newPosition);
                this._activePageComp.setMediaOverlayActiveClass(newPosition.iid, par.text_id);
            }
            else {
                this._activePageComp.clearMediaOverlayActiveClass();
            }
        });
        this._mediaOverlay.clipEnded$
            .pipe(takeUntil(this._unsubscriber))
            .subscribe(() => {
            const nextPosition = this._mediaOverlay.getNextPosition();
            if (nextPosition) {
                if (!this._isLoadingItem && !this._isSettingPage) {
                    this._playMediaOverlay(nextPosition);
                }
                else {
                    // console.warn('>>>>>>>>>>> stop next item..');
                }
            }
            else {
                this._mediaOverlay.stop();
            }
        });
    }
    _onItemChange(address, oldAddress) {
        // 이전 로드 동작 중지
        this._itemLoadEventUnsubscriber$.next();
        // 유저 interaction 중지
        this._activePageComp?.clearSelection();
        this._activePageComp?.pauseAllMedia();
        // reset
        this._isAddressChangedByUserScroll = false;
        // 아이템 로드 시작
        this._isLoadingItem = true;
        this.itemLoadStart.emit({ address });
        // 불러올 아이템 찾음
        const items = calculateAddressItems(this.book, address, this._settingsStore.settings.multiColumn.value);
        if (items.length === 0) {
            this.itemLoadError.emit({
                address: address.clone(),
                code: ItemLoadErrorCode.ItemNotFound,
            });
            return;
        }
        // 페이지 로드 이벤트 리스너 추가
        this._inactivePageComp?.loaded
            .pipe(takeUntil(this._itemLoadEventUnsubscriber$), take(1))
            .subscribe((event) => {
            const isInitialLoading = !this._activePageComp;
            const skipPageAnimation = isInitialLoading || oldAddress?.bid !== address.bid;
            this._activePageComp = this._inactivePageComp;
            // 확대 배율 초기화
            this._activePageComp.resetZoom(this._zoomScale, items.length === 1);
            if (isInitialLoading) {
                this._onPageZoomScaleChange({
                    target: this._activePageComp,
                    scale: this._activePageComp.zoomScale,
                });
            }
            this.itemLoad.emit({
                address: address.clone(),
                items: items,
            });
            this._setLanguages(address);
            this._setPageHighlights();
            this._setTOCPositions();
            this._setPage(address);
            if (this._mediaOverlay && this._mediaOverlay.isPlaying) {
                const currPosition = this._mediaOverlay.currentPosition;
                const par = this._mediaOverlay.getParByPosition(currPosition);
                par &&
                    this._activePageComp.setMediaOverlayActiveClass(currPosition.iid, par.text_id);
            }
            this._isLoadingItem = false;
            this._changePageVisibility(this._activePageComp, this._inactivePageComp, skipPageAnimation);
        });
        // html 로드 시작
        zip(...items.map((i, index) => {
            return this._getContents(i).pipe(catchError((error) => throwError([error, index])));
        }))
            .pipe(takeUntil(this._itemLoadEventUnsubscriber$))
            .subscribe((results) => {
            const pageInfoArr = results.map(({ html }, index) => {
                return {
                    item: items[index],
                    html,
                };
            });
            // iframe 로드 시작
            this._inactivePageComp?.loadPage(pageInfoArr[0], pageInfoArr[1]);
        }, ([error, index]) => {
            this.itemLoadError.emit({
                address: address.clone(),
                item: items[index],
                code: error.code,
                raw: error.raw,
            });
            this._activePageComp = undefined;
        });
    }
    _onPageChange(newAddress, oldAddress) {
        if (newAddress.query?.l !== oldAddress?.query?.l) {
            this._setLanguages(newAddress);
            this._setTOCPositions();
        }
        this._setPage(newAddress);
    }
    _onQueryChange(newAddress, oldAddress) {
        if (newAddress.query?.l !== oldAddress?.query?.l) {
            this._setLanguages(newAddress);
            this._setTOCPositions();
            this._setPage(newAddress);
        }
    }
    _setPage(address) {
        const skipSetPage = this._isAddressChangedByUserScroll && address.page != null;
        if (!skipSetPage) {
            this._isSettingPage = true;
            this._activePageComp.clearSelection();
            this._activePageComp.setPage(address.anchor);
        }
        this._activePageComp.clearAnchorHighlight();
        const highlightColor = getAnchorHighlightColorFromQuery(address.query);
        if (address.range && highlightColor) {
            const iid = address.iid ?? this.book.items[0].iid;
            this._activePageComp.highlightAnchor(iid, address.range, highlightColor);
        }
        this._isAddressChangedByUserScroll = false;
        this.pageInfoChange.emit({
            pageCount: this._activePageComp.getTotalPageCount(),
            page: this._activePageComp.getCurrentPage(),
            printPageCount: this.book._totalPrintPageCount ?? null,
            printPages: this._activePageComp.getCurrentPrintPages(),
            tocIndex: this._getCurrentTOCIndex(),
        });
        // this._checkPageBookmarks();
    }
    _setLanguages(address) {
        const langsAtAddress = getLanguages(address);
        const config = (this.book.meta.locales || [])?.reduce((result, [lang]) => {
            result[lang] = langsAtAddress.includes(lang);
            return result;
        }, {});
        this._activePageComp?.setLanguages(config);
    }
    applyContentsStyles() {
        if (!this._activePageComp || this._isLoadingItem) {
            return;
        }
        this._activePageComp?.applyContentsStyles();
        this._setTOCPositions();
        this._setPage(this._address);
    }
    _onSettingsChange(newSettings, oldSettings) {
        const needReloadItem = oldSettings?.multiColumn.value !== newSettings.multiColumn.value;
        // TODO: reflowable 에선 필요 없음?
        if (needReloadItem) {
            this._onItemChange(this._address);
            return;
        }
        if (!this._activePageComp || this._isLoadingItem) {
            return;
        }
        const needRepositionPage = [
            'pagingMode',
            'fontFace',
            'fontSize',
            'lineHeight',
        ].some((key) => {
            if (!oldSettings) {
                return true;
            }
            return (oldSettings[key].value !==
                newSettings[key].value);
        });
        this._activePageComp.applySettings(newSettings);
        if (needRepositionPage) {
            this._setTOCPositions();
            this._setPage(this._address);
        }
    }
    _getContents(item) {
        if (!this._contentsCache.has(item.iid)) {
            const contents$ = this._contentsService.getItem(item.url).pipe(catchError((error) => {
                return throwError({
                    code: ItemLoadErrorCode.ContentsLoadFailed,
                    raw: error,
                });
            }), switchMap((html) => {
                try {
                    return of(this._contentsProcessorService.processContentsHTML(this.book, item, html));
                }
                catch (error) {
                    return throwError({
                        code: ItemLoadErrorCode.ContentsProcessingFailed,
                        raw: error,
                    });
                }
            }), shareReplay(1));
            this._contentsCache.set(item.iid, contents$);
        }
        return this._contentsCache.get(item.iid);
    }
    _changePageVisibility(activePageComp, inactivePageComp, skipAnimation) {
        super._changePageVisibility(activePageComp, inactivePageComp, skipAnimation || !this._settingsStore.settings.pageAnimation.value);
    }
    _setPageHighlights() {
        if (!this.annotations) {
            return;
        }
        this._highlightAnnotations(this.annotations);
    }
    _canHighlightAnnotation(annotation) {
        return annotation.address.bid === this.book.meta.bid;
    }
    _highlightAnnotations(annotations) {
        this._activePageComp?.highlight(annotations.filter((highlight) => this._canHighlightAnnotation(highlight)));
    }
    _unhighlightAnnotations(annotations) {
        this._activePageComp?.unhighlight(annotations.filter((highlight) => this._canHighlightAnnotation(highlight)));
    }
    _createBookmark() {
        if (!this._activePageComp) {
            throw new Error('faild to highlight, no active page');
        }
        return this._activePageComp.createBookmark();
    }
    _checkPageBookmarks() {
        if (!this.annotations) {
            return;
        }
        this._pageBookmarks = this.annotations.filter((annotation) => {
            return (annotation.type === AnnotationType.Bookmark &&
                this._canHighlightAnnotation(annotation) &&
                this._activePageComp?.isAnnotationAtCurrentPage(annotation));
        });
    }
    _isSpreadItemsChanged(address1, address2) {
        const items1 = this.book.getSpreadItems(address1.iid ?? this.book.items[0].iid);
        const items2 = this.book.getSpreadItems(address2.iid ?? this.book.items[0].iid);
        return items1.left !== items2.left || items1.right !== items2.right;
    }
    _initTOC() {
        this._toc = this.book.toc.map((tocItem) => {
            const address = parseBukURL(`/@${this.book.meta.bid}/${tocItem.address}`);
            return {
                address,
                itemIndex: this.book.getItemIndex(address.iid),
                page: -1,
            };
        });
    }
    _setTOCPositions() {
        this._toc.forEach((toc) => {
            if (this._activePageComp?.isShowingItem(toc.address.iid) &&
                typeof toc.address.anchor === 'string') {
                toc.page = this._activePageComp.getPageForAnchor(toc.address.anchor);
            }
        });
    }
    _getCurrentTOCIndex() {
        const currentPage = this._activePageComp.getCurrentPage();
        const pageIid = this._activePageComp._rightItem.iid;
        const currentItemIndex = this.book.getItemIndex(pageIid);
        let currentTOCIndex = -1;
        for (let i = 0; i < this._toc.length; i++) {
            const tocItem = this._toc[i];
            if (tocItem.page !== -1) {
                if (tocItem.page <= currentPage) {
                    currentTOCIndex = i;
                }
                else if (currentTOCIndex !== -1) {
                    break;
                }
            }
            else if (tocItem.itemIndex <= currentItemIndex) {
                if (currentTOCIndex === -1) {
                    currentTOCIndex = i;
                }
                else if (this._toc[currentTOCIndex].itemIndex <= tocItem.itemIndex) {
                    currentTOCIndex = i;
                }
            }
        }
        return currentTOCIndex;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: PagesComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i0.NgZone }, { token: LibConfigService }, { token: EventBusService }, { token: AddressStoreService }, { token: SettingsStoreService }, { token: ContentsService }, { token: ContentsProcessorService }, { token: SearchService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.3", type: PagesComponent, selector: "bukv-pages", inputs: { annotations: "annotations", mediaOverlayPlaybackRate: "mediaOverlayPlaybackRate" }, host: { properties: { "class.bukv_is-vertical": "this._isScrollPagingMode" } }, viewQueries: [{ propertyName: "_pageComps", predicate: PageComponent, descendants: true }], usesInheritance: true, ngImport: i0, template: "<bukv-page\n  class=\"bukv_page\"\n  [mediaOverlayMeta]=\"book.meta.media\"\n  (pageScrolled)=\"_onPageScrolled($event)\"\n  (pageSettled)=\"_onPageSettled()\"\n  (mediaOverlayClick)=\"_onMediaOverlayClick($event)\"\n  (zoomScaleChange)=\"_onPageZoomScaleChange($event)\"\n></bukv-page>\n<bukv-page\n  class=\"bukv_page\"\n  [mediaOverlayMeta]=\"book.meta.media\"\n  (pageScrolled)=\"_onPageScrolled($event)\"\n  (pageSettled)=\"_onPageSettled()\"\n  (mediaOverlayClick)=\"_onMediaOverlayClick($event)\"\n  (zoomScaleChange)=\"_onPageZoomScaleChange($event)\"\n></bukv-page>\n", styles: [":host{display:block;width:100%;height:100%;position:relative}:host[data-bukv-theme=light] .bukv_page{background-color:var(--bukv-contents-bg-color-light)}:host[data-bukv-theme=dark] .bukv_page{background-color:var(--bukv-contents-bg-color-dark)}:host[data-bukv-theme=sepia] .bukv_page{background-color:var(--bukv-contents-bg-color-sepia)}.bukv_page{position:absolute;inset:0;visibility:hidden;z-index:-1}.bukv_page.bukv_is-active{visibility:visible;z-index:0}@keyframes bukvPageSlideInLeft{0%{transform:translate3d(100%,0,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideInRight{0%{transform:translate3d(-100%,0,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutLeft{0%{transform:translateZ(0)}to{transform:translate3d(-100%,0,0)}}@keyframes bukvPageSlideOutRight{0%{transform:translateZ(0)}to{transform:translate3d(100%,0,0)}}@keyframes bukvPageSlideInTop{0%{transform:translate3d(0,100%,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutTop{0%{transform:translateZ(0)}to{transform:translate3d(0,-100%,0)}}@keyframes bukvPageSlideInBottom{0%{transform:translate3d(0,-100%,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutBottom{0%{transform:translateZ(0)}to{transform:translate3d(0,100%,0)}}:host.bukv_anim-to-prev .bukv_page,:host.bukv_anim-to-next .bukv_page{animation-duration:.3s;animation-timing-function:ease;visibility:visible!important}:host.bukv_anim-to-prev .bukv_page.bukv_is-active{animation-name:bukvPageSlideInRight;z-index:-1!important}:host.bukv_anim-to-prev .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutRight;z-index:0!important}:host.bukv_anim-to-next .bukv_page.bukv_is-active{animation-name:bukvPageSlideInLeft;z-index:-1!important}:host.bukv_anim-to-next .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutLeft;z-index:0!important}:host.bukv_is-vertical.bukv_anim-to-prev .bukv_page.bukv_is-active{animation-name:bukvPageSlideInBottom;z-index:-1!important}:host.bukv_is-vertical.bukv_anim-to-prev .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutBottom;z-index:0!important}:host.bukv_is-vertical.bukv_anim-to-next .bukv_page.bukv_is-active{animation-name:bukvPageSlideInTop;z-index:-1!important}:host.bukv_is-vertical.bukv_anim-to-next .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutTop;z-index:0!important}\n", ""], dependencies: [{ kind: "component", type: PageComponent, selector: "bukv-page", inputs: ["mediaOverlayMeta"], outputs: ["loaded", "domLoaded", "pageScrolled", "pageSettled", "mediaOverlayClick", "zoomScaleChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: PagesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bukv-pages', template: "<bukv-page\n  class=\"bukv_page\"\n  [mediaOverlayMeta]=\"book.meta.media\"\n  (pageScrolled)=\"_onPageScrolled($event)\"\n  (pageSettled)=\"_onPageSettled()\"\n  (mediaOverlayClick)=\"_onMediaOverlayClick($event)\"\n  (zoomScaleChange)=\"_onPageZoomScaleChange($event)\"\n></bukv-page>\n<bukv-page\n  class=\"bukv_page\"\n  [mediaOverlayMeta]=\"book.meta.media\"\n  (pageScrolled)=\"_onPageScrolled($event)\"\n  (pageSettled)=\"_onPageSettled()\"\n  (mediaOverlayClick)=\"_onMediaOverlayClick($event)\"\n  (zoomScaleChange)=\"_onPageZoomScaleChange($event)\"\n></bukv-page>\n", styles: [":host{display:block;width:100%;height:100%;position:relative}:host[data-bukv-theme=light] .bukv_page{background-color:var(--bukv-contents-bg-color-light)}:host[data-bukv-theme=dark] .bukv_page{background-color:var(--bukv-contents-bg-color-dark)}:host[data-bukv-theme=sepia] .bukv_page{background-color:var(--bukv-contents-bg-color-sepia)}.bukv_page{position:absolute;inset:0;visibility:hidden;z-index:-1}.bukv_page.bukv_is-active{visibility:visible;z-index:0}@keyframes bukvPageSlideInLeft{0%{transform:translate3d(100%,0,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideInRight{0%{transform:translate3d(-100%,0,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutLeft{0%{transform:translateZ(0)}to{transform:translate3d(-100%,0,0)}}@keyframes bukvPageSlideOutRight{0%{transform:translateZ(0)}to{transform:translate3d(100%,0,0)}}@keyframes bukvPageSlideInTop{0%{transform:translate3d(0,100%,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutTop{0%{transform:translateZ(0)}to{transform:translate3d(0,-100%,0)}}@keyframes bukvPageSlideInBottom{0%{transform:translate3d(0,-100%,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutBottom{0%{transform:translateZ(0)}to{transform:translate3d(0,100%,0)}}:host.bukv_anim-to-prev .bukv_page,:host.bukv_anim-to-next .bukv_page{animation-duration:.3s;animation-timing-function:ease;visibility:visible!important}:host.bukv_anim-to-prev .bukv_page.bukv_is-active{animation-name:bukvPageSlideInRight;z-index:-1!important}:host.bukv_anim-to-prev .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutRight;z-index:0!important}:host.bukv_anim-to-next .bukv_page.bukv_is-active{animation-name:bukvPageSlideInLeft;z-index:-1!important}:host.bukv_anim-to-next .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutLeft;z-index:0!important}:host.bukv_is-vertical.bukv_anim-to-prev .bukv_page.bukv_is-active{animation-name:bukvPageSlideInBottom;z-index:-1!important}:host.bukv_is-vertical.bukv_anim-to-prev .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutBottom;z-index:0!important}:host.bukv_is-vertical.bukv_anim-to-next .bukv_page.bukv_is-active{animation-name:bukvPageSlideInTop;z-index:-1!important}:host.bukv_is-vertical.bukv_anim-to-next .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutTop;z-index:0!important}\n"] }]
        }], ctorParameters: () => [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i0.NgZone }, { type: LibConfigService }, { type: EventBusService }, { type: AddressStoreService }, { type: SettingsStoreService }, { type: ContentsService }, { type: ContentsProcessorService }, { type: SearchService }], propDecorators: { _pageComps: [{
                type: ViewChildren,
                args: [PageComponent]
            }], _isScrollPagingMode: [{
                type: HostBinding,
                args: ['class.bukv_is-vertical']
            }], annotations: [{
                type: Input
            }], mediaOverlayPlaybackRate: [{
                type: Input
            }] } });

class LinkLayerComponent {
    constructor() {
        this.addressClick = new EventEmitter();
    }
    set links(links) {
        this._links = links.map((link) => ({
            link,
            isInternal: link[1].startsWith('/'),
        }));
    }
    _onLinkClick(link, event) {
        if (!link.isInternal) {
            return;
        }
        this.addressClick.emit(parseBukURL(link.link[1]));
        event.preventDefault();
        event.stopPropagation();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: LinkLayerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.3", type: LinkLayerComponent, selector: "bukv-link-layer", inputs: { links: "links" }, outputs: { addressClick: "addressClick" }, ngImport: i0, template: "<a\n  *ngFor=\"let link of _links\"\n  [style.left.%]=\"link.link[0][0]\"\n  [style.top.%]=\"link.link[0][1]\"\n  [style.width.%]=\"link.link[0][2]\"\n  [style.height.%]=\"link.link[0][3]\"\n  href=\"{{ link.link[1] }}\"\n  [target]=\"link.isInternal ? '_self' : '_blank'\"\n  (click)=\"_onLinkClick(link, $event)\"\n></a>\n", styles: [":host{position:absolute;inset:0;pointer-events:none}a{position:absolute;pointer-events:auto}\n"], dependencies: [{ kind: "directive", type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: LinkLayerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bukv-link-layer', changeDetection: ChangeDetectionStrategy.OnPush, template: "<a\n  *ngFor=\"let link of _links\"\n  [style.left.%]=\"link.link[0][0]\"\n  [style.top.%]=\"link.link[0][1]\"\n  [style.width.%]=\"link.link[0][2]\"\n  [style.height.%]=\"link.link[0][3]\"\n  href=\"{{ link.link[1] }}\"\n  [target]=\"link.isInternal ? '_self' : '_blank'\"\n  (click)=\"_onLinkClick(link, $event)\"\n></a>\n", styles: [":host{position:absolute;inset:0;pointer-events:none}a{position:absolute;pointer-events:auto}\n"] }]
        }], propDecorators: { addressClick: [{
                type: Output
            }], links: [{
                type: Input
            }] } });

class SafePipe {
    constructor(domSanitizer) {
        this.domSanitizer = domSanitizer;
    }
    transform(value, type) {
        switch (type) {
            case 'html':
                return this.domSanitizer.bypassSecurityTrustHtml(value);
            case 'style':
                return this.domSanitizer.bypassSecurityTrustStyle(value);
            case 'script':
                return this.domSanitizer.bypassSecurityTrustScript(value);
            case 'url':
                return this.domSanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl':
                return this.domSanitizer.bypassSecurityTrustResourceUrl(value);
            default:
                throw new Error('Invalid safe type specified: ' + type);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: SafePipe, deps: [{ token: i1$1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.3", ngImport: i0, type: SafePipe, name: "safe" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: SafePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'safe',
                }]
        }], ctorParameters: () => [{ type: i1$1.DomSanitizer }] });

const ZOOM_FLICKER_FIX_CLASS = 'bukv_fix-zoom-flicker';
function createTextHTML(text) {
    return `<p style="left:${text[0]}%; top:${text[1]}%" data-width="${text[2]}" data-height="${text[3]}" ${text[4] ? `data-deg="${text[4]}"` : ''} ><br style="display: none;"/>${obfuscateText(text[5])}<br style="display: none;"/></p>`;
}
function getNodeRect(node) {
    const range = node.ownerDocument?.createRange();
    if (!range) {
        return null;
    }
    range.selectNodeContents(node);
    const rect = range.getBoundingClientRect();
    range.detach();
    return rect;
}
function overrideRangeToStringForDeofuscation(range) {
    range.toString = function () {
        return deobfuscateText(Range.prototype.toString.call(this));
    };
}
function deofuscateAnnotationText(annotation) {
    annotation.text = deobfuscateText(annotation.text);
}
const OVERLAY_CONTAINER_STYLE = {
    'pointer-events': 'none',
    position: 'absolute',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    background: ' rgba(0, 0, 0, 0)',
};
class PDFImageComponent extends HighlightableFrameComponent {
    get _document() {
        return this._textFrameElem.nativeElement.contentDocument;
    }
    constructor(_element, _renderer, _ngZone, _libConfig, _contentsClickInterceptor, _pdfImageLoaderService) {
        super(_libConfig);
        this._element = _element;
        this._renderer = _renderer;
        this._ngZone = _ngZone;
        this._libConfig = _libConfig;
        this._contentsClickInterceptor = _contentsClickInterceptor;
        this._pdfImageLoaderService = _pdfImageLoaderService;
        this.imageLoad = new EventEmitter();
        this.imageLoadError = new EventEmitter();
        this.internalAddressClick = new EventEmitter();
        this._naturalWidth = 0;
        this._naturalHeight = 0;
        this._pica = new Pica();
        this._fixBlurryImageRequest$ = new Subject();
    }
    get naturalWidth() {
        return this._naturalWidth;
    }
    get naturalHeight() {
        return this._naturalHeight;
    }
    ngOnInit() {
        this._highlighter = new Highlighter();
        this._fixBlurryImageRequest$.pipe(debounceTime(100)).subscribe(() => {
            this._ngZone.runOutsideAngular(() => {
                this._fixBlurryImage();
            });
        });
        this._initTextLayerFrame();
        this.fixZoomFlicker();
    }
    ngOnDestroy() {
        this._fixBlurryImageRequest$.complete();
    }
    load(baseURL, image, links) {
        this._document.documentElement.setAttribute(BASE_BUK_URL_ATTR, baseURL);
        this._document.body.innerHTML = '';
        this._cancelPicaResize();
        this._updateCanvasVisibility(false);
        this._imageLoadSubscription?.unsubscribe();
        this._links = links;
        this._lqImgURL = image.lqURL;
        const prevSrc = this._src;
        const hqImageBlob = this._pdfImageLoaderService.load(image.hqURL);
        if (hqImageBlob instanceof Blob) {
            this._renderer.removeStyle(this._imgElem.nativeElement, 'background-image');
            this._hqImgURL = URL.createObjectURL(hqImageBlob);
            this._src = this._hqImgURL;
        }
        else {
            this._renderer.setStyle(this._imgElem.nativeElement, 'background-image', `url(${this._lqImgURL})`);
            this._imageLoadSubscription = hqImageBlob
                .pipe(finalize(() => {
                this._imageLoadSubscription = undefined;
            }))
                .subscribe((blob) => {
                this._hqImgURL = URL.createObjectURL(blob);
                this._src = this._hqImgURL;
            }, (error) => {
                console.log('failed to load blob image url', error);
                this._onImageLoadError();
            });
            this._src = this._lqImgURL;
        }
        // 같은 이미지 로드 -> 수동으로 이벤트 emit
        if (prevSrc === this._src && this._imgElem.nativeElement.complete) {
            if (this.naturalHeight === 0) {
                this._onImageLoadError();
            }
            else {
                this._onImageLoad();
            }
        }
    }
    loadText(text) {
        this._text = text;
        this._document.body.innerHTML =
            text?.texts.reduce((html, t) => {
                return (html += createTextHTML(t));
            }, '') ?? '';
        this.resizeTextLayer();
    }
    resizeTextLayer() {
        const pageWidth = this._element.nativeElement.offsetWidth;
        const pageHeight = this._element.nativeElement.offsetHeight;
        this.querySelectorAll('p').forEach((span) => {
            const height = (pageHeight * parseFloat(span.dataset.height)) / 100;
            span.style.fontSize = `${height - 1}px`;
            span.style.transform = 'none';
        });
        const rects = this.querySelectorAll('p').map((span) => {
            return getNodeRect(span);
        });
        this.querySelectorAll('p').forEach((span, index) => {
            const width = (pageWidth * parseFloat(span.dataset.width)) / 100;
            const height = (pageHeight * parseFloat(span.dataset.height)) / 100;
            const deg = span.dataset.deg && parseFloat(span.dataset.deg);
            const textNodeRect = rects[index];
            if (textNodeRect) {
                span.style.removeProperty('visibility');
                const scaleX = width / textNodeRect.width;
                const scaleY = height / textNodeRect.height;
                span.style.transform =
                    (deg ? `rotate(${deg}deg) ` : '') + `scale(${scaleX}, ${scaleY})`;
                span.style.paddingBottom = `${textNodeRect.height}px`;
                span.style.marginBottom = `-${textNodeRect.height}px`;
            }
            else {
                span.style.visibility = 'hidden';
            }
        });
    }
    fixZoomFlicker() {
        IMAGE_FLICKERING_WITH_ZOOM &&
            this._renderer.addClass(this._imgElem.nativeElement, ZOOM_FLICKER_FIX_CLASS);
    }
    unfixZoomFlicker() {
        IMAGE_FLICKERING_WITH_ZOOM &&
            this._renderer.removeClass(this._imgElem.nativeElement, ZOOM_FLICKER_FIX_CLASS);
    }
    fixBlurryImage() {
        this._fixBlurryImageRequest$.next();
    }
    getOverlayElement() {
        return this._overlayContainer?.firstElementChild ?? null;
    }
    attachOverlayElement(element) {
        if (element.parentElement === this._overlayContainer) {
            return;
        }
        else {
            this.removeOverlayElement();
        }
        this._overlayContainer = document.createElement('div');
        for (const key in OVERLAY_CONTAINER_STYLE) {
            this._overlayContainer.style.setProperty(key, OVERLAY_CONTAINER_STYLE[key]);
        }
        this._overlayContainer.appendChild(element);
        this._renderer.appendChild(this._element.nativeElement, this._overlayContainer);
    }
    removeOverlayElement() {
        if (!this._overlayContainer) {
            return;
        }
        this._renderer.removeChild(this._element.nativeElement, this._overlayContainer);
        this._overlayContainer = undefined;
    }
    _onImageLoad() {
        this._naturalWidth = this._imgElem.nativeElement.naturalWidth;
        this._naturalHeight = this._imgElem.nativeElement.naturalHeight;
        if (this._src === this._lqImgURL && this._hqImgURL) {
            this._src = this._hqImgURL;
        }
        else if (this._src === this._hqImgURL) {
            this.fixBlurryImage();
            this._renderer.removeStyle(this._imgElem.nativeElement, 'background-image');
            const url = this._hqImgURL;
            this._ngZone.runOutsideAngular(() => {
                setTimeout(() => {
                    URL.revokeObjectURL(url);
                }, 10 * 1000);
            });
        }
        this.imageLoad.emit({
            target: this,
            pageWidth: this._element.nativeElement.offsetWidth,
            pageHeight: this._element.nativeElement.offsetHeight,
        });
    }
    _onImageLoadError() {
        this._naturalWidth = this._imgElem.nativeElement.naturalWidth;
        this._naturalHeight = this._imgElem.nativeElement.naturalHeight;
        this.imageLoadError.emit({ target: this });
    }
    _onAddressClick(address) {
        const bid = parseBukURL(this._baseURL).bid;
        if (address.bid === bid) {
            this.internalAddressClick.emit(address);
        }
    }
    _initTextLayerFrame() {
        this._document.open();
        this._document.write(`<html><head><style>
    body {
      color: rgba(0, 0, 0, 0);
      overflow: hidden;
    }
    ::selection {
      color: rgba(0, 0, 0, 0);
      background-color: rgba(0, 110, 255, 0.28);
    }
    p {
      position: absolute;
      display: inline-block;
      transform-origin: left top;
      white-space: pre;
      margin: 0;
    }
    </style>
    ${createHighlightStyleHTML(this._libConfig.highlightStyles)}
    </head><body></body></html>`);
        this._document.close();
        /**
         * (데스크탑 환경) Fixed Layout에서 더블 클릭으로 텍스트 선택 막음, 확대 축소 제스처로 사용
         */
        if (!IS_TOUCH_DEVICE) {
            fromDoubleClickEvent(this._document).subscribe((event) => {
                event.preventDefault();
            });
        }
        else {
            fromSwipeEvent(this._document)
                .pipe(filter(() => !this.hasSelection()), observeOn(enterZone(this._ngZone)))
                .subscribe((direction) => {
                this._emitEmptySelectionChangeEvent(); // 데스크탑에서는 빈 공간 클릭하는 순간 selection change가 발생하는데 모바일에서는 그렇지 않기 때문에 동작 통일하기 위해 수동으로 이벤트 트리거
                this.frameSwipe.emit(direction === SwipeDirection.Left ? Direction.Next : Direction.Prev);
            });
            if (this._libConfig.enablePinchZoom) {
                fromHammerPinchEvent(this._document.documentElement, 'pan-x pan-y')
                    // .pipe(observeOn(enterZone(this._ngZone))) // FIXME: 이렇게 하면 이벤트가 두 번 emit 됨
                    .subscribe((event) => {
                    this._ngZone.run(() => {
                        this.framePinch.emit(event);
                    });
                });
                preventBrowserPinchZoom(this._document);
            }
        }
        fromClickEvent(this._document.documentElement, false)
            .pipe(observeOn(enterZone(this._ngZone)))
            .subscribe((event) => {
            switch (event.type) {
                case 'double':
                    this.frameDoubleClick.emit(event);
                    break;
                case 'single':
                    this._onTextFrameClick(event);
                    break;
            }
        });
        /**
         * keydown
         */
        fromPageChangeKeydownEvent(this._document)
            .pipe(observeOn(enterZone(this._ngZone)))
            .subscribe((direction) => {
            this.framePageChangeKeydown.emit(direction);
        });
        /**
         * 텍스트 선택 감지
         */
        fromEvent(this._document, 'selectionchange')
            .pipe(debounceTime(50), observeOn(enterZone(this._ngZone)))
            .subscribe(() => {
            this.frameSelectionChange.emit({
                selection: this.getContentsSelection(),
                doc: this._document,
            });
        });
        /**
         * 컨텍스트 메뉴 disable
         */
        this._document.addEventListener('contextmenu', (event) => {
            event.preventDefault();
        });
    }
    getContentsSelection() {
        const result = super.getContentsSelection();
        result && overrideRangeToStringForDeofuscation(result.range);
        return result;
    }
    createHighlight(range, styleClass, options) {
        const result = super.createHighlight(range, styleClass, options);
        deofuscateAnnotationText(result.created);
        result.merged.forEach(deofuscateAnnotationText);
        return result;
    }
    changeHighlight(range, currStyleClass, newStyleClass) {
        const result = super.changeHighlight(range, currStyleClass, newStyleClass);
        result && deofuscateAnnotationText(result);
        return result;
    }
    removeHighlight(range, styleClass) {
        const result = super.removeHighlight(range, styleClass);
        result && deofuscateAnnotationText(result);
        return result;
    }
    getParentHighlightsFromRange(range) {
        const result = super.getParentHighlightsFromRange(range);
        result.forEach((r) => {
            overrideRangeToStringForDeofuscation(r.range);
            deofuscateAnnotationText(r.annotation);
        });
        return result;
    }
    getHighlightsFromElement(element) {
        const result = super.getHighlightsFromElement(element);
        result.forEach((r) => {
            overrideRangeToStringForDeofuscation(r.range);
            deofuscateAnnotationText(r.annotation);
        });
        return result;
    }
    highlightAnchor(anchor, color) {
        super.highlightAnchor(anchor, color);
        const highlightElem = this.getHighlightElements(undefined, ANCHOR_HIGHLIGHT_CLASS)[0];
        return highlightElem;
    }
    getVisibleRange() {
        if (!this._document) {
            return null;
        }
        const firstElem = this._document.body.firstElementChild;
        const lastElem = this._document.body.lastElementChild;
        if (!firstElem || !lastElem) {
            return null;
        }
        const range = createRangeFromNodes(firstElem, lastElem);
        overrideRangeToStringForDeofuscation(range);
        return range;
    }
    _cancelPicaResize() {
        this._picaResizeCancelFn?.();
        this._picaResizeCancelFn = undefined;
    }
    _updateCanvasSize() {
        this._renderer.setStyle(this._canvasElem.nativeElement, 'width', `${this._imgElem.nativeElement.offsetWidth}px`);
        this._renderer.setStyle(this._canvasElem.nativeElement, 'height', `${this._imgElem.nativeElement.offsetHeight}px`);
    }
    _updateCanvasVisibility(visible) {
        this._renderer.setStyle(this._canvasElem.nativeElement, 'display', visible ? 'block' : 'none');
    }
    _onTextFrameClick(event) {
        IS_TOUCH_DEVICE && this._emitEmptySelectionChangeEvent(); // 데스크탑에서는 빈 공간 클릭하는 순간 selection change가 발생하는데 모바일에서는 그렇지 않기 때문에 동작 통일하기 위해 수동으로 이벤트 트리거
        if (!event.target) {
            return;
        }
        if (event.viewerDefaultPrevented) {
            return;
        }
        let interceptable;
        if ((interceptable = this._contentsClickInterceptor.getHighlightElement(event.target))) {
            this.frameHighlightClick.emit({
                highlights: this.getHighlightsFromElement(interceptable),
                clientPoint: { x: event.center.x, y: event.center.y },
            });
        }
        if (!interceptable) {
            this.frameClick.emit(event);
        }
    }
    /**
     * devicePixelRatio가 낮은 화면의 크롬 브라우저에서 이미지가 흐릿하게 보이는 문제 보완
     * 이미지 사이즈를 조정하여 pixel-perfect하게 렌더링
     */
    _fixBlurryImage() {
        if (!LOW_DOWNSCALED_IMAGE_QUALITY) {
            return;
        }
        if (this._src === this._lqImgURL || !this._src) {
            return;
        }
        this._updateCanvasSize();
        const imgRect = this._imgElem.nativeElement.getBoundingClientRect();
        const width = Math.round(imgRect.width) * window.devicePixelRatio;
        const height = Math.round(imgRect.height) * window.devicePixelRatio;
        // 이미 리사이즈 됐거나 리사이즈 중임
        if (this._canvasElem.nativeElement.dataset.src === this._src &&
            width === this._canvasElem.nativeElement.width &&
            height === this._canvasElem.nativeElement.height) {
            if (!this._picaResizeCancelFn) {
                this._updateCanvasVisibility(true);
            }
            return;
        }
        this._cancelPicaResize();
        // 원본 이미지 사이즈보다 크거나 원본 이미지 사이즈가 없는 경우, 이미지가 로딩 중인 경우 캔버스 사용 안함
        if (imgRect.width >= this.naturalWidth ||
            imgRect.width === 0 ||
            !this._imgElem.nativeElement.complete) {
            this._renderer.setStyle(this._canvasElem.nativeElement, 'display', 'none');
            return;
        }
        this._canvasElem.nativeElement.dataset.src =
            this._imgElem.nativeElement.src;
        this._canvasElem.nativeElement.width = width;
        this._canvasElem.nativeElement.height = height;
        const cancelToken = new Promise((resolve, reject) => {
            this._picaResizeCancelFn = reject;
        });
        cancelToken.catch(() => {
            this._updateCanvasVisibility(false);
            delete this._canvasElem.nativeElement.dataset.src;
        });
        this._pica
            .resize(this._imgElem.nativeElement, this._canvasElem.nativeElement, {
            unsharpAmount: 0,
            unsharpRadius: 0.6,
            unsharpThreshold: 2,
            cancelToken,
        })
            .then(() => {
            this._updateCanvasVisibility(true);
        }, (error) => {
            console.warn('Pica: resize error', error);
            this._updateCanvasVisibility(false);
        })
            .finally(() => {
            this._picaResizeCancelFn = undefined;
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: PDFImageComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.NgZone }, { token: LibConfigService }, { token: ContentsClickInterceptorService }, { token: PDFImageLoaderService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.3", type: PDFImageComponent, selector: "bukv-pdf-image", outputs: { imageLoad: "imageLoad", imageLoadError: "imageLoadError", internalAddressClick: "internalAddressClick" }, viewQueries: [{ propertyName: "_imgElem", first: true, predicate: ["img"], descendants: true, static: true }, { propertyName: "_textFrameElem", first: true, predicate: ["textFrame"], descendants: true, static: true }, { propertyName: "_canvasElem", first: true, predicate: ["canvas"], descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<img\n  #img\n  draggable=\"false\"\n  [src]=\"_src && (_src | safe: 'resourceUrl')\"\n  (load)=\"_onImageLoad()\"\n  (error)=\"_onImageLoadError()\"\n  crossorigin=\"anonymous\"\n/>\n<canvas #canvas></canvas>\n<iframe class=\"bukv_text-layer\" #textFrame></iframe>\n<bukv-link-layer\n  [links]=\"_links\"\n  (addressClick)=\"_onAddressClick($event)\"\n  *ngIf=\"_links && _links.length > 0\"\n></bukv-link-layer>\n", styles: [":host{display:inline-block;position:relative}img{background-size:cover;background-color:#fff;width:100%;height:auto;vertical-align:middle}img.bukv_fix-zoom-flicker{-webkit-transform:translate3d(0,0,0)}.bukv_text-layer{position:absolute;inset:0;background:#0000;display:block;border:none;width:100%;height:100%}canvas{position:absolute;display:none;top:0;left:0}\n"], dependencies: [{ kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: LinkLayerComponent, selector: "bukv-link-layer", inputs: ["links"], outputs: ["addressClick"] }, { kind: "pipe", type: SafePipe, name: "safe" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: PDFImageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bukv-pdf-image', template: "<img\n  #img\n  draggable=\"false\"\n  [src]=\"_src && (_src | safe: 'resourceUrl')\"\n  (load)=\"_onImageLoad()\"\n  (error)=\"_onImageLoadError()\"\n  crossorigin=\"anonymous\"\n/>\n<canvas #canvas></canvas>\n<iframe class=\"bukv_text-layer\" #textFrame></iframe>\n<bukv-link-layer\n  [links]=\"_links\"\n  (addressClick)=\"_onAddressClick($event)\"\n  *ngIf=\"_links && _links.length > 0\"\n></bukv-link-layer>\n", styles: [":host{display:inline-block;position:relative}img{background-size:cover;background-color:#fff;width:100%;height:auto;vertical-align:middle}img.bukv_fix-zoom-flicker{-webkit-transform:translate3d(0,0,0)}.bukv_text-layer{position:absolute;inset:0;background:#0000;display:block;border:none;width:100%;height:100%}canvas{position:absolute;display:none;top:0;left:0}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.NgZone }, { type: LibConfigService }, { type: ContentsClickInterceptorService }, { type: PDFImageLoaderService }], propDecorators: { _imgElem: [{
                type: ViewChild,
                args: ['img', { static: true }]
            }], _textFrameElem: [{
                type: ViewChild,
                args: ['textFrame', { static: true }]
            }], _canvasElem: [{
                type: ViewChild,
                args: ['canvas', { static: true }]
            }], imageLoad: [{
                type: Output
            }], imageLoadError: [{
                type: Output
            }], internalAddressClick: [{
                type: Output
            }] } });

class PDFPageComponent {
    constructor(_element, _renderer, _libConfig, _eventBus, _addressStore, _overlayViewProviderService) {
        this._element = _element;
        this._renderer = _renderer;
        this._libConfig = _libConfig;
        this._eventBus = _eventBus;
        this._addressStore = _addressStore;
        this._overlayViewProviderService = _overlayViewProviderService;
        this.loaded = new EventEmitter();
        this.textLoaded = new EventEmitter();
        this.zoomScaleChange = new EventEmitter();
        this._unsubscriber = new Subject();
        this._isLoadingImage = false;
        this._imgLoadEventUnsubscriber = new Subject();
    }
    get zoomScale() {
        if (!this._zoomElem) {
            return 1;
        }
        return this._zoomElem.scale;
    }
    ngAfterViewInit() {
        fromClickEvent(this._element.nativeElement, false)
            .pipe(takeUntil(this._unsubscriber))
            .subscribe((event) => {
            switch (event.type) {
                case 'double':
                    this._onPageDblClick(event);
                    break;
                case 'single':
                    this._onPageClick(event);
                    break;
            }
        });
        fromResizeEvent(this._element.nativeElement)
            .pipe(takeUntil(this._unsubscriber), filter(() => !this._isLoadingImage))
            .subscribe(() => this._onPageResize());
        if (IS_TOUCH_DEVICE && this._libConfig.enablePinchZoom) {
            fromHammerPinchEvent(this._element.nativeElement, 'pan-x pan-y').subscribe((event) => {
                this._onPagePinch(event);
            });
        }
    }
    ngOnDestroy() {
        this._unsubscriber.next();
        this._unsubscriber.complete();
    }
    unloadPage() {
        if (this._overlayViewProviderService) {
            this._imageComps.forEach((imageComp) => {
                const overlay = imageComp.getOverlayElement();
                overlay &&
                    this._overlayViewProviderService?.willEndDisplayingOverlayView(overlay);
            });
        }
    }
    loadPage(rightPageInfo, leftPageInfo) {
        this._imgLoadEventUnsubscriber.next();
        this._leftItem = leftPageInfo?.item;
        this._rightItem = rightPageInfo.item;
        const itemCompPair = [
            [rightPageInfo, this._imageComps.last],
        ];
        if (leftPageInfo) {
            itemCompPair.push([leftPageInfo, this._imageComps.first]);
        }
        this._isLoadingImage = true;
        zip(...itemCompPair.map(([, imageComp]) => imageComp.imageLoad))
            .pipe(takeUntil(this._imgLoadEventUnsubscriber), take(1))
            .subscribe((events) => {
            this._isLoadingImage = false;
            if (this._overlayViewProviderService) {
                events.forEach((event) => {
                    const iid = itemCompPair.find(([, comp]) => comp === event.target)?.[0].item.iid;
                    if (iid) {
                        const overlay = this._overlayViewProviderService?.getOverlayView(iid, { width: event.pageWidth, height: event.pageHeight });
                        if (overlay) {
                            event.target.attachOverlayElement(overlay);
                        }
                        else {
                            event.target.removeOverlayElement();
                        }
                    }
                });
            }
            this.loaded.emit();
        });
        if (itemCompPair.length > 1) {
            this._renderer.addClass(this._imagesElem.nativeElement, 'bukv_is-multi-column');
        }
        else {
            this._renderer.removeClass(this._imagesElem.nativeElement, 'bukv_is-multi-column');
        }
        this._setImagesSize();
        itemCompPair.forEach(([pageInfo, imageComp]) => {
            imageComp.load(pageInfo.baseURL, {
                hqURL: pageInfo.item.url,
                lqURL: pageInfo.item.thumbnail,
            }, pageInfo.links);
        });
    }
    loadText(rightText, leftText) {
        this._imageComps.last.loadText(rightText);
        this._imageComps.first.loadText(leftText);
        this.textLoaded.emit();
    }
    getBookmarkIid() {
        return this._leftItem?.iid ?? this._rightItem?.iid;
    }
    isAnnotationAtCurrentPage(annotation) {
        return (annotation.address.iid === this._leftItem?.iid ||
            annotation.address.iid === this._rightItem?.iid);
    }
    zoom(scale) {
        this._zoomElem.zoom(scale);
    }
    resetZoom(scale, centerHorizontally) {
        this._zoomElem.reset(scale, centerHorizontally);
    }
    getSelection() {
        let selection = null;
        this._imageComps.forEach((imageComp, compIndex) => {
            if ((compIndex === 0 && !this._leftItem) ||
                (compIndex === 1 && !this._rightItem)) {
                return;
            }
            selection = imageComp.getContentsSelection();
        });
        return selection;
    }
    clearSelection() {
        this._imageComps.forEach((imageComp) => imageComp.clearSelection());
    }
    highlightAnchor(iid, anchor, color) {
        const anchorElement = this._getImageComponentForIid(iid)?.highlightAnchor(anchor, color);
        anchorElement && this._zoomElem.scrollToElement(anchorElement);
    }
    clearAnchorHighlight() {
        this._imageComps.forEach((frameComp) => frameComp.clearAnchorHighlight());
    }
    highlight(annotations) {
        annotations.forEach((annotation) => {
            this._getImageComponentForIid(annotation.address.iid)?.highlightAnnotation(annotation);
        });
    }
    unhighlight(annotations) {
        annotations.forEach((annotation) => {
            this._getImageComponentForIid(annotation.address.iid)?.unhighlightAnnotation(annotation);
        });
    }
    createHighlight(range, styleClass, options) {
        const frameComp = this._getImageComponentContainingRange(range);
        return frameComp.createHighlight(range instanceof Address ? range.range : range, styleClass, options);
    }
    changeHighlight(range, currStyleClass, newStyleClass) {
        const frameComp = this._getImageComponentContainingRange(range);
        return frameComp.changeHighlight(range instanceof Address ? range.range : range, currStyleClass, newStyleClass);
    }
    removeHighlight(range, styleClass) {
        const frameComp = this._getImageComponentContainingRange(range);
        return frameComp.removeHighlight(range instanceof Address ? range.range : range, styleClass);
    }
    getParentHighlightsFromRange(range) {
        const frameComp = this._getImageComponentContainingRange(range);
        return frameComp.getParentHighlightsFromRange(range);
    }
    createRangeFromElements(startId, endId, iid) {
        const imageComp = iid
            ? this._getImageComponentForIid(iid)
            : this._imageComps.last;
        if (!imageComp) {
            throw new Error('no active page with the given iid');
        }
        return imageComp.createRangeFromElements(startId, endId);
    }
    getVisibleRanges() {
        return this._imageComps.reduce((result, imageComp, index) => {
            if ((index === 0 && !this._leftItem) ||
                (index === 1 && !this._rightItem)) {
                return result;
            }
            const range = imageComp.getVisibleRange();
            range && result.push(range);
            return result;
        }, []);
    }
    getAddressFromRange(range) {
        return this._getImageComponentContainingRange(range).getAddressFromRange(range);
    }
    _onZoomScaleChange(scale) {
        this.zoomScaleChange.emit({ target: this, scale });
    }
    /**
     * 확대 중 화면 깜빡임을 방지하는 스타일(-webkit-transform: translateZ(0))을 추가하면
     * 사파리에서 transform 된 크기가 제대로 잡히지 않아 스크롤되지 않는 문제가 있어 확대 중일 때는 해당 스타일을 잠시 꺼둠
     */
    _onZoomScaleStart() {
        !this._libConfig.enablePinchZoom &&
            this._imageComps.forEach((comp) => comp.unfixZoomFlicker());
    }
    _onZoomScaleEnd() {
        // TODO: 확대 상태에서 _setImagesSize한 경우 스크롤바 너비를 제외하고 계산하기 때문에 사이즈가 달라지는 문제 수정, 더 좋은 방법 필요
        if (!this._zoomElem.isZoomed) {
            this._setImagesSize();
        }
        this._imageComps.forEach((comp) => {
            !this._libConfig.enablePinchZoom && comp.fixZoomFlicker();
            setTimeout(() => {
                comp.fixBlurryImage();
            });
        });
    }
    _onInternalAddressClick(imageCompIndex, address) {
        this._addressStore.update(address);
    }
    _onImageSelectionChange(imageCompIndex, event) {
        const isPageFocused = this._imageComps.find((comp) => document.activeElement === comp._textFrameElem.nativeElement);
        if (!isPageFocused ||
            event.doc.defaultView?.frameElement === document.activeElement) {
            if (isPageFocused) {
                this._imageComps.get(imageCompIndex === 0 ? 1 : 0)?.clearSelection();
            }
            this._eventBus.emit('selectionChange', event);
        }
    }
    _onImagePageChangeKeydown(imageCompIndex, direction) {
        if (this._zoomElem.isZoomed) {
            return;
        }
        this._eventBus.emit('changePage', { direction, trigger: 'keyboard' });
    }
    _onImageClick(imageCompIndex, event) {
        const iframeBoundingRect = this._imageComps
            .get(imageCompIndex)
            ._textFrameElem.nativeElement.getBoundingClientRect();
        const client = {
            x: event.center.x * (this.zoomScale / 100) + iframeBoundingRect.left,
            y: event.center.y * (this.zoomScale / 100) + iframeBoundingRect.top,
        };
        this._pageClicked(event.target, client);
    }
    _onImageDblClick(imageCompIndex, event) {
        if (IS_TOUCH_DEVICE) {
            return;
        }
        const imageComp = this._imageComps.get(imageCompIndex)._element.nativeElement;
        this._zoomElem.toggle({
            x: event.center.x + imageComp.offsetLeft,
            y: event.center.y + imageComp.offsetTop,
        });
    }
    _onImagePinch(event) {
        this._zoomElem.pinchZoom(event);
    }
    _onHighlightClick(imageCompIndex, event) {
        const iframeBoundingRect = this._imageComps
            .get(imageCompIndex)
            ._textFrameElem.nativeElement.getBoundingClientRect();
        const client = {
            x: event.clientPoint.x * (this.zoomScale / 100) + iframeBoundingRect.left,
            y: event.clientPoint.y * (this.zoomScale / 100) + iframeBoundingRect.top,
        };
        const offset = getLocationInElement(this._element.nativeElement, client);
        this._eventBus.emit('highlightClick', {
            highlights: event.highlights,
            offsetX: offset.x,
            offsetY: offset.y,
        });
    }
    _onImageSwipe(imageCompIndex, direction) {
        if (this._zoomElem.isZoomed) {
            return;
        }
        getWindowScale() === 1 &&
            !isWindowZoomed() &&
            this._eventBus.emit('changePage', { direction, trigger: 'gesture' });
    }
    _setImagesSize() {
        const sizes = [];
        if (this._leftItem) {
            sizes.push({
                width: this._leftItem.fixedWidth,
                height: this._leftItem.fixedHeight,
            });
        }
        if (this._rightItem) {
            sizes.push({
                width: this._rightItem.fixedWidth,
                height: this._rightItem.fixedHeight,
            });
        }
        const size = this._calculateImagesSize(sizes);
        this._renderer.setStyle(this._imagesElem.nativeElement, 'width', `${size.width}px`);
        this._renderer.setStyle(this._imagesElem.nativeElement, 'height', `${size.height}px`);
    }
    _calculateImagesSize(imageSizes) {
        const pageSize = {
            width: this._pageContentElem.nativeElement.offsetWidth / imageSizes.length,
            height: this._pageContentElem.nativeElement.offsetHeight,
        };
        return imageSizes.reduce((result, imageSize) => {
            const scale = getContentsScale(pageSize, imageSize);
            result.width += imageSize.width * scale;
            result.height = Math.max(result.height, imageSize.height * scale);
            return result;
        }, { width: 0, height: 0 });
    }
    _onPageResize() {
        this._setImagesSize();
        this._imageComps.forEach((imageComp) => {
            imageComp.resizeTextLayer();
            imageComp.fixBlurryImage();
        });
    }
    _onPagePinch(event) {
        this._zoomElem.pinchZoom(event);
    }
    _onPageClick(event) {
        !event.viewerDefaultPrevented &&
            this._pageClicked(event.target, event.center);
    }
    _onPageDblClick(event) {
        if (IS_TOUCH_DEVICE) {
            return;
        }
        const offset = getLocationInElement(this._element.nativeElement, event.center);
        this._zoomElem.toggle({
            x: offset.x,
            y: offset.y,
        });
    }
    _pageClicked(target, clickLocation) {
        let clientX = clickLocation.x;
        if (IS_TOUCH_DEVICE) {
            const windowScale = getWindowScale();
            clientX *= windowScale;
        }
        const offset = getLocationInElement(this._element.nativeElement, clickLocation);
        const isPageChangeGesture = this._changePageByTap(this._element.nativeElement.getBoundingClientRect().left < 0
            ? clientX
            : offset.x);
        this._eventBus.emit('pageTap', {
            target,
            offsetX: offset.x,
            offsetY: offset.y,
            isPageChangeGesture,
        });
    }
    _changePageByTap(tapOffsetX) {
        if (!this._libConfig.pageGestureEnabled) {
            return false;
        }
        const pageWidth = this._element.nativeElement.offsetWidth;
        if (tapOffsetX < pageWidth * PAGE_CHANGE_GESTURE_AREA) {
            this._eventBus.emit('changePage', {
                direction: Direction.Prev,
                trigger: 'gesture',
            });
            return true;
        }
        if (tapOffsetX > pageWidth * (1 - PAGE_CHANGE_GESTURE_AREA)) {
            this._eventBus.emit('changePage', {
                direction: Direction.Next,
                trigger: 'gesture',
            });
            return true;
        }
        return false;
    }
    _getImageComponentForIid(iid = '') {
        if (iid === this._leftItem?.iid) {
            return this._imageComps.first;
        }
        else if (iid === this._rightItem?.iid) {
            return this._imageComps.last;
        }
        return null;
    }
    _getImageComponentContainingRange(range) {
        let frameComp;
        if (range instanceof Address) {
            frameComp = this._getImageComponentForIid(range.iid);
        }
        else {
            frameComp = this._imageComps.find((comp) => comp.containsRange(range));
        }
        if (!frameComp) {
            throw new Error('Cannot find an active page containing a given range');
        }
        return frameComp;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: PDFPageComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: LibConfigService }, { token: EventBusService }, { token: AddressStoreService }, { token: ViewerPDFOverlayViewProviderService, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.3", type: PDFPageComponent, selector: "bukv-pdf-page", outputs: { loaded: "loaded", textLoaded: "textLoaded", zoomScaleChange: "zoomScaleChange" }, viewQueries: [{ propertyName: "_zoomElem", first: true, predicate: ScrollZoomComponent, descendants: true, static: true }, { propertyName: "_pageContentElem", first: true, predicate: ["pageContent"], descendants: true, static: true }, { propertyName: "_imagesElem", first: true, predicate: ["images"], descendants: true, static: true }, { propertyName: "_imageComps", predicate: PDFImageComponent, descendants: true }], ngImport: i0, template: "<bukv-scroll-zoom\n  (scaleChange)=\"_onZoomScaleChange($event)\"\n  (scaleStart)=\"_onZoomScaleStart()\"\n  (scaleEnd)=\"_onZoomScaleEnd()\"\n>\n  <div class=\"bukv_page-content\" #pageContent>\n    <div class=\"bukv_images\" #images>\n      <bukv-pdf-image\n        (internalAddressClick)=\"_onInternalAddressClick(0, $event)\"\n        (frameSelectionChange)=\"_onImageSelectionChange(0, $event)\"\n        (framePageChangeKeydown)=\"_onImagePageChangeKeydown(0, $event)\"\n        (frameDoubleClick)=\"_onImageDblClick(0, $event)\"\n        (frameHighlightClick)=\"_onHighlightClick(0, $event)\"\n        (frameClick)=\"_onImageClick(0, $event)\"\n        (frameSwipe)=\"_onImageSwipe(0, $event)\"\n        (framePinch)=\"_onImagePinch($event)\"\n      ></bukv-pdf-image>\n      <bukv-pdf-image\n        (internalAddressClick)=\"_onInternalAddressClick(1, $event)\"\n        (frameSelectionChange)=\"_onImageSelectionChange(1, $event)\"\n        (framePageChangeKeydown)=\"_onImagePageChangeKeydown(1, $event)\"\n        (frameDoubleClick)=\"_onImageDblClick(1, $event)\"\n        (frameHighlightClick)=\"_onHighlightClick(1, $event)\"\n        (frameClick)=\"_onImageClick(1, $event)\"\n        (frameSwipe)=\"_onImageSwipe(1, $event)\"\n        (framePinch)=\"_onImagePinch($event)\"\n      ></bukv-pdf-image>\n    </div>\n  </div>\n</bukv-scroll-zoom>\n", styles: [":host{display:block;height:100%;-webkit-user-select:none;user-select:none}.bukv_page-content{height:100%;position:relative;display:flex;align-items:center;justify-content:center}.bukv_images{width:100%;height:100%;overflow:hidden}bukv-pdf-image{width:100%}.bukv_images.bukv_is-multi-column bukv-pdf-image{width:50%}.bukv_images:not(.bukv_is-multi-column) bukv-pdf-image:first-child{display:none}\n"], dependencies: [{ kind: "component", type: PDFImageComponent, selector: "bukv-pdf-image", outputs: ["imageLoad", "imageLoadError", "internalAddressClick"] }, { kind: "component", type: ScrollZoomComponent, selector: "bukv-scroll-zoom", inputs: ["animDuration", "toggleScale"], outputs: ["scaleChange", "scaleStart", "scaleEnd"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: PDFPageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bukv-pdf-page', template: "<bukv-scroll-zoom\n  (scaleChange)=\"_onZoomScaleChange($event)\"\n  (scaleStart)=\"_onZoomScaleStart()\"\n  (scaleEnd)=\"_onZoomScaleEnd()\"\n>\n  <div class=\"bukv_page-content\" #pageContent>\n    <div class=\"bukv_images\" #images>\n      <bukv-pdf-image\n        (internalAddressClick)=\"_onInternalAddressClick(0, $event)\"\n        (frameSelectionChange)=\"_onImageSelectionChange(0, $event)\"\n        (framePageChangeKeydown)=\"_onImagePageChangeKeydown(0, $event)\"\n        (frameDoubleClick)=\"_onImageDblClick(0, $event)\"\n        (frameHighlightClick)=\"_onHighlightClick(0, $event)\"\n        (frameClick)=\"_onImageClick(0, $event)\"\n        (frameSwipe)=\"_onImageSwipe(0, $event)\"\n        (framePinch)=\"_onImagePinch($event)\"\n      ></bukv-pdf-image>\n      <bukv-pdf-image\n        (internalAddressClick)=\"_onInternalAddressClick(1, $event)\"\n        (frameSelectionChange)=\"_onImageSelectionChange(1, $event)\"\n        (framePageChangeKeydown)=\"_onImagePageChangeKeydown(1, $event)\"\n        (frameDoubleClick)=\"_onImageDblClick(1, $event)\"\n        (frameHighlightClick)=\"_onHighlightClick(1, $event)\"\n        (frameClick)=\"_onImageClick(1, $event)\"\n        (frameSwipe)=\"_onImageSwipe(1, $event)\"\n        (framePinch)=\"_onImagePinch($event)\"\n      ></bukv-pdf-image>\n    </div>\n  </div>\n</bukv-scroll-zoom>\n", styles: [":host{display:block;height:100%;-webkit-user-select:none;user-select:none}.bukv_page-content{height:100%;position:relative;display:flex;align-items:center;justify-content:center}.bukv_images{width:100%;height:100%;overflow:hidden}bukv-pdf-image{width:100%}.bukv_images.bukv_is-multi-column bukv-pdf-image{width:50%}.bukv_images:not(.bukv_is-multi-column) bukv-pdf-image:first-child{display:none}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: LibConfigService }, { type: EventBusService }, { type: AddressStoreService }, { type: ViewerPDFOverlayViewProviderService, decorators: [{
                    type: Optional
                }] }], propDecorators: { _imageComps: [{
                type: ViewChildren,
                args: [PDFImageComponent]
            }], _zoomElem: [{
                type: ViewChild,
                args: [ScrollZoomComponent, { static: true }]
            }], _pageContentElem: [{
                type: ViewChild,
                args: ['pageContent', { static: true }]
            }], _imagesElem: [{
                type: ViewChild,
                args: ['images', { static: true }]
            }], loaded: [{
                type: Output
            }], textLoaded: [{
                type: Output
            }], zoomScaleChange: [{
                type: Output
            }] } });

class PDFPagesComponent extends PagesBaseComponent {
    constructor(_renderer, _element, _ngZone, _libConfig, _eventBus, _addressStore, _settingsStore, _apiService, _searchService, _pdfImageLoaderService) {
        super(_renderer, _element, _libConfig, _eventBus, _settingsStore);
        this._renderer = _renderer;
        this._element = _element;
        this._ngZone = _ngZone;
        this._libConfig = _libConfig;
        this._addressStore = _addressStore;
        this._settingsStore = _settingsStore;
        this._apiService = _apiService;
        this._searchService = _searchService;
        this._pdfImageLoaderService = _pdfImageLoaderService;
        this._itemLoadEventUnsubscriber$ = new Subject();
        this._toc = [];
    }
    get _inactivePageComp() {
        return this._pageComps.find((c) => c !== this._activePageComp);
    }
    ngAfterViewInit() {
        this._addressChange$.subscribe(({ newAddress, oldAddress, changeType }) => {
            this._onAddressChange(changeType, newAddress, oldAddress);
        });
        this._changePage$.subscribe((direction) => {
            this._changePageToDirection(direction);
        });
        this._settingsChange$
            .pipe(filter(({ oldSettings, newSettings }) => {
            return (oldSettings?.multiColumn.value !== newSettings.multiColumn.value);
        }))
            .subscribe(() => {
            this._onItemChange(this._address);
        });
        IS_TOUCH_DEVICE &&
            fromSwipeEvent(this._element.nativeElement)
                .pipe(takeUntil(this._unsubscriber), filter(() => {
                if (this._libConfig.enablePinchZoom) {
                    return this._activePageComp?.zoomScale === 100;
                }
                else {
                    return getWindowScale() === 1 && !isWindowZoomed();
                }
            }))
                .subscribe((direction) => {
                this._eventBus.emit('changePage', {
                    direction: direction === SwipeDirection.Left
                        ? Direction.Next
                        : Direction.Prev,
                    trigger: 'gesture',
                });
            });
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    set annotations(annotations) {
        const deletedAnnotataions = getDeletedAnnotations(this._annotations ?? [], annotations ?? []);
        this._unhighlightAnnotations(deletedAnnotataions);
        this._annotations = annotations;
        this._checkPageBookmarks();
        this._setPageHighlights();
    }
    get annotations() {
        return this._annotations;
    }
    zoom(scale) {
        this._activePageComp?.zoom(scale);
    }
    search(keyword) {
        const createResult = (pageIndex, searchResult) => ({
            text: searchResult.text,
            url: createBukURL(this.book.meta.bid, this.book.items[pageIndex].iid, searchResult.address),
        });
        return this._texts.pipe(switchMap((texts) => {
            const searches = texts.map((text) => {
                return this._searchService
                    .searchContents(keyword, text.pageText)
                    .pipe(map((results) => results.map(createResult.bind(null, text.page))));
            });
            return zip(...searches);
        }), map((results) => Array.prototype.concat(...results)), observeOn(enterZone(this._ngZone)));
    }
    createHighlight(range, styleClass, options = {}) {
        if (!this._activePageComp) {
            return null;
        }
        const { created: annotation, merged: mergedAnnotations } = this._activePageComp.createHighlight(range, styleClass, options);
        if (options.emitEvent !== false) {
            this.annotationCreated.emit({
                annotation,
                mergedAnnotations,
            });
        }
        return {
            annotation,
            mergedAnnotations,
        };
    }
    changeHighlight(range, currStyleClass, newStyleClass, options = {}) {
        if (!this._activePageComp) {
            return null;
        }
        const annotation = this._activePageComp.changeHighlight(range, currStyleClass, newStyleClass);
        if (annotation && options.emitEvent !== false) {
            this.annotationChanged.emit({
                annotation,
                oldStyleClass: currStyleClass,
            });
        }
        return annotation;
    }
    removeHighlight(range, styleClass, options = {}) {
        if (!this._activePageComp) {
            return null;
        }
        const annotation = this._activePageComp.removeHighlight(range, styleClass);
        if (annotation && options.emitEvent !== false) {
            this.annotationRemoved.emit({
                annotations: [annotation],
            });
        }
        return annotation;
    }
    getSelection() {
        return this._activePageComp?.getSelection() ?? null;
    }
    clearSelection() {
        this._activePageComp?.clearSelection();
    }
    getHighlightsFromRange(range) {
        if (!this._activePageComp) {
            throw new Error('no active page');
        }
        return this._activePageComp.getParentHighlightsFromRange(range);
    }
    createRangeFromElements(startId, endId, iid) {
        if (!this._activePageComp) {
            throw new Error('no active page');
        }
        return this._activePageComp.createRangeFromElements(startId, endId, iid);
    }
    getVisibleRanges() {
        if (!this._activePageComp) {
            throw new Error('no active page');
        }
        return this._activePageComp.getVisibleRanges();
    }
    getAddressFromRange(range) {
        if (!this._activePageComp) {
            throw new Error('no active page');
        }
        return this._activePageComp.getAddressFromRange(range);
    }
    _onPageZoomScaleChange(event) {
        if (event.target !== this._activePageComp) {
            return;
        }
        if (event.scale !== this._zoomScale) {
            this._zoomScale = event.scale;
            this.zoomScaleChange.emit({ scale: event.scale });
        }
    }
    _onAddressChange(type, newAddress, oldAddress) {
        switch (type) {
            case AddressChangeType.Book:
                this._initTexts(newAddress.bid);
                this._initTOC();
                this._onItemChange(newAddress, oldAddress);
                break;
            case AddressChangeType.Item:
                this._onItemChange(newAddress, oldAddress);
                break;
            case AddressChangeType.Page:
                this._onPageChange(newAddress);
                break;
            case AddressChangeType.Query:
                this._onQueryChange(newAddress);
                break;
            default:
                break;
        }
    }
    _changePageToDirection(direction) {
        if (!this._address) {
            return;
        }
        const currentIid = this._address.iid ?? this.book.items[0].iid;
        const nextItem = calculateNextItem(this.book, currentIid, direction, this._settingsStore.settings.multiColumn.value);
        if (!nextItem) {
            this.pageChangeCanceled.emit({
                direction,
                code: PageChangeCancelCode.NoNextItem,
            });
            return;
        }
        const newAddress = this._address.clone();
        newAddress.iid = nextItem.iid;
        newAddress.anchor = undefined;
        delete newAddress.query?.highlight;
        delete newAddress.query?.force;
        this._addressStore.update(newAddress);
    }
    _onItemChange(address, oldAddress) {
        // 이전 로드 동작 중지
        this._itemLoadEventUnsubscriber$.next();
        // 유저 interaction 중지
        this._activePageComp?.clearSelection();
        //
        this._activePageComp?.unloadPage();
        // 아이템 로드 시작
        this.itemLoadStart.emit({ address });
        // 불러올 아이템 찾음
        const items = calculateAddressItems(this.book, address, this._settingsStore.settings.multiColumn.value);
        if (items.length === 0) {
            this.itemLoadError.emit({
                address: address.clone(),
                code: ItemLoadErrorCode.ItemNotFound,
            });
            return;
        }
        // 페이지 로드 이벤트 리스너 추가
        this._inactivePageComp?.loaded
            .pipe(takeUntil(this._itemLoadEventUnsubscriber$), take(1))
            .subscribe((event) => {
            const isInitialLoading = !this._activePageComp;
            const skipPageAnimation = isInitialLoading || oldAddress?.bid !== address.bid;
            this._activePageComp = this._inactivePageComp;
            // 확대 배율 초기화
            this._activePageComp.resetZoom(this._zoomScale, items.length === 1);
            // 텍스트 로드
            this._texts
                .pipe(takeUntil(this._itemLoadEventUnsubscriber$))
                .subscribe((texts) => {
                this._activePageComp?.loadText(...items.map((item) => {
                    const index = this.book.getItemIndex(item.iid);
                    return texts.find((text) => text.page === index);
                }));
                this._setPageHighlights();
                this._address && this._setPage(this._address);
            });
            if (isInitialLoading) {
                this._onPageZoomScaleChange({
                    target: this._activePageComp,
                    scale: this._activePageComp.zoomScale,
                });
            }
            this.itemLoad.emit({
                address: address.clone(),
                items: items,
            });
            this._checkPageBookmarks();
            this.pageInfoChange.emit({
                pageCount: 1,
                page: 1,
                printPageCount: null,
                printPages: [],
                tocIndex: this._getCurrentTOCIndex(),
            });
            this._changePageVisibility(this._activePageComp, this._inactivePageComp, skipPageAnimation);
        });
        const pageInfoArr = items.map((item) => ({
            item,
            baseURL: createBukURL(address.bid, item.iid),
            links: item.links?.map((link) => {
                let url;
                if (typeof link[1][0] === 'string') {
                    url = link[1][0];
                }
                else {
                    const item = this.book.items[link[1][0]];
                    url = createBukURL(this.book.meta.bid, item.iid);
                }
                return [link[0], url];
            }),
        }));
        this._inactivePageComp?.loadPage(pageInfoArr[0], pageInfoArr[1]);
        this._preloadImage(items);
    }
    _onPageChange(address) {
        this._setPage(address);
    }
    _onQueryChange(address) {
        this._setPage(address);
    }
    _setPage(address) {
        this._activePageComp.clearAnchorHighlight();
        const highlightColor = getAnchorHighlightColorFromQuery(address.query);
        if (address.range && highlightColor) {
            const iid = address.iid ?? this.book.items[0].iid;
            this._activePageComp.highlightAnchor(iid, address.range, highlightColor);
        }
    }
    _changePageVisibility(activePageComp, inactivePageComp, skipAnimation) {
        super._changePageVisibility(activePageComp, inactivePageComp, skipAnimation || !this._settingsStore.settings.pageAnimation.value);
    }
    _checkPageBookmarks() {
        if (!this.annotations) {
            return;
        }
        this._pageBookmarks = this.annotations.filter((annotation) => {
            return (annotation.type === AnnotationType.Bookmark &&
                annotation.address.bid === this.book.meta.bid &&
                this._activePageComp?.isAnnotationAtCurrentPage(annotation));
        });
    }
    _createBookmark() {
        const iid = this._activePageComp?.getBookmarkIid();
        if (!iid) {
            throw new Error();
        }
        return {
            type: AnnotationType.Bookmark,
            url: new Address(this.book.meta.bid, iid).toString(),
            text: '',
            styleClass: null,
        };
    }
    _setPageHighlights() {
        if (!this.annotations) {
            return;
        }
        this._highlightAnnotations(this.annotations);
    }
    _highlightAnnotations(annotations) {
        this._activePageComp?.highlight(annotations.filter((highlight) => this._canHighlightAnnotation(highlight)));
    }
    _unhighlightAnnotations(annotations) {
        this._activePageComp?.unhighlight(annotations.filter((highlight) => this._canHighlightAnnotation(highlight)));
    }
    _canHighlightAnnotation(annotation) {
        return annotation.address.bid === this.book.meta.bid;
    }
    _preloadImage(baseItems) {
        const preloadItems = [];
        const leftBaseIndex = this.book.getItemIndex(baseItems[baseItems.length - 1].iid);
        const rightBaseIndex = this.book.getItemIndex(baseItems[0].iid);
        let item;
        for (let pageGap = 1; pageGap <= 2; pageGap++) {
            item = this.book.items[leftBaseIndex - pageGap];
            if (item) {
                preloadItems.push(item);
            }
            item = this.book.items[rightBaseIndex + pageGap];
            if (item) {
                preloadItems.push(item);
            }
        }
        preloadItems.forEach((item) => {
            item.url && this._pdfImageLoaderService.preload(item.url);
        });
    }
    _initTOC() {
        this._toc = this.book.toc.map((tocItem) => {
            const address = parseBukURL(`/@${this.book.meta.bid}/${tocItem.address}`);
            return {
                address,
                itemIndex: this.book.getItemIndex(address.iid),
            };
        });
    }
    _getCurrentTOCIndex() {
        const pageIid = this._activePageComp._rightItem.iid;
        const currentItemIndex = this.book.getItemIndex(pageIid);
        let currentTOCIndex = -1;
        for (let i = 0; i < this._toc.length; i++) {
            const tocItem = this._toc[i];
            if (pageIid === tocItem.address.iid) {
                currentTOCIndex = i;
            }
            else if (tocItem.itemIndex < currentItemIndex) {
                if (currentTOCIndex === -1) {
                    currentTOCIndex = i;
                }
                else if (this._toc[currentTOCIndex].itemIndex <= tocItem.itemIndex) {
                    currentTOCIndex = i;
                }
            }
        }
        return currentTOCIndex;
    }
    _initTexts(bid) {
        this._texts = this._apiService.getPDFText(bid).pipe(map((texts) => {
            return texts.map((text) => ({
                ...text,
                pageText: text.texts.map((t) => t[5].trim()).join(' '),
            }));
        }), catchError(() => of([])), shareReplay(1));
        this._texts.subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: PDFPagesComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i0.NgZone }, { token: LibConfigService }, { token: EventBusService }, { token: AddressStoreService }, { token: SettingsStoreService }, { token: APIService }, { token: SearchService }, { token: PDFImageLoaderService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.3", type: PDFPagesComponent, selector: "bukv-pdf-pages", inputs: { annotations: "annotations" }, viewQueries: [{ propertyName: "_pageComps", predicate: PDFPageComponent, descendants: true }], usesInheritance: true, ngImport: i0, template: "<bukv-pdf-page\n  class=\"bukv_page\"\n  (zoomScaleChange)=\"_onPageZoomScaleChange($event)\"\n></bukv-pdf-page>\n<bukv-pdf-page\n  class=\"bukv_page\"\n  (zoomScaleChange)=\"_onPageZoomScaleChange($event)\"\n></bukv-pdf-page>\n", styles: [":host{display:block;width:100%;height:100%;position:relative}:host[data-bukv-theme=light] .bukv_page{background-color:var(--bukv-contents-bg-color-light)}:host[data-bukv-theme=dark] .bukv_page{background-color:var(--bukv-contents-bg-color-dark)}:host[data-bukv-theme=sepia] .bukv_page{background-color:var(--bukv-contents-bg-color-sepia)}.bukv_page{position:absolute;inset:0;visibility:hidden;z-index:-1}.bukv_page.bukv_is-active{visibility:visible;z-index:0}@keyframes bukvPageSlideInLeft{0%{transform:translate3d(100%,0,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideInRight{0%{transform:translate3d(-100%,0,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutLeft{0%{transform:translateZ(0)}to{transform:translate3d(-100%,0,0)}}@keyframes bukvPageSlideOutRight{0%{transform:translateZ(0)}to{transform:translate3d(100%,0,0)}}@keyframes bukvPageSlideInTop{0%{transform:translate3d(0,100%,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutTop{0%{transform:translateZ(0)}to{transform:translate3d(0,-100%,0)}}@keyframes bukvPageSlideInBottom{0%{transform:translate3d(0,-100%,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutBottom{0%{transform:translateZ(0)}to{transform:translate3d(0,100%,0)}}:host.bukv_anim-to-prev .bukv_page,:host.bukv_anim-to-next .bukv_page{animation-duration:.3s;animation-timing-function:ease;visibility:visible!important}:host.bukv_anim-to-prev .bukv_page.bukv_is-active{animation-name:bukvPageSlideInRight;z-index:-1!important}:host.bukv_anim-to-prev .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutRight;z-index:0!important}:host.bukv_anim-to-next .bukv_page.bukv_is-active{animation-name:bukvPageSlideInLeft;z-index:-1!important}:host.bukv_anim-to-next .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutLeft;z-index:0!important}:host.bukv_is-vertical.bukv_anim-to-prev .bukv_page.bukv_is-active{animation-name:bukvPageSlideInBottom;z-index:-1!important}:host.bukv_is-vertical.bukv_anim-to-prev .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutBottom;z-index:0!important}:host.bukv_is-vertical.bukv_anim-to-next .bukv_page.bukv_is-active{animation-name:bukvPageSlideInTop;z-index:-1!important}:host.bukv_is-vertical.bukv_anim-to-next .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutTop;z-index:0!important}\n", ""], dependencies: [{ kind: "component", type: PDFPageComponent, selector: "bukv-pdf-page", outputs: ["loaded", "textLoaded", "zoomScaleChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: PDFPagesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bukv-pdf-pages', template: "<bukv-pdf-page\n  class=\"bukv_page\"\n  (zoomScaleChange)=\"_onPageZoomScaleChange($event)\"\n></bukv-pdf-page>\n<bukv-pdf-page\n  class=\"bukv_page\"\n  (zoomScaleChange)=\"_onPageZoomScaleChange($event)\"\n></bukv-pdf-page>\n", styles: [":host{display:block;width:100%;height:100%;position:relative}:host[data-bukv-theme=light] .bukv_page{background-color:var(--bukv-contents-bg-color-light)}:host[data-bukv-theme=dark] .bukv_page{background-color:var(--bukv-contents-bg-color-dark)}:host[data-bukv-theme=sepia] .bukv_page{background-color:var(--bukv-contents-bg-color-sepia)}.bukv_page{position:absolute;inset:0;visibility:hidden;z-index:-1}.bukv_page.bukv_is-active{visibility:visible;z-index:0}@keyframes bukvPageSlideInLeft{0%{transform:translate3d(100%,0,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideInRight{0%{transform:translate3d(-100%,0,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutLeft{0%{transform:translateZ(0)}to{transform:translate3d(-100%,0,0)}}@keyframes bukvPageSlideOutRight{0%{transform:translateZ(0)}to{transform:translate3d(100%,0,0)}}@keyframes bukvPageSlideInTop{0%{transform:translate3d(0,100%,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutTop{0%{transform:translateZ(0)}to{transform:translate3d(0,-100%,0)}}@keyframes bukvPageSlideInBottom{0%{transform:translate3d(0,-100%,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutBottom{0%{transform:translateZ(0)}to{transform:translate3d(0,100%,0)}}:host.bukv_anim-to-prev .bukv_page,:host.bukv_anim-to-next .bukv_page{animation-duration:.3s;animation-timing-function:ease;visibility:visible!important}:host.bukv_anim-to-prev .bukv_page.bukv_is-active{animation-name:bukvPageSlideInRight;z-index:-1!important}:host.bukv_anim-to-prev .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutRight;z-index:0!important}:host.bukv_anim-to-next .bukv_page.bukv_is-active{animation-name:bukvPageSlideInLeft;z-index:-1!important}:host.bukv_anim-to-next .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutLeft;z-index:0!important}:host.bukv_is-vertical.bukv_anim-to-prev .bukv_page.bukv_is-active{animation-name:bukvPageSlideInBottom;z-index:-1!important}:host.bukv_is-vertical.bukv_anim-to-prev .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutBottom;z-index:0!important}:host.bukv_is-vertical.bukv_anim-to-next .bukv_page.bukv_is-active{animation-name:bukvPageSlideInTop;z-index:-1!important}:host.bukv_is-vertical.bukv_anim-to-next .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutTop;z-index:0!important}\n"] }]
        }], ctorParameters: () => [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i0.NgZone }, { type: LibConfigService }, { type: EventBusService }, { type: AddressStoreService }, { type: SettingsStoreService }, { type: APIService }, { type: SearchService }, { type: PDFImageLoaderService }], propDecorators: { _pageComps: [{
                type: ViewChildren,
                args: [PDFPageComponent]
            }], annotations: [{
                type: Input
            }] } });

class DocPagesComponent extends PagesComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: DocPagesComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.3", type: DocPagesComponent, selector: "bukv-doc-pages", usesInheritance: true, ngImport: i0, template: "<bukv-page\n  class=\"bukv_page\"\n  (pageScrolled)=\"_onPageScrolled($event)\"\n  (pageSettled)=\"_onPageSettled()\"\n></bukv-page>\n<bukv-page\n  class=\"bukv_page\"\n  (pageScrolled)=\"_onPageScrolled($event)\"\n  (pageSettled)=\"_onPageSettled()\"\n></bukv-page>\n", styles: [":host{display:block;width:100%;height:100%;position:relative}:host[data-bukv-theme=light] .bukv_page{background-color:var(--bukv-contents-bg-color-light)}:host[data-bukv-theme=dark] .bukv_page{background-color:var(--bukv-contents-bg-color-dark)}:host[data-bukv-theme=sepia] .bukv_page{background-color:var(--bukv-contents-bg-color-sepia)}.bukv_page{position:absolute;inset:0;visibility:hidden;z-index:-1}.bukv_page.bukv_is-active{visibility:visible;z-index:0}@keyframes bukvPageSlideInLeft{0%{transform:translate3d(100%,0,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideInRight{0%{transform:translate3d(-100%,0,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutLeft{0%{transform:translateZ(0)}to{transform:translate3d(-100%,0,0)}}@keyframes bukvPageSlideOutRight{0%{transform:translateZ(0)}to{transform:translate3d(100%,0,0)}}@keyframes bukvPageSlideInTop{0%{transform:translate3d(0,100%,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutTop{0%{transform:translateZ(0)}to{transform:translate3d(0,-100%,0)}}@keyframes bukvPageSlideInBottom{0%{transform:translate3d(0,-100%,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutBottom{0%{transform:translateZ(0)}to{transform:translate3d(0,100%,0)}}:host.bukv_anim-to-prev .bukv_page,:host.bukv_anim-to-next .bukv_page{animation-duration:.3s;animation-timing-function:ease;visibility:visible!important}:host.bukv_anim-to-prev .bukv_page.bukv_is-active{animation-name:bukvPageSlideInRight;z-index:-1!important}:host.bukv_anim-to-prev .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutRight;z-index:0!important}:host.bukv_anim-to-next .bukv_page.bukv_is-active{animation-name:bukvPageSlideInLeft;z-index:-1!important}:host.bukv_anim-to-next .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutLeft;z-index:0!important}:host.bukv_is-vertical.bukv_anim-to-prev .bukv_page.bukv_is-active{animation-name:bukvPageSlideInBottom;z-index:-1!important}:host.bukv_is-vertical.bukv_anim-to-prev .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutBottom;z-index:0!important}:host.bukv_is-vertical.bukv_anim-to-next .bukv_page.bukv_is-active{animation-name:bukvPageSlideInTop;z-index:-1!important}:host.bukv_is-vertical.bukv_anim-to-next .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutTop;z-index:0!important}\n", ""], dependencies: [{ kind: "component", type: PageComponent, selector: "bukv-page", inputs: ["mediaOverlayMeta"], outputs: ["loaded", "domLoaded", "pageScrolled", "pageSettled", "mediaOverlayClick", "zoomScaleChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: DocPagesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bukv-doc-pages', template: "<bukv-page\n  class=\"bukv_page\"\n  (pageScrolled)=\"_onPageScrolled($event)\"\n  (pageSettled)=\"_onPageSettled()\"\n></bukv-page>\n<bukv-page\n  class=\"bukv_page\"\n  (pageScrolled)=\"_onPageScrolled($event)\"\n  (pageSettled)=\"_onPageSettled()\"\n></bukv-page>\n", styles: [":host{display:block;width:100%;height:100%;position:relative}:host[data-bukv-theme=light] .bukv_page{background-color:var(--bukv-contents-bg-color-light)}:host[data-bukv-theme=dark] .bukv_page{background-color:var(--bukv-contents-bg-color-dark)}:host[data-bukv-theme=sepia] .bukv_page{background-color:var(--bukv-contents-bg-color-sepia)}.bukv_page{position:absolute;inset:0;visibility:hidden;z-index:-1}.bukv_page.bukv_is-active{visibility:visible;z-index:0}@keyframes bukvPageSlideInLeft{0%{transform:translate3d(100%,0,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideInRight{0%{transform:translate3d(-100%,0,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutLeft{0%{transform:translateZ(0)}to{transform:translate3d(-100%,0,0)}}@keyframes bukvPageSlideOutRight{0%{transform:translateZ(0)}to{transform:translate3d(100%,0,0)}}@keyframes bukvPageSlideInTop{0%{transform:translate3d(0,100%,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutTop{0%{transform:translateZ(0)}to{transform:translate3d(0,-100%,0)}}@keyframes bukvPageSlideInBottom{0%{transform:translate3d(0,-100%,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutBottom{0%{transform:translateZ(0)}to{transform:translate3d(0,100%,0)}}:host.bukv_anim-to-prev .bukv_page,:host.bukv_anim-to-next .bukv_page{animation-duration:.3s;animation-timing-function:ease;visibility:visible!important}:host.bukv_anim-to-prev .bukv_page.bukv_is-active{animation-name:bukvPageSlideInRight;z-index:-1!important}:host.bukv_anim-to-prev .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutRight;z-index:0!important}:host.bukv_anim-to-next .bukv_page.bukv_is-active{animation-name:bukvPageSlideInLeft;z-index:-1!important}:host.bukv_anim-to-next .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutLeft;z-index:0!important}:host.bukv_is-vertical.bukv_anim-to-prev .bukv_page.bukv_is-active{animation-name:bukvPageSlideInBottom;z-index:-1!important}:host.bukv_is-vertical.bukv_anim-to-prev .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutBottom;z-index:0!important}:host.bukv_is-vertical.bukv_anim-to-next .bukv_page.bukv_is-active{animation-name:bukvPageSlideInTop;z-index:-1!important}:host.bukv_is-vertical.bukv_anim-to-next .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutTop;z-index:0!important}\n"] }]
        }] });

class WikiPagesComponent extends PagesComponent {
    constructor(_renderer, _element, _ngZone, _libConfig, _eventBus, _addressStore, _settingsStore, _contentsService, _contentsProcessorService, _searchService) {
        super(_renderer, _element, _ngZone, _libConfig, _eventBus, _addressStore, _settingsStore, _contentsService, _contentsProcessorService, _searchService);
        this._renderer = _renderer;
        this._element = _element;
        this._ngZone = _ngZone;
        this._addressStore = _addressStore;
        this._settingsStore = _settingsStore;
        this._contentsService = _contentsService;
        this._contentsProcessorService = _contentsProcessorService;
    }
    _fixAddress(address) {
        let fixed = super._fixAddress(address);
        /**
         * 위키 현재 버전 추가
         */
        if (!address.query?.version) {
            if (!address.query) {
                address.query = {};
            }
            address.query.version = this.book.meta.version;
            fixed = true;
        }
        return fixed;
    }
    _getContents(item) {
        if (!this._contentsCache.has(this.book.meta.version)) {
            const contents$ = this._contentsService
                .getWikiItem(this.book.meta.bid, this.book.meta.version)
                .pipe(catchError((error) => {
                return throwError({
                    code: ItemLoadErrorCode.ContentsLoadFailed,
                    raw: error,
                });
            }), switchMap((html) => {
                try {
                    return of(this._contentsProcessorService.processContentsHTML(this.book, item, html));
                }
                catch (error) {
                    return throwError({
                        code: ItemLoadErrorCode.ContentsProcessingFailed,
                        raw: error,
                    });
                }
            }), shareReplay(1));
            this._contentsCache.set(this.book.meta.version, contents$);
        }
        return this._contentsCache.get(this.book.meta.version);
    }
    _changePageVisibility(activePageComp, inactivePageComp, skipAnimation) {
        super._changePageVisibility(activePageComp, inactivePageComp, true);
    }
    _canHighlightAnnotation(annotation) {
        return (annotation.address.bid === this.book.meta.bid &&
            annotation.address.query?.version === this.book.meta.version);
    }
    search(keyword) {
        return super.search(keyword).pipe(map((results) => {
            return results.map((r) => {
                const address = parseBukURL(r.url);
                if (!address.query) {
                    address.query = {};
                }
                address.query.version = this.book.meta.version;
                return {
                    ...r,
                    url: address.toString(),
                };
            });
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: WikiPagesComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i0.NgZone }, { token: LibConfigService }, { token: EventBusService }, { token: AddressStoreService }, { token: SettingsStoreService }, { token: ContentsService }, { token: ContentsProcessorService }, { token: SearchService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.3", type: WikiPagesComponent, selector: "bukv-wiki-pages", usesInheritance: true, ngImport: i0, template: "<bukv-page\n  class=\"bukv_page\"\n  (pageScrolled)=\"_onPageScrolled($event)\"\n  (pageSettled)=\"_onPageSettled()\"\n></bukv-page>\n<bukv-page\n  class=\"bukv_page\"\n  (pageScrolled)=\"_onPageScrolled($event)\"\n  (pageSettled)=\"_onPageSettled()\"\n></bukv-page>\n", styles: [":host{display:block;width:100%;height:100%;position:relative}:host[data-bukv-theme=light] .bukv_page{background-color:var(--bukv-contents-bg-color-light)}:host[data-bukv-theme=dark] .bukv_page{background-color:var(--bukv-contents-bg-color-dark)}:host[data-bukv-theme=sepia] .bukv_page{background-color:var(--bukv-contents-bg-color-sepia)}.bukv_page{position:absolute;inset:0;visibility:hidden;z-index:-1}.bukv_page.bukv_is-active{visibility:visible;z-index:0}@keyframes bukvPageSlideInLeft{0%{transform:translate3d(100%,0,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideInRight{0%{transform:translate3d(-100%,0,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutLeft{0%{transform:translateZ(0)}to{transform:translate3d(-100%,0,0)}}@keyframes bukvPageSlideOutRight{0%{transform:translateZ(0)}to{transform:translate3d(100%,0,0)}}@keyframes bukvPageSlideInTop{0%{transform:translate3d(0,100%,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutTop{0%{transform:translateZ(0)}to{transform:translate3d(0,-100%,0)}}@keyframes bukvPageSlideInBottom{0%{transform:translate3d(0,-100%,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutBottom{0%{transform:translateZ(0)}to{transform:translate3d(0,100%,0)}}:host.bukv_anim-to-prev .bukv_page,:host.bukv_anim-to-next .bukv_page{animation-duration:.3s;animation-timing-function:ease;visibility:visible!important}:host.bukv_anim-to-prev .bukv_page.bukv_is-active{animation-name:bukvPageSlideInRight;z-index:-1!important}:host.bukv_anim-to-prev .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutRight;z-index:0!important}:host.bukv_anim-to-next .bukv_page.bukv_is-active{animation-name:bukvPageSlideInLeft;z-index:-1!important}:host.bukv_anim-to-next .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutLeft;z-index:0!important}:host.bukv_is-vertical.bukv_anim-to-prev .bukv_page.bukv_is-active{animation-name:bukvPageSlideInBottom;z-index:-1!important}:host.bukv_is-vertical.bukv_anim-to-prev .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutBottom;z-index:0!important}:host.bukv_is-vertical.bukv_anim-to-next .bukv_page.bukv_is-active{animation-name:bukvPageSlideInTop;z-index:-1!important}:host.bukv_is-vertical.bukv_anim-to-next .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutTop;z-index:0!important}\n", ""], dependencies: [{ kind: "component", type: PageComponent, selector: "bukv-page", inputs: ["mediaOverlayMeta"], outputs: ["loaded", "domLoaded", "pageScrolled", "pageSettled", "mediaOverlayClick", "zoomScaleChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: WikiPagesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bukv-wiki-pages', template: "<bukv-page\n  class=\"bukv_page\"\n  (pageScrolled)=\"_onPageScrolled($event)\"\n  (pageSettled)=\"_onPageSettled()\"\n></bukv-page>\n<bukv-page\n  class=\"bukv_page\"\n  (pageScrolled)=\"_onPageScrolled($event)\"\n  (pageSettled)=\"_onPageSettled()\"\n></bukv-page>\n", styles: [":host{display:block;width:100%;height:100%;position:relative}:host[data-bukv-theme=light] .bukv_page{background-color:var(--bukv-contents-bg-color-light)}:host[data-bukv-theme=dark] .bukv_page{background-color:var(--bukv-contents-bg-color-dark)}:host[data-bukv-theme=sepia] .bukv_page{background-color:var(--bukv-contents-bg-color-sepia)}.bukv_page{position:absolute;inset:0;visibility:hidden;z-index:-1}.bukv_page.bukv_is-active{visibility:visible;z-index:0}@keyframes bukvPageSlideInLeft{0%{transform:translate3d(100%,0,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideInRight{0%{transform:translate3d(-100%,0,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutLeft{0%{transform:translateZ(0)}to{transform:translate3d(-100%,0,0)}}@keyframes bukvPageSlideOutRight{0%{transform:translateZ(0)}to{transform:translate3d(100%,0,0)}}@keyframes bukvPageSlideInTop{0%{transform:translate3d(0,100%,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutTop{0%{transform:translateZ(0)}to{transform:translate3d(0,-100%,0)}}@keyframes bukvPageSlideInBottom{0%{transform:translate3d(0,-100%,0)}to{transform:translateZ(0)}}@keyframes bukvPageSlideOutBottom{0%{transform:translateZ(0)}to{transform:translate3d(0,100%,0)}}:host.bukv_anim-to-prev .bukv_page,:host.bukv_anim-to-next .bukv_page{animation-duration:.3s;animation-timing-function:ease;visibility:visible!important}:host.bukv_anim-to-prev .bukv_page.bukv_is-active{animation-name:bukvPageSlideInRight;z-index:-1!important}:host.bukv_anim-to-prev .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutRight;z-index:0!important}:host.bukv_anim-to-next .bukv_page.bukv_is-active{animation-name:bukvPageSlideInLeft;z-index:-1!important}:host.bukv_anim-to-next .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutLeft;z-index:0!important}:host.bukv_is-vertical.bukv_anim-to-prev .bukv_page.bukv_is-active{animation-name:bukvPageSlideInBottom;z-index:-1!important}:host.bukv_is-vertical.bukv_anim-to-prev .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutBottom;z-index:0!important}:host.bukv_is-vertical.bukv_anim-to-next .bukv_page.bukv_is-active{animation-name:bukvPageSlideInTop;z-index:-1!important}:host.bukv_is-vertical.bukv_anim-to-next .bukv_page:not(.bukv_is-active){animation-name:bukvPageSlideOutTop;z-index:0!important}\n"] }]
        }], ctorParameters: () => [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i0.NgZone }, { type: LibConfigService }, { type: EventBusService }, { type: AddressStoreService }, { type: SettingsStoreService }, { type: ContentsService }, { type: ContentsProcessorService }, { type: SearchService }] });

class MainComponent {
    constructor(_element, _libConfig, _contentsService, _addressStore, _settingsStore, _eventBus) {
        this._element = _element;
        this._libConfig = _libConfig;
        this._contentsService = _contentsService;
        this._addressStore = _addressStore;
        this._settingsStore = _settingsStore;
        this._eventBus = _eventBus;
        this.BookType = BookType;
        this._isLoadingBook = false;
        this._annotations = [];
        this._mediaOverlayPlaybackRate = 1;
        this.bookLoad = new EventEmitter();
        this.bookLoadError = new EventEmitter();
        this.addressChange = new EventEmitter();
        this.settingsChange = new EventEmitter();
        this.itemLoadStart = new EventEmitter();
        this.itemLoad = new EventEmitter();
        this.itemLoadError = new EventEmitter();
        this.pageInfoChange = new EventEmitter();
        this.bookmarkStateChange = new EventEmitter();
        this.selectionChange = new EventEmitter();
        this.highlightClick = new EventEmitter();
        this.annotationCreated = new EventEmitter();
        this.annotationChanged = new EventEmitter();
        this.annotationRemoved = new EventEmitter();
        this.mediaOverlayPlayStateChange = new EventEmitter();
        this.pageTap = new EventEmitter();
        this.pageChangeCanceled = new EventEmitter();
        this.pageTransitionEnd = new EventEmitter();
        this.zoomScaleChange = new EventEmitter();
    }
    ngAfterViewInit() {
        if (this._libConfig.enablePinchZoom) {
            preventBrowserPinchZoom(document);
        }
        this._addressStore.address$
            .pipe(startWith(undefined), pairwise())
            .subscribe(([oldAddr, newAddr]) => {
            const type = getAddressChangeType(newAddr, oldAddr);
            if (type !== AddressChangeType.None) {
                this.addressChange.emit({ address: newAddr.clone() });
            }
            if (type === AddressChangeType.Book) {
                this._loadBook(newAddr);
            }
            else if (!this._isLoadingBook) {
                this.pagesComps.first.updateAddress(newAddr);
            }
        });
        this._settingsStore.settings$.subscribe((settings) => {
            if (!this._isLoadingBook) {
                this.pagesComps.first?.updateSettings(settings);
            }
            this.settingsChange.emit({
                settings: cloneObj(settings),
            });
        });
        this._eventBus.on('pageTap').subscribe((event) => {
            this.pageTap.emit(event);
        });
        this._eventBus.on('selectionChange').subscribe((event) => {
            this.selectionChange.emit(event);
        });
        this._eventBus.on('highlightClick').subscribe((event) => {
            this.highlightClick.emit(event);
        });
        this._eventBus.on('pageTransitionEnd').subscribe(() => {
            this.pageTransitionEnd.emit();
        });
    }
    openBook(bid, iid, anchor, query) {
        this._addressStore.updateWithURL(createBukURL(bid, iid, anchor, query));
    }
    openBookWithURL(url) {
        this._addressStore.updateWithURL(url);
    }
    prevPage() {
        this._eventBus.emit('changePage', {
            direction: Direction.Prev,
            trigger: 'manual',
        });
    }
    nextPage() {
        this._eventBus.emit('changePage', {
            direction: Direction.Next,
            trigger: 'manual',
        });
    }
    goToPrintPage(page) {
        const pageListItem = this._book?.page_list.find((item) => item.page === page);
        if (pageListItem) {
            const bid = this._addressStore.address.bid;
            const address = new Address(bid, pageListItem.iid, pageListItem.anchor);
            this._addressStore.update(address);
        }
    }
    getCurrentSettings() {
        return cloneObj(this._settingsStore.settings);
    }
    getCurrentAddress() {
        return this._addressStore.address?.clone();
    }
    getFontsCurrentlyAvailable() {
        if (!this._book) {
            return [];
        }
        return getFontsForBook(this._book, this._libConfig.fonts);
    }
    /** @deprecated */
    changeTheme(theme) {
        this._settingsStore.changeTheme(theme);
    }
    /** @deprecated */
    changeFontSize(value, isAbsolute) {
        this._settingsStore.changeFontSize(value, isAbsolute);
    }
    /** @deprecated */
    changeFontFace(fontFace) {
        this._settingsStore.changeFontFace(fontFace);
    }
    /** @deprecated */
    changeLineHeight(value, isAbsolute) {
        this._settingsStore.changeLineHeight(value, isAbsolute);
    }
    /** @deprecated */
    changePagingMode(pagingMode) {
        this._settingsStore.changePagingMode(pagingMode);
    }
    /** @deprecated */
    setPageAnimation(isActive) {
        this._settingsStore.setPageAnimation(isActive);
    }
    /** @deprecated */
    setMultiColumn(isActive) {
        this._settingsStore.setMultiColumn(isActive);
    }
    /** @deprecated */
    setClickToPlayMediaOverlay(isActive) {
        this._settingsStore.setClickToPlayMediaOverlay(isActive);
    }
    updateSettings(key, value) {
        this._settingsStore.change(key, value);
    }
    setContentsStyles(styles) {
        this._libConfig.contentsStyles = styles;
        this.pagesComps.first.applyContentsStyles();
    }
    setPageGestureEnabled(enabled) {
        this._libConfig.pageGestureEnabled = enabled;
    }
    setAnnotations(annotations) {
        this._annotations = annotations.map((annotation) => {
            return new ParsedAnnotation(annotation);
        });
    }
    toggleBookmark() {
        this.pagesComps.first.toggleBookmark();
    }
    search(keyword, callback) {
        const subscription = this.pagesComps.first
            .search(keyword)
            .subscribe((result) => callback(result));
        return () => subscription.unsubscribe();
    }
    playMediaOverlay(prevOrNext) {
        this.pagesComps.first.playMediaOverlay(prevOrNext);
    }
    playMediaOverlayFromRange(range) {
        this.pagesComps.first.playMediaOverlayFromRange(range);
    }
    pauseMediaOverlay() {
        this.pagesComps.first.pauseMediaOverlay();
    }
    isPlayingMediaOverlay() {
        return this.pagesComps.first.isPlayingMediaOverlay();
    }
    setMediaOverlayPlaybackRate(value) {
        this._mediaOverlayPlaybackRate = value;
    }
    canPlayMediaOverlayFromRange(range) {
        return this.pagesComps.first.canPlayMediaOverlayFromRange(range);
    }
    getHighlightsFromRange(range) {
        return this.pagesComps.first.getHighlightsFromRange(range);
    }
    createHighlight(range, styleClass, options) {
        return this.pagesComps.first.createHighlight(this._toHighlightableRange(range), styleClass, options);
    }
    changeHighlight(rangeURL, currStyleClass, newStyleClass, options) {
        return this.pagesComps.first.changeHighlight(this._toHighlightableRange(rangeURL), currStyleClass, newStyleClass, options);
    }
    removeHighlight(rangeURL, styleClass, options) {
        return this.pagesComps.first.removeHighlight(this._toHighlightableRange(rangeURL), styleClass, options);
    }
    getSelection() {
        return this.pagesComps.first.getSelection();
    }
    clearSelection() {
        this.pagesComps.first.clearSelection();
    }
    zoom(scale) {
        this.pagesComps.first.zoom(scale);
    }
    createRangeFromElements(startId, endId, iid) {
        return this.pagesComps.first.createRangeFromElements(startId, endId, iid);
    }
    getVisibleRanges() {
        return this.pagesComps.first.getVisibleRanges();
    }
    getAddressFromRange(range) {
        return this.pagesComps.first.getAddressFromRange(range);
    }
    _loadBook(address) {
        if (this._bookLoadSubscription) {
            this._bookLoadSubscription.unsubscribe();
        }
        this._isLoadingBook = true;
        this._bookLoadSubscription = this._contentsService
            .getBook(address)
            .subscribe((book) => this._onBookLoad(book), (error) => this._onBookLoadError(error));
    }
    _onBookLoad(bukJSON) {
        this._book = new Book(bukJSON);
        this._settingsStore.resetSettings(this._book, this._getViewerSize());
        setTimeout(() => {
            this.pagesComps.first.updateAddress(this._addressStore.address);
            this._isLoadingBook = false;
        });
        this.bookLoad.emit({ book: this._book._rawBook });
    }
    _onBookLoadError(error) {
        this._isLoadingBook = false;
        this.bookLoadError.emit({
            code: error instanceof HttpErrorResponse
                ? BookLoadErrorCode.Network
                : BookLoadErrorCode.Unknown,
            raw: error,
        });
    }
    _getViewerSize() {
        return {
            width: this._element.nativeElement.offsetWidth,
            height: this._element.nativeElement.offsetHeight,
        };
    }
    _toHighlightableRange(range) {
        if (typeof range !== 'string') {
            return range;
        }
        const result = parseBukURL(range);
        if (this._addressStore.address?.bid !== result.bid || !result.range) {
            throw new Error('Invalid range');
        }
        return result;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: MainComponent, deps: [{ token: i0.ElementRef }, { token: LibConfigService }, { token: ContentsService }, { token: AddressStoreService }, { token: SettingsStoreService }, { token: EventBusService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.3", type: MainComponent, selector: "bukv-main", outputs: { bookLoad: "bookLoad", bookLoadError: "bookLoadError", addressChange: "addressChange", settingsChange: "settingsChange", itemLoadStart: "itemLoadStart", itemLoad: "itemLoad", itemLoadError: "itemLoadError", pageInfoChange: "pageInfoChange", bookmarkStateChange: "bookmarkStateChange", selectionChange: "selectionChange", highlightClick: "highlightClick", annotationCreated: "annotationCreated", annotationChanged: "annotationChanged", annotationRemoved: "annotationRemoved", mediaOverlayPlayStateChange: "mediaOverlayPlayStateChange", pageTap: "pageTap", pageChangeCanceled: "pageChangeCanceled", pageTransitionEnd: "pageTransitionEnd", zoomScaleChange: "zoomScaleChange" }, providers: [
            APIService,
            AddressStoreService,
            ContentsClickInterceptorService,
            ContentsProcessorService,
            ContentsService,
            SettingsStoreService,
            PDFImageLoaderService,
        ], viewQueries: [{ propertyName: "pagesComps", predicate: ["pages"], descendants: true }], ngImport: i0, template: "<bukv-pages\n  #pages\n  *ngIf=\"\n    _book &&\n    (_book.meta.type === BookType.Buk || _book.meta.type === BookType.Edition)\n  \"\n  [book]=\"_book\"\n  [annotations]=\"_annotations\"\n  [mediaOverlayPlaybackRate]=\"_mediaOverlayPlaybackRate\"\n  (itemLoadStart)=\"itemLoadStart.emit($event)\"\n  (itemLoad)=\"itemLoad.emit($event)\"\n  (itemLoadError)=\"itemLoadError.emit($event)\"\n  (pageInfoChange)=\"pageInfoChange.emit($event)\"\n  (mediaOverlayPlayStateChange)=\"mediaOverlayPlayStateChange.emit($event)\"\n  (pageChangeCanceled)=\"pageChangeCanceled.emit($event)\"\n  (bookmarkStateChange)=\"bookmarkStateChange.emit($event)\"\n  (annotationCreated)=\"annotationCreated.emit($event)\"\n  (annotationChanged)=\"annotationChanged.emit($event)\"\n  (annotationRemoved)=\"annotationRemoved.emit($event)\"\n  (zoomScaleChange)=\"zoomScaleChange.emit($event)\"\n></bukv-pages>\n<bukv-pdf-pages\n  #pages\n  *ngIf=\"_book && _book.meta.type === BookType.PDF\"\n  [book]=\"_book\"\n  [annotations]=\"_annotations\"\n  (itemLoadStart)=\"itemLoadStart.emit($event)\"\n  (itemLoad)=\"itemLoad.emit($event)\"\n  (itemLoadError)=\"itemLoadError.emit($event)\"\n  (pageInfoChange)=\"pageInfoChange.emit($event)\"\n  (pageChangeCanceled)=\"pageChangeCanceled.emit($event)\"\n  (bookmarkStateChange)=\"bookmarkStateChange.emit($event)\"\n  (annotationCreated)=\"annotationCreated.emit($event)\"\n  (annotationChanged)=\"annotationChanged.emit($event)\"\n  (annotationRemoved)=\"annotationRemoved.emit($event)\"\n  (zoomScaleChange)=\"zoomScaleChange.emit($event)\"\n></bukv-pdf-pages>\n<bukv-doc-pages\n  #pages\n  *ngIf=\"_book && _book.meta.type === BookType.Document\"\n  [book]=\"_book\"\n  [annotations]=\"_annotations\"\n  (itemLoadStart)=\"itemLoadStart.emit($event)\"\n  (itemLoad)=\"itemLoad.emit($event)\"\n  (itemLoadError)=\"itemLoadError.emit($event)\"\n  (pageInfoChange)=\"pageInfoChange.emit($event)\"\n  (pageChangeCanceled)=\"pageChangeCanceled.emit($event)\"\n  (bookmarkStateChange)=\"bookmarkStateChange.emit($event)\"\n  (annotationCreated)=\"annotationCreated.emit($event)\"\n  (annotationChanged)=\"annotationChanged.emit($event)\"\n  (annotationRemoved)=\"annotationRemoved.emit($event)\"\n  (zoomScaleChange)=\"zoomScaleChange.emit($event)\"\n></bukv-doc-pages>\n<bukv-wiki-pages\n  #pages\n  *ngIf=\"_book && _book.meta.type === BookType.Wiki\"\n  [book]=\"_book\"\n  [annotations]=\"_annotations\"\n  (itemLoadStart)=\"itemLoadStart.emit($event)\"\n  (itemLoad)=\"itemLoad.emit($event)\"\n  (itemLoadError)=\"itemLoadError.emit($event)\"\n  (pageInfoChange)=\"pageInfoChange.emit($event)\"\n  (pageChangeCanceled)=\"pageChangeCanceled.emit($event)\"\n  (bookmarkStateChange)=\"bookmarkStateChange.emit($event)\"\n  (annotationCreated)=\"annotationCreated.emit($event)\"\n  (annotationChanged)=\"annotationChanged.emit($event)\"\n  (annotationRemoved)=\"annotationRemoved.emit($event)\"\n  (zoomScaleChange)=\"zoomScaleChange.emit($event)\"\n></bukv-wiki-pages>\n", styles: [":host{display:block;position:relative;overflow:hidden;height:100%}\n"], dependencies: [{ kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: PagesComponent, selector: "bukv-pages", inputs: ["annotations", "mediaOverlayPlaybackRate"] }, { kind: "component", type: PDFPagesComponent, selector: "bukv-pdf-pages", inputs: ["annotations"] }, { kind: "component", type: DocPagesComponent, selector: "bukv-doc-pages" }, { kind: "component", type: WikiPagesComponent, selector: "bukv-wiki-pages" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: MainComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bukv-main', providers: [
                        APIService,
                        AddressStoreService,
                        ContentsClickInterceptorService,
                        ContentsProcessorService,
                        ContentsService,
                        SettingsStoreService,
                        PDFImageLoaderService,
                    ], template: "<bukv-pages\n  #pages\n  *ngIf=\"\n    _book &&\n    (_book.meta.type === BookType.Buk || _book.meta.type === BookType.Edition)\n  \"\n  [book]=\"_book\"\n  [annotations]=\"_annotations\"\n  [mediaOverlayPlaybackRate]=\"_mediaOverlayPlaybackRate\"\n  (itemLoadStart)=\"itemLoadStart.emit($event)\"\n  (itemLoad)=\"itemLoad.emit($event)\"\n  (itemLoadError)=\"itemLoadError.emit($event)\"\n  (pageInfoChange)=\"pageInfoChange.emit($event)\"\n  (mediaOverlayPlayStateChange)=\"mediaOverlayPlayStateChange.emit($event)\"\n  (pageChangeCanceled)=\"pageChangeCanceled.emit($event)\"\n  (bookmarkStateChange)=\"bookmarkStateChange.emit($event)\"\n  (annotationCreated)=\"annotationCreated.emit($event)\"\n  (annotationChanged)=\"annotationChanged.emit($event)\"\n  (annotationRemoved)=\"annotationRemoved.emit($event)\"\n  (zoomScaleChange)=\"zoomScaleChange.emit($event)\"\n></bukv-pages>\n<bukv-pdf-pages\n  #pages\n  *ngIf=\"_book && _book.meta.type === BookType.PDF\"\n  [book]=\"_book\"\n  [annotations]=\"_annotations\"\n  (itemLoadStart)=\"itemLoadStart.emit($event)\"\n  (itemLoad)=\"itemLoad.emit($event)\"\n  (itemLoadError)=\"itemLoadError.emit($event)\"\n  (pageInfoChange)=\"pageInfoChange.emit($event)\"\n  (pageChangeCanceled)=\"pageChangeCanceled.emit($event)\"\n  (bookmarkStateChange)=\"bookmarkStateChange.emit($event)\"\n  (annotationCreated)=\"annotationCreated.emit($event)\"\n  (annotationChanged)=\"annotationChanged.emit($event)\"\n  (annotationRemoved)=\"annotationRemoved.emit($event)\"\n  (zoomScaleChange)=\"zoomScaleChange.emit($event)\"\n></bukv-pdf-pages>\n<bukv-doc-pages\n  #pages\n  *ngIf=\"_book && _book.meta.type === BookType.Document\"\n  [book]=\"_book\"\n  [annotations]=\"_annotations\"\n  (itemLoadStart)=\"itemLoadStart.emit($event)\"\n  (itemLoad)=\"itemLoad.emit($event)\"\n  (itemLoadError)=\"itemLoadError.emit($event)\"\n  (pageInfoChange)=\"pageInfoChange.emit($event)\"\n  (pageChangeCanceled)=\"pageChangeCanceled.emit($event)\"\n  (bookmarkStateChange)=\"bookmarkStateChange.emit($event)\"\n  (annotationCreated)=\"annotationCreated.emit($event)\"\n  (annotationChanged)=\"annotationChanged.emit($event)\"\n  (annotationRemoved)=\"annotationRemoved.emit($event)\"\n  (zoomScaleChange)=\"zoomScaleChange.emit($event)\"\n></bukv-doc-pages>\n<bukv-wiki-pages\n  #pages\n  *ngIf=\"_book && _book.meta.type === BookType.Wiki\"\n  [book]=\"_book\"\n  [annotations]=\"_annotations\"\n  (itemLoadStart)=\"itemLoadStart.emit($event)\"\n  (itemLoad)=\"itemLoad.emit($event)\"\n  (itemLoadError)=\"itemLoadError.emit($event)\"\n  (pageInfoChange)=\"pageInfoChange.emit($event)\"\n  (pageChangeCanceled)=\"pageChangeCanceled.emit($event)\"\n  (bookmarkStateChange)=\"bookmarkStateChange.emit($event)\"\n  (annotationCreated)=\"annotationCreated.emit($event)\"\n  (annotationChanged)=\"annotationChanged.emit($event)\"\n  (annotationRemoved)=\"annotationRemoved.emit($event)\"\n  (zoomScaleChange)=\"zoomScaleChange.emit($event)\"\n></bukv-wiki-pages>\n", styles: [":host{display:block;position:relative;overflow:hidden;height:100%}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: LibConfigService }, { type: ContentsService }, { type: AddressStoreService }, { type: SettingsStoreService }, { type: EventBusService }], propDecorators: { pagesComps: [{
                type: ViewChildren,
                args: ['pages']
            }], bookLoad: [{
                type: Output
            }], bookLoadError: [{
                type: Output
            }], addressChange: [{
                type: Output
            }], settingsChange: [{
                type: Output
            }], itemLoadStart: [{
                type: Output
            }], itemLoad: [{
                type: Output
            }], itemLoadError: [{
                type: Output
            }], pageInfoChange: [{
                type: Output
            }], bookmarkStateChange: [{
                type: Output
            }], selectionChange: [{
                type: Output
            }], highlightClick: [{
                type: Output
            }], annotationCreated: [{
                type: Output
            }], annotationChanged: [{
                type: Output
            }], annotationRemoved: [{
                type: Output
            }], mediaOverlayPlayStateChange: [{
                type: Output
            }], pageTap: [{
                type: Output
            }], pageChangeCanceled: [{
                type: Output
            }], pageTransitionEnd: [{
                type: Output
            }], zoomScaleChange: [{
                type: Output
            }] } });

class ViewerComponent {
    constructor(_element, _ngZone, _libConfigService, _storageService, _eventBus) {
        this._element = _element;
        this._ngZone = _ngZone;
        this._libConfigService = _libConfigService;
        this._storageService = _storageService;
        this._eventBus = _eventBus;
        this.tabIndex = -1;
        this.bookLoad = new EventEmitter();
        this.bookLoadError = new EventEmitter();
        this.addressChange = new EventEmitter();
        this.settingsChange = new EventEmitter();
        this.itemLoadStart = new EventEmitter();
        this.itemLoad = new EventEmitter();
        this.itemLoadError = new EventEmitter();
        this.pageInfoChange = new EventEmitter();
        this.bookmarkStateChange = new EventEmitter();
        this.selectionChange = new EventEmitter();
        this.highlightClick = new EventEmitter();
        this.annotationCreated = new EventEmitter();
        this.annotationChanged = new EventEmitter();
        this.annotationRemoved = new EventEmitter();
        this.mediaOverlayPlayStateChange = new EventEmitter();
        this.pageTap = new EventEmitter();
        this.pageChangeCanceled = new EventEmitter();
        this.pageTransitionEnd = new EventEmitter();
        this.zoomScaleChange = new EventEmitter();
        this._isInitalized = false;
        delete Hammer.defaults.cssProps.userSelect;
        [
            'init',
            'openBook',
            'openBookWithURL',
            'parseBukURL',
            'prevPage',
            'nextPage',
            'goToPrintPage',
            'getCurrentAddress',
            'getCurrentSettings',
            'getFontsCurrentlyAvailable',
            'changeTheme',
            'changeFontFace',
            'changeFontSize',
            'changeLineHeight',
            'changePagingMode',
            'setPageAnimation',
            'setMultiColumn',
            'setClickToPlayMediaOverlay',
            'updateSettings',
            'setAnnotations',
            'toggleBookmark',
            'search',
            'playMediaOverlay',
            'playMediaOverlayFromRange',
            'pauseMediaOverlay',
            'isPlayingMediaOverlay',
            'setMediaOverlayPlaybackRate',
            'canPlayMediaOverlayFromRange',
            'getHighlightsFromRange',
            'createHighlight',
            'changeHighlight',
            'removeHighlight',
            'getSelection',
            'clearSelection',
            'zoom',
            'createRangeFromElements',
            'getVisibleRanges',
            'getAddressFromRange',
            'setContentsStyles',
            'setPageGestureEnabled',
        ].forEach((methodName) => {
            this._element.nativeElement[methodName] = (...args) => {
                return this._ngZone.run(() => this[methodName].apply(this, args));
            };
        });
        fromPageChangeKeydownEvent(this._element.nativeElement).subscribe((direction) => {
            this._eventBus.emit('changePage', {
                direction: direction,
                trigger: 'keyboard',
            });
        });
    }
    set config(libConfig) {
        this.init(libConfig);
    }
    init(libConfig) {
        this._isInitalized = true;
        if (libConfig.enablePinchZoom) {
            Hammer.defaults.distanceProps = ['screenX', 'screenY'];
        }
        const savedSettings = this._storageService.loadSettings();
        return cloneObj(this._libConfigService.init(Object.assign({ initialSettings: savedSettings }, libConfig)));
    }
    get _mainComp() {
        if (!this.__mainComp) {
            throw new Error('viewer not initialized');
        }
        return this.__mainComp;
    }
    openBook(bid, iid, anchor, query) {
        this._mainComp.openBook(bid, iid, anchor, query);
    }
    openBookWithURL(url) {
        this._mainComp.openBookWithURL(url);
    }
    parseBukURL(url) {
        return parseBukURL(url);
    }
    prevPage() {
        this._mainComp.prevPage();
    }
    nextPage() {
        this._mainComp.nextPage();
    }
    goToPrintPage(page) {
        this._mainComp.goToPrintPage(page);
    }
    getCurrentSettings() {
        return this._mainComp.getCurrentSettings();
    }
    getCurrentAddress() {
        return this._mainComp.getCurrentAddress();
    }
    getFontsCurrentlyAvailable() {
        return this._mainComp.getFontsCurrentlyAvailable();
    }
    /** @deprecated */
    changeTheme(theme) {
        this._mainComp.changeTheme(theme);
    }
    /** @deprecated */
    changeFontSize(value, isAbsolute) {
        this._mainComp.changeFontSize(value, isAbsolute);
    }
    /** @deprecated */
    changeFontFace(fontFace) {
        this._mainComp.changeFontFace(fontFace);
    }
    /** @deprecated */
    changeLineHeight(value, isAbsolute) {
        this._mainComp.changeLineHeight(value, isAbsolute);
    }
    /** @deprecated */
    changePagingMode(pagingMode) {
        this._mainComp.changePagingMode(pagingMode);
    }
    /** @deprecated */
    setPageAnimation(isActive) {
        this._mainComp.setPageAnimation(isActive);
    }
    /** @deprecated */
    setMultiColumn(isActive) {
        this._mainComp.setMultiColumn(isActive);
    }
    /** @deprecated */
    setClickToPlayMediaOverlay(isActive) {
        this._mainComp.setClickToPlayMediaOverlay(isActive);
    }
    updateSettings(key, value) {
        this._mainComp.updateSettings(key, value);
    }
    setContentsStyles(styles) {
        this._mainComp.setContentsStyles(styles);
    }
    setPageGestureEnabled(enabled) {
        this._mainComp.setPageGestureEnabled(enabled);
    }
    setAnnotations(annotations) {
        this._mainComp.setAnnotations(annotations);
    }
    toggleBookmark() {
        this._mainComp.toggleBookmark();
    }
    search(keyword, callback) {
        return this._mainComp.search(keyword, callback);
    }
    playMediaOverlay(prevOrNext) {
        this._mainComp.playMediaOverlay(prevOrNext);
    }
    playMediaOverlayFromRange(range) {
        this._mainComp.playMediaOverlayFromRange(range);
    }
    pauseMediaOverlay() {
        this._mainComp.pauseMediaOverlay();
    }
    isPlayingMediaOverlay() {
        return this._mainComp.isPlayingMediaOverlay();
    }
    setMediaOverlayPlaybackRate(value) {
        return this._mainComp.setMediaOverlayPlaybackRate(value);
    }
    canPlayMediaOverlayFromRange(range) {
        return this._mainComp.canPlayMediaOverlayFromRange(range);
    }
    getHighlightsFromRange(range) {
        return this._mainComp.getHighlightsFromRange(range);
    }
    createHighlight(range, styleClass, options) {
        return this._mainComp.createHighlight(range, styleClass, options);
    }
    changeHighlight(rangeURL, currStyleClass, newStyleClass, options) {
        return this._mainComp.changeHighlight(rangeURL, currStyleClass, newStyleClass, options);
    }
    removeHighlight(rangeURL, styleClass, options) {
        return this._mainComp.removeHighlight(rangeURL, styleClass, options);
    }
    getSelection() {
        return this._mainComp.getSelection();
    }
    clearSelection() {
        return this._mainComp.clearSelection();
    }
    zoom(scale) {
        return this._mainComp.zoom(scale);
    }
    createRangeFromElements(startId, endId, iid) {
        return this._mainComp.createRangeFromElements(startId, endId, iid);
    }
    getVisibleRanges() {
        return this._mainComp.getVisibleRanges();
    }
    getAddressFromRange(range) {
        return this._mainComp.getAddressFromRange(range);
    }
    _onSettingsChange(event) {
        this._storageService.saveSettings(event.settings);
        this.settingsChange.emit(event);
    }
    _focus() {
        this._element.nativeElement.focus({
            preventScroll: true,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: ViewerComponent, deps: [{ token: i0.ElementRef }, { token: i0.NgZone }, { token: LibConfigService }, { token: StorageService }, { token: EventBusService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.3", type: ViewerComponent, selector: "bukv-viewer, buk-viewer", inputs: { config: "config" }, outputs: { bookLoad: "bookLoad", bookLoadError: "bookLoadError", addressChange: "addressChange", settingsChange: "settingsChange", itemLoadStart: "itemLoadStart", itemLoad: "itemLoad", itemLoadError: "itemLoadError", pageInfoChange: "pageInfoChange", bookmarkStateChange: "bookmarkStateChange", selectionChange: "selectionChange", highlightClick: "highlightClick", annotationCreated: "annotationCreated", annotationChanged: "annotationChanged", annotationRemoved: "annotationRemoved", mediaOverlayPlayStateChange: "mediaOverlayPlayStateChange", pageTap: "pageTap", pageChangeCanceled: "pageChangeCanceled", pageTransitionEnd: "pageTransitionEnd", zoomScaleChange: "zoomScaleChange" }, host: { properties: { "attr.tabindex": "this.tabIndex" } }, providers: [EventBusService, LibConfigService, StorageService], viewQueries: [{ propertyName: "__mainComp", first: true, predicate: MainComponent, descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"_isInitalized\">\n  <bukv-main\n    (bookLoad)=\"bookLoad.emit($event)\"\n    (bookLoadError)=\"bookLoadError.emit($event)\"\n    (addressChange)=\"addressChange.emit($event)\"\n    (settingsChange)=\"_onSettingsChange($event)\"\n    (itemLoadStart)=\"itemLoadStart.emit($event)\"\n    (itemLoad)=\"itemLoad.emit($event); _focus()\"\n    (itemLoadError)=\"itemLoadError.emit($event)\"\n    (pageInfoChange)=\"pageInfoChange.emit($event)\"\n    (bookmarkStateChange)=\"bookmarkStateChange.emit($event)\"\n    (annotationCreated)=\"annotationCreated.emit($event)\"\n    (annotationChanged)=\"annotationChanged.emit($event)\"\n    (annotationRemoved)=\"annotationRemoved.emit($event)\"\n    (mediaOverlayPlayStateChange)=\"mediaOverlayPlayStateChange.emit($event)\"\n    (pageTap)=\"pageTap.emit($event)\"\n    (pageChangeCanceled)=\"pageChangeCanceled.emit($event)\"\n    (selectionChange)=\"selectionChange.emit($event)\"\n    (highlightClick)=\"highlightClick.emit($event)\"\n    (zoomScaleChange)=\"zoomScaleChange.emit($event)\"\n    (pageTransitionEnd)=\"pageTransitionEnd.emit($event)\"\n  ></bukv-main>\n</ng-container>\n", styles: [":host{display:block;-webkit-tap-highlight-color:rgba(0,0,0,0)}:host ::ng-deep *{box-sizing:border-box}:host:focus{outline:none}::ng-deep :root{--bukv-contents-bg-color-light: #fff;--bukv-contents-bg-color-sepia: #f2efec;--bukv-contents-bg-color-dark: #212121}@media (max-width: 480px){::ng-deep :root{--bukv-contents-padding-top: 40px;--bukv-contents-padding-bottom: 40px}}@media (min-width: 481px){::ng-deep :root{--bukv-contents-padding-top: 60px;--bukv-contents-padding-bottom: 60px}}\n"], dependencies: [{ kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: MainComponent, selector: "bukv-main", outputs: ["bookLoad", "bookLoadError", "addressChange", "settingsChange", "itemLoadStart", "itemLoad", "itemLoadError", "pageInfoChange", "bookmarkStateChange", "selectionChange", "highlightClick", "annotationCreated", "annotationChanged", "annotationRemoved", "mediaOverlayPlayStateChange", "pageTap", "pageChangeCanceled", "pageTransitionEnd", "zoomScaleChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: ViewerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bukv-viewer, buk-viewer', providers: [EventBusService, LibConfigService, StorageService], template: "<ng-container *ngIf=\"_isInitalized\">\n  <bukv-main\n    (bookLoad)=\"bookLoad.emit($event)\"\n    (bookLoadError)=\"bookLoadError.emit($event)\"\n    (addressChange)=\"addressChange.emit($event)\"\n    (settingsChange)=\"_onSettingsChange($event)\"\n    (itemLoadStart)=\"itemLoadStart.emit($event)\"\n    (itemLoad)=\"itemLoad.emit($event); _focus()\"\n    (itemLoadError)=\"itemLoadError.emit($event)\"\n    (pageInfoChange)=\"pageInfoChange.emit($event)\"\n    (bookmarkStateChange)=\"bookmarkStateChange.emit($event)\"\n    (annotationCreated)=\"annotationCreated.emit($event)\"\n    (annotationChanged)=\"annotationChanged.emit($event)\"\n    (annotationRemoved)=\"annotationRemoved.emit($event)\"\n    (mediaOverlayPlayStateChange)=\"mediaOverlayPlayStateChange.emit($event)\"\n    (pageTap)=\"pageTap.emit($event)\"\n    (pageChangeCanceled)=\"pageChangeCanceled.emit($event)\"\n    (selectionChange)=\"selectionChange.emit($event)\"\n    (highlightClick)=\"highlightClick.emit($event)\"\n    (zoomScaleChange)=\"zoomScaleChange.emit($event)\"\n    (pageTransitionEnd)=\"pageTransitionEnd.emit($event)\"\n  ></bukv-main>\n</ng-container>\n", styles: [":host{display:block;-webkit-tap-highlight-color:rgba(0,0,0,0)}:host ::ng-deep *{box-sizing:border-box}:host:focus{outline:none}::ng-deep :root{--bukv-contents-bg-color-light: #fff;--bukv-contents-bg-color-sepia: #f2efec;--bukv-contents-bg-color-dark: #212121}@media (max-width: 480px){::ng-deep :root{--bukv-contents-padding-top: 40px;--bukv-contents-padding-bottom: 40px}}@media (min-width: 481px){::ng-deep :root{--bukv-contents-padding-top: 60px;--bukv-contents-padding-bottom: 60px}}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.NgZone }, { type: LibConfigService }, { type: StorageService }, { type: EventBusService }], propDecorators: { tabIndex: [{
                type: HostBinding,
                args: ['attr.tabindex']
            }], __mainComp: [{
                type: ViewChild,
                args: [MainComponent]
            }], bookLoad: [{
                type: Output
            }], bookLoadError: [{
                type: Output
            }], addressChange: [{
                type: Output
            }], settingsChange: [{
                type: Output
            }], itemLoadStart: [{
                type: Output
            }], itemLoad: [{
                type: Output
            }], itemLoadError: [{
                type: Output
            }], pageInfoChange: [{
                type: Output
            }], bookmarkStateChange: [{
                type: Output
            }], selectionChange: [{
                type: Output
            }], highlightClick: [{
                type: Output
            }], annotationCreated: [{
                type: Output
            }], annotationChanged: [{
                type: Output
            }], annotationRemoved: [{
                type: Output
            }], mediaOverlayPlayStateChange: [{
                type: Output
            }], pageTap: [{
                type: Output
            }], pageChangeCanceled: [{
                type: Output
            }], pageTransitionEnd: [{
                type: Output
            }], zoomScaleChange: [{
                type: Output
            }], config: [{
                type: Input
            }] } });

class ViewerModule {
    static forRoot(config) {
        const providers = [
            {
                provide: LIB_CONFIG_INTERNAL_ENABLE_EPUB_OBFUSCATION,
                useValue: !!config?.enableEpubObfuscation,
            },
        ];
        if (config?.customAPIService) {
            providers.push(config.customAPIService);
        }
        if (config?.customContentsService) {
            providers.push(config.customContentsService);
        }
        if (config?.pdfOverlayViewProviderService) {
            providers.push(config.pdfOverlayViewProviderService);
        }
        return {
            ngModule: ViewerModule,
            providers: providers,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: ViewerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.3", ngImport: i0, type: ViewerModule, declarations: [ViewerComponent,
            MainComponent,
            FrameComponent,
            PageComponent,
            PagesComponent,
            PDFPagesComponent,
            PDFPageComponent,
            PDFImageComponent,
            ScrollZoomComponent,
            DocPagesComponent,
            WikiPagesComponent,
            LinkLayerComponent,
            SafePipe], imports: [CommonModule], exports: [ViewerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: ViewerModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.3", ngImport: i0, type: ViewerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ViewerComponent,
                        MainComponent,
                        FrameComponent,
                        PageComponent,
                        PagesComponent,
                        PDFPagesComponent,
                        PDFPageComponent,
                        PDFImageComponent,
                        ScrollZoomComponent,
                        DocPagesComponent,
                        WikiPagesComponent,
                        LinkLayerComponent,
                        SafePipe,
                    ],
                    imports: [CommonModule],
                    exports: [ViewerComponent],
                }]
        }] });

/*
 * Public API Surface of viewer
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Address, AnnotationType, Book, BookLoadErrorCode, BookType, Direction, ItemLoadErrorCode, PageChangeCancelCode, PagingMode, Theme, ViewerAPIService, ViewerComponent, ViewerContentsService, ViewerModule, ViewerPDFOverlayViewProviderService, WikiAPIService, createBukURL, isBukAnchor, isDocumentBid, isIPAddressBid, isWikiBid, isWiktionaryBid, parseBukURL, renderWikiBukJSON };
